import React, { Component as Component$1, PureComponent } from 'react';
import ReactDOM, { render } from 'react-dom';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

ArrowDown.displayName = "ArrowDown";
ArrowDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var ArrowDownTrimmed = function ArrowDownTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 10l5 5 5-5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10v24H0V0z",
    fill: "none"
  }));
};

ArrowDownTrimmed.displayName = "ArrowDownTrimmed";
ArrowDownTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 24"
};

var ArrowUp = function ArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 14l5-5 5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

ArrowUp.displayName = "ArrowUp";
ArrowUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var ArrowUpTrimmed = function ArrowUpTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 14l5-5 5 5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10v24H0V0z",
    fill: "none"
  }));
};

ArrowUpTrimmed.displayName = "ArrowUpTrimmed";
ArrowUpTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 24"
};

var Asset = function Asset(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.14 11.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
  })));
};

Asset.displayName = "Asset";
Asset.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var AssetTrimmed = function AssetTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 5v14H2V5h14m0-2H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 11.9l-3 3.9L6 13.1 3 17h12l-3.9-5.1z"
  })));
};

AssetTrimmed.displayName = "AssetTrimmed";
AssetTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 24"
};

var ChatBubble = function ChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

ChatBubble.displayName = "ChatBubble";
ChatBubble.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChatBubbleTrimmed = function ChatBubbleTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.5h-12C.7 1.5 0 2.2 0 3v13.5l3-3h10.5c.8 0 1.5-.7 1.5-1.5V3c0-.8-.7-1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }));
};

ChatBubbleTrimmed.displayName = "ChatBubbleTrimmed";
ChatBubbleTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var CheckCircle = function CheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }));
};

CheckCircle.displayName = "CheckCircle";
CheckCircle.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var CheckCircleTrimmed = function CheckCircleTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5C3.4 1.5 0 4.9 0 9s3.4 7.5 7.5 7.5S15 13.1 15 9s-3.4-7.5-7.5-7.5zM6 12.8L2.2 9l1.1-1.1L6 10.6l5.7-5.7L12.8 6 6 12.8z"
  }));
};

CheckCircleTrimmed.displayName = "CheckCircleTrimmed";
CheckCircleTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var ChevronDown = function ChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.75h24v24H0z",
    fill: "none"
  }));
};

ChevronDown.displayName = "ChevronDown";
ChevronDown.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChevronDownTrimmed = function ChevronDownTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 5.9l3.4 3.4 3.4-3.4 1.1 1-4.5 4.5L0 6.9l1.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9v18H0V0z",
    fill: "none"
  }));
};

ChevronDownTrimmed.displayName = "ChevronDownTrimmed";
ChevronDownTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 18"
};

var ChevronLeft = function ChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

ChevronLeft.displayName = "ChevronLeft";
ChevronLeft.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChevronLeftTrimmed = function ChevronLeftTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.6 5.6L4.5 4.5 0 9l4.5 4.5 1.1-1.1L2.1 9l3.5-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5.6v18H0V0z",
    fill: "none"
  }));
};

ChevronLeftTrimmed.displayName = "ChevronLeftTrimmed";
ChevronLeftTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 5.6 18"
};

var ChevronRight = function ChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

ChevronRight.displayName = "ChevronRight";
ChevronRight.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChevronRightTrimmed = function ChevronRightTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 4.5L0 5.6 3.4 9 0 12.4l1.1 1.1L5.6 9 1.1 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h5.6v18H0V0z",
    fill: "none"
  }));
};

ChevronRightTrimmed.displayName = "ChevronRightTrimmed";
ChevronRightTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 5.6 18"
};

var ChevronUp = function ChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

ChevronUp.displayName = "ChevronUp";
ChevronUp.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChevronUpTrimmed = function ChevronUpTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 11.6l3.4-3.4 3.4 3.4L9 10.5 4.5 6 0 10.5l1.1 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9v18H0V0z",
    fill: "none"
  }));
};

ChevronUpTrimmed.displayName = "ChevronUpTrimmed";
ChevronUpTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 18"
};

var Close = function Close(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Close.displayName = "Close";
Close.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var CloseTrimmed = function CloseTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 6.4L12.6 5 7 10.6 1.4 5 0 6.4 5.6 12 0 17.6 1.4 19 7 13.4l5.6 5.6 1.4-1.4L8.4 12 14 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v24H0V0z",
    fill: "none"
  }));
};

CloseTrimmed.displayName = "CloseTrimmed";
CloseTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 24"
};

var Code = function Code(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
  }));
};

Code.displayName = "Code";
Code.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24"
};

var CodeTrimmed = function CodeTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.5L2.1 9l3.4-3.4-1-1.1L0 9l4.5 4.5 1-1zm3.9 0L12.9 9 9.4 5.6l1.1-1.1L15 9l-4.5 4.5s-1-1-1.1-1z"
  }));
};

CodeTrimmed.displayName = "CodeTrimmed";
CodeTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var Copy = function Copy(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
  }));
};

Copy.displayName = "Copy";
Copy.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var CopyTrimmed = function CopyTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.2v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5.8h-9C.7.8 0 1.4 0 2.2v10.5h1.5V2.2h9V.8zm2.3 3H4.5c-.8 0-1.5.6-1.5 1.4v10.5c0 .8.7 1.5 1.5 1.5h8.2c.8 0 1.5-.7 1.5-1.5V5.2c0-.8-.6-1.4-1.4-1.4zm0 12H4.5V5.2h8.2v10.6z"
  }));
};

CopyTrimmed.displayName = "CopyTrimmed";
CopyTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.2 18"
};

var Cycle = function Cycle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Cycle.displayName = "Cycle";
Cycle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
};

var CycleTrimmed = function CycleTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 4V1L4 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 16 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L1.24 7.74A7.93 7.93 0 0 0 0 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z",
    fillRule: "nonzero"
  }));
};

CycleTrimmed.displayName = "CycleTrimmed";
CycleTrimmed.defaultProps = {
  viewBox: "0 0 16 24",
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: "1.414"
};

var Delete = function Delete(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Delete.displayName = "Delete";
Delete.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var DeleteTrimmed = function DeleteTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H1v12zM14 4h-3.5l-1-1h-5l-1 1H0v2h14V4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-5 0h24v24H-5V0z"
  }));
};

DeleteTrimmed.displayName = "DeleteTrimmed";
DeleteTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  viewBox: "0 0 14 24"
};

var Download = function Download(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Download.displayName = "Download";
Download.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var DownloadTrimmed = function DownloadTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.8h-3V2.2H3v4.5H0L5.2 12l5.3-5.2zM0 13.5V15h10.5v-1.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10.5v18H0V0z",
    fill: "none"
  }));
};

DownloadTrimmed.displayName = "DownloadTrimmed";
DownloadTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10.5 18"
};

var Drag = function Drag(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }));
};

Drag.displayName = "Drag";
Drag.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var DragTrimmed = function DragTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 4 0 4.9 0 6s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }));
};

DragTrimmed.displayName = "DragTrimmed";
DragTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 24"
};

var Edit = function Edit(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Edit.displayName = "Edit";
Edit.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var EditTrimmed = function EditTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.9v2.8h2.8l8.3-8.3-2.8-2.8L0 12.9zm13.3-7.6c.3-.3.3-.8 0-1.1l-1.8-1.8c-.3-.3-.8-.3-1.1 0L9.1 3.8l2.8 2.8c0 .1 1.4-1.3 1.4-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.5v18H0V0z",
    fill: "none"
  }));
};

EditTrimmed.displayName = "EditTrimmed";
EditTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.5 18"
};

var EmbeddedEntryBlock = function EmbeddedEntryBlock(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21 15H3c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1h18c.5 0 1 .4 1 1v4c0 .6-.5 1-1 1zM19.5 7h-15c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h15c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zM19.5 19h-15c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h15c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zM17.6 23H6.4c-.2 0-.4-.2-.4-.4v-1.1c0-.3.2-.5.4-.5h11.1c.2 0 .4.2.4.4v1.1c.1.3-.1.5-.3.5zM17.6 3H6.4c-.2 0-.4-.2-.4-.4V1.4c0-.2.2-.4.4-.4h11.1c.3 0 .5.2.5.4v1.1c0 .3-.2.5-.4.5z"
  }));
};

EmbeddedEntryBlock.displayName = "EmbeddedEntryBlock";
EmbeddedEntryBlock.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var EmbeddedEntryBlockTrimmed = function EmbeddedEntryBlockTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 15H1c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1h18c.5 0 1 .4 1 1v4c0 .6-.5 1-1 1zM17.5 7h-15c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h15c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zM17.5 19h-15c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h15c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zM15.6 23H4.4c-.2 0-.4-.2-.4-.4v-1.1c0-.3.2-.5.4-.5h11.1c.2 0 .4.2.4.4v1.1c.1.3-.1.5-.3.5zM15.6 3H4.4c-.2 0-.4-.2-.4-.4V1.4c0-.2.2-.4.4-.4h11.1c.3 0 .5.2.5.4v1.1c0 .3-.2.5-.4.5z"
  }));
};

EmbeddedEntryBlockTrimmed.displayName = "EmbeddedEntryBlockTrimmed";
EmbeddedEntryBlockTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "24",
  viewBox: "0 0 20 24"
};

var EmbeddedEntryInline = function EmbeddedEntryInline(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.4 17H6.6c-.3 0-.6-.3-.6-.6v-2.8c0-.3.3-.6.6-.6h6.8c.3 0 .6.3.6.6v2.8c0 .3-.3.6-.6.6zM22.5 11h-21c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h20.9c.4 0 .6.2.6.5v.9c0 .4-.2.6-.5.6zM4.5 16h-3c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zM12.6 21H1.4c-.2 0-.4-.2-.4-.4v-1.1c0-.3.2-.5.4-.5h11.1c.2 0 .4.2.4.4v1.1c.1.3-.1.5-.3.5zM15.6 6H1.4c-.2 0-.4-.2-.4-.4V4.4c0-.2.2-.4.4-.4h14.1c.3 0 .5.2.5.4v1.1c0 .3-.2.5-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16h-3c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zM19.5 16h-4c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h4c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5z"
  }));
};

EmbeddedEntryInline.displayName = "EmbeddedEntryInline";
EmbeddedEntryInline.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var EmbeddedEntryInlineTrimmed = function EmbeddedEntryInlineTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.4 17H5.6c-.3 0-.6-.3-.6-.6v-2.8c0-.3.3-.6.6-.6h6.8c.3 0 .6.3.6.6v2.8c0 .3-.3.6-.6.6zM21.5 11H.5c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h20.9c.4 0 .6.2.6.5v.9c0 .4-.2.6-.5.6zM3.5 16h-3c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zM11.6 21H.4c-.2 0-.4-.2-.4-.4v-1.1c0-.3.2-.5.4-.5h11.1c.2 0 .4.2.4.4v1.1c.1.3-.1.5-.3.5zM14.6 6H.4C.2 6 0 5.8 0 5.6V4.4c0-.2.2-.4.4-.4h14.1c.3 0 .5.2.5.4v1.1c0 .3-.2.5-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 16h-3c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zM18.5 16h-4c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h4c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5z"
  }));
};

EmbeddedEntryInlineTrimmed.displayName = "EmbeddedEntryInlineTrimmed";
EmbeddedEntryInlineTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "24",
  viewBox: "0 0 22 24"
};

var Entry = function Entry(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16h8v2H8zM8 12h8v2H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
  }));
};

Entry.displayName = "Entry";
Entry.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var EntryTrimmed = function EntryTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16h8v2H4zM4 12h8v2H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2H2C.9 2 0 2.9 0 4v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H2V4h7v5h5v11z"
  }));
};

EntryTrimmed.displayName = "EntryTrimmed";
EntryTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 24"
};

var ErrorCircle = function ErrorCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
  }));
};

ErrorCircle.displayName = "ErrorCircle";
ErrorCircle.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var ErrorCircleTrimmed = function ErrorCircleTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5C3.4 1.5 0 4.9 0 9s3.4 7.5 7.5 7.5S15 13.1 15 9s-3.4-7.5-7.5-7.5zm.7 11.3H6.8v-1.5h1.5v1.5zm0-3H6.8V5.2h1.5v4.6z"
  }));
};

ErrorCircleTrimmed.displayName = "ErrorCircleTrimmed";
ErrorCircleTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var ExternalLink = function ExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

ExternalLink.displayName = "ExternalLink";
ExternalLink.defaultProps = {
  height: "18",
  width: "18",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ExternalLinkTrimmed = function ExternalLinkTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.2H1.5V3.8h5.2V2.2H1.5C.7 2.2 0 2.9 0 3.8v10.5c0 .8.7 1.5 1.5 1.5H12c.8 0 1.5-.7 1.5-1.5V9H12v5.2zm-3.8-12v1.5h2.7l-7.4 7.4 1.1 1.1L12 4.8v2.7h1.5V2.2H8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.5v18H0V0z",
    fill: "none"
  }));
};

ExternalLinkTrimmed.displayName = "ExternalLinkTrimmed";
ExternalLinkTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.5 18"
};

var FaceHappy = function FaceHappy(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

FaceHappy.displayName = "FaceHappy";
FaceHappy.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var FaceHappyTrimmed = function FaceHappyTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5C3.4 1.5 0 4.9 0 9s3.4 7.5 7.5 7.5S15 13.1 15 9s-3.4-7.5-7.5-7.5zm0 13.5c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm.7-7.5l.8.7.8-.8.8.8.8-.8-1.6-1.5-1.6 1.6zm-3 0l.8.7.8-.8-1.6-1.5-1.6 1.6.8.8.8-.8zm2.3 5.6c1.7 0 3.2-1.1 3.8-2.6H3.7c.6 1.5 2.1 2.6 3.8 2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }));
};

FaceHappyTrimmed.displayName = "FaceHappyTrimmed";
FaceHappyTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var Filter = function Filter(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Filter.displayName = "Filter";
Filter.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var FilterTrimmed = function FilterTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.2 13.5h3V12h-3v1.5zM0 4.5V6h13.5V4.5H0zm2.2 5.3h9V8.2h-9v1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.5v18H0V0z",
    fill: "none"
  }));
};

FilterTrimmed.displayName = "FilterTrimmed";
FilterTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.5 18"
};

var Folder = function Folder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Folder.displayName = "Folder";
Folder.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var FolderCreate = function FolderCreate(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"
  }));
};

FolderCreate.displayName = "FolderCreate";
FolderCreate.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var FolderCreateTrimmed = function FolderCreateTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.5h-6L6 3H1.5C.7 3 0 3.7 0 4.5v9c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5V6c0-.8-.7-1.5-1.5-1.5zm-.7 6h-2.2v2.2H9v-2.2H6.8V9H9V6.8h1.5V9h2.2v1.5z"
  }));
};

FolderCreateTrimmed.displayName = "FolderCreateTrimmed";
FolderCreateTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var FolderOpen = function FolderOpen(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
  }));
};

FolderOpen.displayName = "FolderOpen";
FolderOpen.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var FolderOpenTrimmed = function FolderOpenTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.5h-6L6 3H1.5C.7 3 0 3.7 0 4.5v9c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5V6c0-.8-.7-1.5-1.5-1.5zm0 9h-12V6h12v7.5z"
  }));
};

FolderOpenTrimmed.displayName = "FolderOpenTrimmed";
FolderOpenTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var FolderTrimmed = function FolderTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 3H1.5C.7 3 0 3.7 0 4.5v9c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5V6c0-.8-.7-1.5-1.5-1.5h-6L6 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }));
};

FolderTrimmed.displayName = "FolderTrimmed";
FolderTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var FormatBold = function FormatBold(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

FormatBold.displayName = "FormatBold";
FormatBold.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var FormatBoldTrimmed = function FormatBoldTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.6 10.8c1-.7 1.6-1.8 1.6-2.8 0-2.3-1.8-4-4-4H0v14h7c2.1 0 3.7-1.7 3.7-3.8.1-1.5-.8-2.8-2.1-3.4zM3 6.5h3c.8 0 1.5.7 1.5 1.5S6.8 9.5 6 9.5H3v-3zm3.5 9H3v-3h3.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10.8v24H0V0z",
    fill: "none"
  }));
};

FormatBoldTrimmed.displayName = "FormatBoldTrimmed";
FormatBoldTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10.8 24"
};

var FormatItalic = function FormatItalic(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
  }));
};

FormatItalic.displayName = "FormatItalic";
FormatItalic.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var FormatItalicTrimmed = function FormatItalicTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v3h2.2l-3.4 8H0v3h8v-3H5.8l3.4-8H12V4H4z"
  }));
};

FormatItalicTrimmed.displayName = "FormatItalicTrimmed";
FormatItalicTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 24"
};

var FormatUnderlined = function FormatUnderlined(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
  }));
};

FormatUnderlined.displayName = "FormatUnderlined";
FormatUnderlined.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var FormatUnderlinedTrimmed = function FormatUnderlinedTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17c3.3 0 6-2.7 6-6V3h-2.5v8c0 1.9-1.6 3.5-3.5 3.5S3.5 12.9 3.5 11V3H1v8c0 3.3 2.7 6 6 6zm-7 2v2h14v-2H0z"
  }));
};

FormatUnderlinedTrimmed.displayName = "FormatUnderlinedTrimmed";
FormatUnderlinedTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 24"
};

var Heading = function Heading(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8 5v5.5H9.2V5H6.4v14h2.8v-6.1h5.6V19h2.8V5z"
  }));
};

Heading.displayName = "Heading";
Heading.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24"
};

var HeadingOne = function HeadingOne(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 5v5.5H6.1V5H3.3v14h2.8v-6.1h5.6V19h2.8V5zM18.6 19v-6.3L17.1 14l-1-1.4 2.8-2.1h1.8V19h-2.1z"
  }));
};

HeadingOne.displayName = "HeadingOne";
HeadingOne.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24"
};

var HeadingOneTrimmed = function HeadingOneTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3 3.8v4.1H2.1V3.8H0V14.2h2.1V9.7h4.2v4.5h2.1V3.8zM11.5 14.2V9.5l-1.1 1-.8-1 2.1-1.6H13v6.4h-1.5z"
  }));
};

HeadingOneTrimmed.displayName = "HeadingOneTrimmed";
HeadingOneTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 18"
};

var HeadingTrimmed = function HeadingTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8.4v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3 3.8v4.1H2.1V3.8H0V14.2h2.1V9.7h4.2v4.5h2.1V3.8z"
  }));
};

HeadingTrimmed.displayName = "HeadingTrimmed";
HeadingTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8.4 18"
};

var HeadingTwo = function HeadingTwo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 5v5.5H5.3V5H2.4v14h2.9v-6.1h5.5V19h2.9V5zM15.4 19v-1.7l3.3-3c.2-.2.4-.4.5-.6.1-.2.2-.4.2-.7 0-.3-.1-.6-.3-.7-.2-.2-.4-.3-.8-.3-.3 0-.6.1-.8.4-.2.2-.3.5-.4.9l-1.9-.3c0-.4.2-.8.4-1.2.2-.3.4-.6.7-.9.3-.2.6-.4 1-.5s.8-.2 1.2-.2c.4 0 .8.1 1.1.2.4.1.7.3 1 .5.3.2.5.5.7.8.2.3.3.7.3 1.2 0 .3 0 .6-.1.8-.1.2-.2.5-.3.7-.1.2-.3.4-.5.6-.2.2-.4.4-.6.5l-2 1.8h3.5V19h-6.2z"
  }));
};

HeadingTwo.displayName = "HeadingTwo";
HeadingTwo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24"
};

var HeadingTwoTrimmed = function HeadingTwoTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.4v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3 3.8v4.1H2.2V3.8H0V14.2h2.2V9.7h4.1v4.5h2.2V3.8zM9.8 14.2V13l2.5-2.2c.2-.1.3-.3.4-.4.1-.2.2-.3.2-.5s-.1-.4-.2-.5c-.3-.3-.5-.4-.8-.4-.2 0-.5.1-.6.3-.1.1-.2.4-.3.7l-1.4-.2c0-.3.2-.6.3-.9.1-.2.3-.5.5-.7.2-.1.5-.3.8-.4.3-.1.6-.1.9-.1.3 0 .6.1.8.1.3.1.5.2.8.4.2.2.4.4.5.6s.2.5.2.9c0 .2 0 .5-.1.6-.1.1-.2.4-.2.5-.1.2-.2.3-.4.5-.2.1-.3.3-.4.4L11.8 13h2.6v1.3H9.8z"
  }));
};

HeadingTwoTrimmed.displayName = "HeadingTwoTrimmed";
HeadingTwoTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.4 18"
};

var HelpCircle = function HelpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
  }));
};

HelpCircle.displayName = "HelpCircle";
HelpCircle.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var HelpCircleTrimmed = function HelpCircleTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5C3.4 1.5 0 4.9 0 9s3.4 7.5 7.5 7.5S15 13.1 15 9s-3.4-7.5-7.5-7.5zm.7 12.7H6.8v-1.5h1.5v1.5zm1.6-5.8l-.7.7c-.5.5-.9 1-.9 2.1H6.8v-.4c0-.8.3-1.6.9-2.1l.9-.9c.2-.3.4-.6.4-1 0-.8-.7-1.5-1.5-1.5S6 5.9 6 6.8H4.5c0-1.7 1.3-3 3-3s3 1.3 3 3c0 .6-.3 1.2-.7 1.6z"
  }));
};

HelpCircleTrimmed.displayName = "HelpCircleTrimmed";
HelpCircleTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var HorizontalRule = function HorizontalRule(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 11.2h16.8v1.7H3.6z"
  }));
};

HorizontalRule.displayName = "HorizontalRule";
HorizontalRule.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24"
};

var HorizontalRuleTrimmed = function HorizontalRuleTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12.6v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.4h12.6v1.3H0z"
  }));
};

HorizontalRuleTrimmed.displayName = "HorizontalRuleTrimmed";
HorizontalRuleTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12.6 18"
};

var InfoCircle = function InfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
  }));
};

InfoCircle.displayName = "InfoCircle";
InfoCircle.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var InfoCircleTrimmed = function InfoCircleTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5C3.4 1.5 0 4.9 0 9s3.4 7.5 7.5 7.5S15 13.1 15 9s-3.4-7.5-7.5-7.5zm.7 11.3H6.8V8.2h1.5v4.6zm0-6H6.8V5.2h1.5v1.6z"
  }));
};

InfoCircleTrimmed.displayName = "InfoCircleTrimmed";
InfoCircleTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var Link = function Link(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
  }));
};

Link.displayName = "Link";
Link.defaultProps = {
  height: "18",
  width: "18",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LinkTrimmed = function LinkTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4 9c0-1.3 1-2.3 2.3-2.3h3V5.2h-3C1.7 5.2 0 6.9 0 9s1.7 3.8 3.8 3.8h3v-1.4h-3c-1.3-.1-2.4-1.1-2.4-2.4zm3.1.8h6V8.2h-6v1.6zm6.7-4.6h-3v1.4h3c1.3 0 2.3 1 2.3 2.3s-1 2.3-2.3 2.3h-3v1.4h3c2.1 0 3.8-1.7 3.8-3.8s-1.7-3.6-3.8-3.6z"
  }));
};

LinkTrimmed.displayName = "LinkTrimmed";
LinkTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var ListBulleted = function ListBulleted(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
};

ListBulleted.displayName = "ListBulleted";
ListBulleted.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24"
};

var ListBulletedTrimmed = function ListBulletedTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.1 7.9C.5 7.9 0 8.4 0 9s.5 1.1 1.1 1.1S2.2 9.6 2.2 9s-.5-1.1-1.1-1.1zm0-4.5C.5 3.4 0 3.9 0 4.5s.5 1.1 1.1 1.1 1.1-.5 1.1-1.1-.5-1.1-1.1-1.1zm0 9c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1 1.1-.5 1.1-1.1-.5-1.1-1.1-1.1zm2.3 1.8h10.5v-1.5H3.4v1.5zm0-4.4h10.5V8.2H3.4v1.6zm0-6v1.5h10.5V3.8H3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.9v18H0V0z",
    fill: "none"
  }));
};

ListBulletedTrimmed.displayName = "ListBulletedTrimmed";
ListBulletedTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.9 18"
};

var ListNumbered = function ListNumbered(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

ListNumbered.displayName = "ListNumbered";
ListNumbered.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24"
};

var ListNumberedTrimmed = function ListNumberedTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8h1.5v.4H.8v.8h.8v.4H0v.6h2.2v-3H0v.8zM.8 6h.8V3H0v.8h.8V6zM0 8.2h1.3L0 9.8v.7h2.2v-.7H.9l1.3-1.6v-.7H0v.7zm3.8-4.4v1.5h10.5V3.8H3.8zm0 10.4h10.5v-1.5H3.8v1.5zm0-4.4h10.5V8.2H3.8v1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.2v18H0V0z",
    fill: "none"
  }));
};

ListNumberedTrimmed.displayName = "ListNumberedTrimmed";
ListNumberedTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.2 18"
};

var Lock = function Lock(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
  }));
};

Lock.displayName = "Lock";
Lock.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var LockTrimmed = function LockTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6h-.7V4.5C9.8 2.4 8.1.7 6 .7S2.2 2.4 2.2 4.5V6h-.7C.7 6 0 6.7 0 7.5V15c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5V7.5c0-.8-.7-1.5-1.5-1.5zM6 12.8c-.8 0-1.5-.7-1.5-1.5S5.2 9.8 6 9.8s1.5.7 1.5 1.5-.7 1.5-1.5 1.5zM8.3 6H3.7V4.5c0-1.3 1-2.3 2.3-2.3s2.3 1 2.3 2.3V6z"
  }));
};

LockTrimmed.displayName = "LockTrimmed";
LockTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 18"
};

var LooksOne = function LooksOne(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"
  }));
};

LooksOne.displayName = "LooksOne";
LooksOne.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var LooksOneTrimmed = function LooksOneTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H9V9H7V7h4v10z"
  }));
};

LooksOneTrimmed.displayName = "LooksOneTrimmed";
LooksOneTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 24"
};

var LooksTwo = function LooksTwo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8a2 2 0 0 1-2 2h-2v2h4v2H9v-4a2 2 0 0 1 2-2h2V9H9V7h4a2 2 0 0 1 2 2v2z"
  }));
};

LooksTwo.displayName = "LooksTwo";
LooksTwo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var LooksTwoTrimmed = function LooksTwoTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.1-.9 2-2 2H8v2h4v2H6v-4c0-1.1.9-2 2-2h2V9H6V7h4c1.1 0 2 .9 2 2v2z"
  }));
};

LooksTwoTrimmed.displayName = "LooksTwoTrimmed";
LooksTwoTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 24"
};

var Menu = function Menu(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }));
};

Menu.displayName = "Menu";
Menu.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var MenuTrimmed = function MenuTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.5v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5h13.5V12H0v1.5zm0-3.7h13.5V8.2H0v1.6zm0-5.3V6h13.5V4.5H0z"
  }));
};

MenuTrimmed.displayName = "MenuTrimmed";
MenuTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.5 18"
};

var MoreHorizontal = function MoreHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }));
};

MoreHorizontal.displayName = "MoreHorizontal";
MoreHorizontal.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var MoreHorizontalTrimmed = function MoreHorizontalTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.5C.7 7.5 0 8.2 0 9s.7 1.5 1.5 1.5S3 9.8 3 9s-.7-1.5-1.5-1.5zm9 0C9.7 7.5 9 8.2 9 9s.7 1.5 1.5 1.5S12 9.8 12 9s-.7-1.5-1.5-1.5zM6 7.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5S7.5 9.8 7.5 9 6.8 7.5 6 7.5z"
  }));
};

MoreHorizontalTrimmed.displayName = "MoreHorizontalTrimmed";
MoreHorizontalTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 18"
};

var MoreVertical = function MoreVertical(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
  }));
};

MoreVertical.displayName = "MoreVertical";
MoreVertical.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var MoreVerticalTrimmed = function MoreVerticalTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6C2.3 6 3 5.3 3 4.5S2.3 3 1.5 3 0 3.7 0 4.5.7 6 1.5 6zm0 1.5C.7 7.5 0 8.2 0 9s.7 1.5 1.5 1.5S3 9.8 3 9s-.7-1.5-1.5-1.5zm0 4.5c-.8 0-1.5.7-1.5 1.5S.7 15 1.5 15 3 14.3 3 13.5 2.3 12 1.5 12z"
  }));
};

MoreVerticalTrimmed.displayName = "MoreVerticalTrimmed";
MoreVerticalTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 3 18"
};

var Plus = function Plus(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Plus.displayName = "Plus";
Plus.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var PlusCircle = function PlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
  }));
};

PlusCircle.displayName = "PlusCircle";
PlusCircle.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var PlusCircleTrimmed = function PlusCircleTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5C3.4 1.5 0 4.9 0 9s3.4 7.5 7.5 7.5S15 13.1 15 9s-3.4-7.5-7.5-7.5zm3.7 8.3h-3v3H6.8v-3h-3V8.2h3v-3h1.5v3h3v1.6z"
  }));
};

PlusCircleTrimmed.displayName = "PlusCircleTrimmed";
PlusCircleTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var PlusTrimmed = function PlusTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.8H6v4.5H4.5V9.8H0V8.2h4.5V3.8H6v4.5h4.5v1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10.5v18H0V0z",
    fill: "none"
  }));
};

PlusTrimmed.displayName = "PlusTrimmed";
PlusTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10.5 18"
};

var Quote = function Quote(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Quote.displayName = "Quote";
Quote.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24"
};

var QuoteTrimmed = function QuoteTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M.8 12.8H3l1.5-3V5.2H0v4.5h2.2L.8 12.8zm6 0H9l1.5-3V5.2H6v4.5h2.2l-1.4 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10.5v18H0V0z",
    fill: "none"
  }));
};

QuoteTrimmed.displayName = "QuoteTrimmed";
QuoteTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10.5 18"
};

var Receipt = function Receipt(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Receipt.displayName = "Receipt";
Receipt.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var ReceiptTrimmed = function ReceiptTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.2 12.8h-9v-1.5h9v1.5zm0-3h-9V8.2h9v1.6zm0-3h-9V5.2h9v1.6zM0 16.5l1.1-1.1 1.1 1.1 1.1-1.1 1.1 1.1 1.1-1.1 1.1 1.1 1.1-1.1L9 16.5l1.1-1.1 1.1 1.1 1.1-1.1 1.1 1.1v-15l-1.1 1.1-1.1-1.1-1.1 1.1L9 1.5 7.9 2.6 6.8 1.5 5.6 2.6 4.5 1.5 3.4 2.6 2.2 1.5 1.1 2.6 0 1.5v15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.5v18H0V0z",
    fill: "none"
  }));
};

ReceiptTrimmed.displayName = "ReceiptTrimmed";
ReceiptTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.5 18"
};

var References = function References(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7zM7 9H4V5h3v4zm10 6h3v4h-3v-4zm0-10h3v4h-3V5z"
  }));
};

References.displayName = "References";
References.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
};

var Release = function Release(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.756 3.636c.254-.254.594-.374.946-.374h12.716c.351 0 .692.12.946.374s.374.595.374.946v12.716c0 .351-.12.692-.374.946a1.32 1.32 0 0 1-.946.374H6.702c-.352 0-.692-.12-.946-.374a1.32 1.32 0 0 1-.374-.946V4.582c0-.351.12-.692.374-.946zm.862.877c-.003.01-.01.031-.01.069v12.716c0 .038.007.06.01.069l.005.01.01.005a.22.22 0 0 0 .069.009h12.716a.225.225 0 0 0 .069-.009l.01-.005c-.002.001.001-.001.004-.01a.183.183 0 0 0 .01-.069V4.582a.188.188 0 0 0-.01-.069c-.003-.009-.006-.011-.004-.01l-.01-.004a.188.188 0 0 0-.069-.01H6.702a.183.183 0 0 0-.069.01c-.009.003-.011.006-.01.004l-.005.01zm12.879-.009v-.001.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.208 6.702c0-.339.274-.613.613-.613h8.477a.613.613 0 1 1 0 1.226H8.821a.613.613 0 0 1-.613-.613zM8.208 9.527c0-.339.274-.613.613-.613h8.477a.613.613 0 1 1 0 1.226H8.821a.612.612 0 0 1-.613-.613zM8.208 12.353c0-.339.274-.613.613-.613h8.477a.613.613 0 1 1 0 1.226H8.821a.612.612 0 0 1-.613-.613zM8.208 15.179c0-.338.274-.613.613-.613h3.885a.614.614 0 1 1 0 1.226H8.821a.612.612 0 0 1-.613-.613z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.636 6.463c.254-.255.595-.374.946-.374h1.413a.612.612 0 1 1 0 1.226H4.582a.188.188 0 0 0-.069.01c-.009.003-.011.006-.01.005.002-.001-.001 0-.004.009a.192.192 0 0 0-.01.069v12.01c0 .038.006.06.01.069.003.009.006.011.004.01l.01.004c.01.004.031.01.069.01h12.01a.192.192 0 0 0 .069-.01l.009-.004c-.001.001.002-.001.005-.01a.183.183 0 0 0 .01-.069v-1.413a.613.613 0 0 1 1.226 0v1.413c0 .351-.119.692-.373.946a1.321 1.321 0 0 1-.946.374H4.582a1.32 1.32 0 0 1-.946-.374 1.32 1.32 0 0 1-.374-.946V7.408c0-.351.12-.691.374-.945z"
  }));
};

Release.displayName = "Release";
Release.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: "1.414"
};

var ReleaseTrimmed = function ReleaseTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2.256 3.636c.254-.254.594-.374.946-.374h12.716c.351 0 .692.12.946.374s.374.595.374.946v12.716c0 .351-.12.692-.374.946a1.32 1.32 0 0 1-.946.374H3.202c-.352 0-.692-.12-.946-.374a1.32 1.32 0 0 1-.374-.946V4.582c0-.351.12-.692.374-.946zm.862.877c-.003.01-.01.031-.01.069v12.716c0 .038.007.06.01.069l.005.01.01.005a.22.22 0 0 0 .069.009h12.716a.225.225 0 0 0 .069-.009l.01-.005c-.002.001.001-.001.004-.01a.183.183 0 0 0 .01-.069V4.582a.188.188 0 0 0-.01-.069c-.003-.009-.006-.011-.004-.01l-.01-.004a.188.188 0 0 0-.069-.01H3.202a.183.183 0 0 0-.069.01c-.009.003-.011.006-.01.004l-.005.01zm12.879-.009v-.001.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.708 6.702c0-.339.274-.613.613-.613h8.477a.613.613 0 1 1 0 1.226H5.321a.613.613 0 0 1-.613-.613zM4.708 9.527c0-.339.274-.613.613-.613h8.477a.613.613 0 1 1 0 1.226H5.321a.612.612 0 0 1-.613-.613zM4.708 12.353c0-.339.274-.613.613-.613h8.477a.613.613 0 1 1 0 1.226H5.321a.612.612 0 0 1-.613-.613zM4.708 15.179c0-.338.274-.613.613-.613h3.885a.614.614 0 1 1 0 1.226H5.321a.612.612 0 0 1-.613-.613z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.136 6.463c.254-.255.595-.374.946-.374h1.413a.612.612 0 1 1 0 1.226H1.082a.188.188 0 0 0-.069.01c-.009.003-.011.006-.01.005.002-.001-.001 0-.004.009a.192.192 0 0 0-.01.069v12.01c0 .038.006.06.01.069.003.009.006.011.004.01l.01.004c.01.004.031.01.069.01h12.01a.192.192 0 0 0 .069-.01l.009-.004c-.001.001.002-.001.005-.01a.183.183 0 0 0 .01-.069v-1.413a.613.613 0 0 1 1.226 0v1.413c0 .351-.119.692-.373.946a1.321 1.321 0 0 1-.946.374H1.082a1.32 1.32 0 0 1-.946-.374 1.32 1.32 0 0 1-.374-.946V7.408c0-.351.12-.691.374-.945z"
  }));
};

ReleaseTrimmed.displayName = "ReleaseTrimmed";
ReleaseTrimmed.defaultProps = {
  viewBox: "0 0 17 24",
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: "1.414"
};

var Search = function Search(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Search.displayName = "Search";
Search.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var SearchTrimmed = function SearchTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.4 10.5h-.6l-.2-.2c.7-.9 1.2-2 1.2-3.2 0-2.7-2.2-4.9-4.9-4.9S0 4.4 0 7.1 2.2 12 4.9 12c1.2 0 2.3-.4 3.2-1.2l.1.2v.6l3.8 3.7 1.1-1.1-3.7-3.7zm-4.5 0C3 10.5 1.5 9 1.5 7.1S3 3.8 4.9 3.8s3.4 1.5 3.4 3.4-1.6 3.3-3.4 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.1v18H0V0z",
    fill: "none"
  }));
};

SearchTrimmed.displayName = "SearchTrimmed";
SearchTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.1 18"
};

var Settings = function Settings(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0 0 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
  }));
};

Settings.displayName = "Settings";
Settings.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var SettingsTrimmed = function SettingsTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.6v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 9.7c0-.2.1-.5.1-.7s0-.5-.1-.7L14.5 7c.1-.1.2-.3.1-.5L13 4c-.1-.2-.3-.2-.5-.2l-1.9.8c-.3-.4-.7-.6-1.2-.8l-.3-2c0-.2-.2-.3-.4-.3h-3c-.2 0-.3.1-.4.3l-.3 2c-.3.2-.7.4-1.1.7L2 3.8c-.2-.1-.4 0-.4.2L.1 6.5c-.1.2-.1.4 0 .5l1.6 1.2c0 .2-.1.5-.1.7s0 .5.1.7L.1 11c-.1.1-.1.3 0 .5L1.6 14c.1.2.3.2.5.2l1.9-.8c.4.3.8.5 1.3.7l.3 2c0 .2.2.3.4.3h3c.2 0 .3-.1.4-.3l.3-2c.5-.2.9-.4 1.3-.7l1.9.8c.2.1.4 0 .5-.2l1.5-2.6c.1-.2.1-.4-.1-.5l-1.9-1.2zm-5.6 1.9c-1.4 0-2.6-1.2-2.6-2.6s1.2-2.6 2.6-2.6S9.9 7.6 9.9 9s-1.2 2.6-2.6 2.6z"
  }));
};

SettingsTrimmed.displayName = "SettingsTrimmed";
SettingsTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.6 18"
};

var ShoppingCart = function ShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

ShoppingCart.displayName = "ShoppingCart";
ShoppingCart.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShoppingCartTrimmed = function ShoppingCartTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5S6 15.8 6 15s-.7-1.5-1.5-1.5zM0 1.5V3h1.5l2.7 5.7-1 1.8c-.1.2-.2.5-.2.7 0 .8.7 1.5 1.5 1.5h9v-1.5H4.8c-.1 0-.2-.1-.2-.2v-.1l.7-1.2h5.6c.6 0 1.1-.3 1.3-.8L14.9 4c.1 0 .1-.1.1-.2 0-.5-.3-.8-.8-.8h-11l-.7-1.5H0zm12 12c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }));
};

ShoppingCartTrimmed.displayName = "ShoppingCartTrimmed";
ShoppingCartTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var Star = function Star(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

Star.displayName = "Star";
Star.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var StarTrimmed = function StarTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13l4.6 2.8-1.2-5.3L15 6.9l-5.4-.4-2.1-5-2.1 5-5.4.4 4.1 3.5-1.2 5.3L7.5 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v18H0V0z",
    fill: "none"
  }));
};

StarTrimmed.displayName = "StarTrimmed";
StarTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var Tags = function Tags(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6.5",
    cy: "6.5",
    r: "1.5"
  }));
};

Tags.displayName = "Tags";
Tags.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
};

var Text = function Text(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 24H0V0h24v24z",
    id: "a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
  }));
};

Text.displayName = "Text";
Text.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var TextTrimmed = function TextTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h14.2v18H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 3v2.2h3.8v9H6v-9h3.8V3H0zm14.2 3.8H7.5V9h2.2v5.2H12V9h2.2V6.8z",
    clipPath: "url(#b)"
  }));
};

TextTrimmed.displayName = "TextTrimmed";
TextTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 14.2 18"
};

var ThumbDown = function ThumbDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"
  }));
};

ThumbDown.displayName = "ThumbDown";
ThumbDown.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var ThumbDownTrimmed = function ThumbDownTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16.5v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.2H3.8c-.6 0-1.2.4-1.4.9L.1 8.5c-.1.1-.1.3-.1.5v1.5c0 .8.7 1.5 1.5 1.5h4.7l-.7 3.4v.2c0 .3.1.6.3.8l.8.8 4.9-4.9c.3-.3.4-.6.4-1.1V3.8c.1-.9-.6-1.6-1.4-1.6zm3 0v9h3v-9h-3z"
  }));
};

ThumbDownTrimmed.displayName = "ThumbDownTrimmed";
ThumbDownTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.5 18"
};

var ThumbUp = function ThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"
  }));
};

ThumbUp.displayName = "ThumbUp";
ThumbUp.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var ThumbUpTrimmed = function ThumbUpTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16.5v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.8h3v-9H0v9zm16.5-8.3c0-.8-.7-1.5-1.5-1.5h-4.7l.7-3.4v-.2c0-.3-.1-.6-.3-.8L9.9.8l-5 4.9c-.2.3-.4.6-.4 1.1v7.5c0 .8.7 1.5 1.5 1.5h6.8c.6 0 1.2-.4 1.4-.9l2.3-5.3c.1-.2.1-.4.1-.5V7.5h-.1z"
  }));
};

ThumbUpTrimmed.displayName = "ThumbUpTrimmed";
ThumbUpTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.5 18"
};

var Users = function Users(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
  }));
};

Users.displayName = "Users";
Users.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var UsersTrimmed = function UsersTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16.5v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 8.2c1.2 0 2.2-1 2.2-2.2s-1-2.2-2.2-2.2S9 4.8 9 6s1 2.2 2.2 2.2zm-6 0c1.2 0 2.2-1 2.2-2.2s-1-2.2-2.2-2.2S3 4.8 3 6s1 2.2 2.2 2.2zm0 1.6c-1.7 0-5.2.8-5.2 2.6v1.9h10.5v-1.9c0-1.8-3.5-2.6-5.3-2.6zm6 0h-.7c.9.6 1.5 1.5 1.5 2.6v1.9h4.5v-1.9c0-1.8-3.5-2.6-5.3-2.6z"
  }));
};

UsersTrimmed.displayName = "UsersTrimmed";
UsersTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.5 18"
};

var Clock = function Clock(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  }));
};

Clock.displayName = "Clock";
Clock.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var ClockTrimmed = function ClockTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.99 0C4.47 0 0 4.48 0 10s4.47 10 9.99 10C15.52 20 20 15.52 20 10S15.52 0 9.99 0zM10 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5H9v6l5.25 3.15.75-1.23-4.5-2.67V5z"
  }));
};

ClockTrimmed.displayName = "ClockTrimmed";
ClockTrimmed.defaultProps = {
  viewBox: "0 0 20 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Warning = function Warning(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
  }));
};

Warning.displayName = "Warning";
Warning.defaultProps = {
  height: "18",
  viewBox: "0 0 24 24",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
};

var WarningTrimmed = function WarningTrimmed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16.5v18H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.8h16.5L8.2 1.5 0 15.8zm9-2.3H7.5V12H9v1.5zm0-3H7.5v-3H9v3z"
  }));
};

WarningTrimmed.displayName = "WarningTrimmed";
WarningTrimmed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.5 18"
};
var styles = {
  "Icon": "Icon__Icon___38Epv",
  "Icon--tiny": "Icon__Icon--tiny___V4Pr9",
  "Icon--small": "Icon__Icon--small___1yGZK",
  "Icon--large": "Icon__Icon--large___215R6",
  "Icon--trimmed": "Icon__Icon--trimmed___1CmZL",
  "Icon--positive": "Icon__Icon--positive___1V4nP",
  "Icon--negative": "Icon__Icon--negative___1dled",
  "Icon--warning": "Icon__Icon--warning___39Bnz",
  "Icon--secondary": "Icon__Icon--secondary___1ztcw",
  "Icon--muted": "Icon__Icon--muted___3egnD",
  "Icon--white": "Icon__Icon--white___3GVPJ"
};
var iconComponents = {
  ArrowDown: ArrowDown,
  ArrowDownTrimmed: ArrowDownTrimmed,
  ArrowUp: ArrowUp,
  ArrowUpTrimmed: ArrowUpTrimmed,
  Asset: Asset,
  AssetTrimmed: AssetTrimmed,
  ChatBubble: ChatBubble,
  ChatBubbleTrimmed: ChatBubbleTrimmed,
  CheckCircle: CheckCircle,
  CheckCircleTrimmed: CheckCircleTrimmed,
  ChevronDown: ChevronDown,
  ChevronDownTrimmed: ChevronDownTrimmed,
  ChevronLeft: ChevronLeft,
  ChevronLeftTrimmed: ChevronLeftTrimmed,
  ChevronRight: ChevronRight,
  ChevronRightTrimmed: ChevronRightTrimmed,
  ChevronUp: ChevronUp,
  ChevronUpTrimmed: ChevronUpTrimmed,
  Clock: Clock,
  ClockTrimmed: ClockTrimmed,
  Close: Close,
  CloseTrimmed: CloseTrimmed,
  Code: Code,
  CodeTrimmed: CodeTrimmed,
  Copy: Copy,
  CopyTrimmed: CopyTrimmed,
  Cycle: Cycle,
  CycleTrimmed: CycleTrimmed,
  Delete: Delete,
  DeleteTrimmed: DeleteTrimmed,
  Download: Download,
  DownloadTrimmed: DownloadTrimmed,
  Drag: Drag,
  DragTrimmed: DragTrimmed,
  Edit: Edit,
  EditTrimmed: EditTrimmed,
  EmbeddedEntryBlock: EmbeddedEntryBlock,
  EmbeddedEntryBlockTrimmed: EmbeddedEntryBlockTrimmed,
  EmbeddedEntryInline: EmbeddedEntryInline,
  EmbeddedEntryInlineTrimmed: EmbeddedEntryInlineTrimmed,
  Entry: Entry,
  EntryTrimmed: EntryTrimmed,
  ErrorCircle: ErrorCircle,
  ErrorCircleTrimmed: ErrorCircleTrimmed,
  ExternalLink: ExternalLink,
  ExternalLinkTrimmed: ExternalLinkTrimmed,
  FaceHappy: FaceHappy,
  FaceHappyTrimmed: FaceHappyTrimmed,
  Filter: Filter,
  FilterTrimmed: FilterTrimmed,
  Folder: Folder,
  FolderCreate: FolderCreate,
  FolderCreateTrimmed: FolderCreateTrimmed,
  FolderOpen: FolderOpen,
  FolderOpenTrimmed: FolderOpenTrimmed,
  FolderTrimmed: FolderTrimmed,
  FormatBold: FormatBold,
  FormatBoldTrimmed: FormatBoldTrimmed,
  FormatItalic: FormatItalic,
  FormatItalicTrimmed: FormatItalicTrimmed,
  FormatUnderlined: FormatUnderlined,
  FormatUnderlinedTrimmed: FormatUnderlinedTrimmed,
  Heading: Heading,
  HeadingOne: HeadingOne,
  HeadingOneTrimmed: HeadingOneTrimmed,
  HeadingTrimmed: HeadingTrimmed,
  HeadingTwo: HeadingTwo,
  HeadingTwoTrimmed: HeadingTwoTrimmed,
  HelpCircle: HelpCircle,
  HelpCircleTrimmed: HelpCircleTrimmed,
  HorizontalRule: HorizontalRule,
  HorizontalRuleTrimmed: HorizontalRuleTrimmed,
  InfoCircle: InfoCircle,
  InfoCircleTrimmed: InfoCircleTrimmed,
  Link: Link,
  LinkTrimmed: LinkTrimmed,
  ListBulleted: ListBulleted,
  ListBulletedTrimmed: ListBulletedTrimmed,
  ListNumbered: ListNumbered,
  ListNumberedTrimmed: ListNumberedTrimmed,
  Lock: Lock,
  LockTrimmed: LockTrimmed,
  LooksOne: LooksOne,
  LooksOneTrimmed: LooksOneTrimmed,
  LooksTwo: LooksTwo,
  LooksTwoTrimmed: LooksTwoTrimmed,
  Menu: Menu,
  MenuTrimmed: MenuTrimmed,
  MoreHorizontal: MoreHorizontal,
  MoreHorizontalTrimmed: MoreHorizontalTrimmed,
  MoreVertical: MoreVertical,
  MoreVerticalTrimmed: MoreVerticalTrimmed,
  Plus: Plus,
  PlusCircle: PlusCircle,
  PlusCircleTrimmed: PlusCircleTrimmed,
  PlusTrimmed: PlusTrimmed,
  Quote: Quote,
  QuoteTrimmed: QuoteTrimmed,
  References: References,
  Release: Release,
  ReleaseTrimmed: ReleaseTrimmed,
  Receipt: Receipt,
  ReceiptTrimmed: ReceiptTrimmed,
  Search: Search,
  SearchTrimmed: SearchTrimmed,
  Settings: Settings,
  SettingsTrimmed: SettingsTrimmed,
  ShoppingCart: ShoppingCart,
  ShoppingCartTrimmed: ShoppingCartTrimmed,
  Star: Star,
  StarTrimmed: StarTrimmed,
  Tags: Tags,
  Text: Text,
  TextTrimmed: TextTrimmed,
  ThumbDown: ThumbDown,
  ThumbDownTrimmed: ThumbDownTrimmed,
  ThumbUp: ThumbUp,
  ThumbUpTrimmed: ThumbUpTrimmed,
  Users: Users,
  UsersTrimmed: UsersTrimmed,
  Warning: Warning,
  WarningTrimmed: WarningTrimmed
};
var defaultProps = {
  testId: 'cf-ui-icon',
  size: 'small',
  color: 'primary'
};
var Icon = /*#__PURE__*/function (_Component) {
  _inherits(Icon, _Component);

  var _super = _createSuper(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _cn;

      var _this$props = this.props,
          className = _this$props.className,
          icon = _this$props.icon,
          size = _this$props.size,
          color = _this$props.color,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "icon", "size", "color", "testId"]);

      var classNames = classnames(styles.Icon, (_cn = {}, _defineProperty(_cn, styles["Icon--".concat(size)], size), _defineProperty(_cn, styles["Icon--".concat(color)], color), _defineProperty(_cn, styles['Icon--trimmed'], icon.toLowerCase().includes('trimmed')), _cn), className);
      var Element = iconComponents[icon];
      return /*#__PURE__*/React.createElement(Element, _extends({
        "data-test-id": testId,
        className: classNames
      }, otherProps));
    }
  }]);

  return Icon;
}(Component$1);
Icon.displayName = "Icon";

_defineProperty(Icon, "propTypes", {
  size: propTypes.oneOf(['tiny', 'small', 'large']),
  color: propTypes.oneOf(['primary', 'positive', 'negative', 'warning', 'secondary', 'muted', 'white']),
  style: propTypes.any,
  icon: propTypes.any.isRequired,
  className: propTypes.string,
  testId: propTypes.string
});

_defineProperty(Icon, "defaultProps", defaultProps);

function _createSuper$1(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$1()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$1 = {
  "TabFocusTrap": "TabFocusTrap__TabFocusTrap___39Vty"
};
var TabFocusTrap = /*#__PURE__*/function (_Component) {
  _inherits(TabFocusTrap, _Component);

  var _super = _createSuper$1(TabFocusTrap);

  function TabFocusTrap() {
    _classCallCheck(this, TabFocusTrap);

    return _super.apply(this, arguments);
  }

  _createClass(TabFocusTrap, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children"]);

      var classNames = classnames(styles$1.TabFocusTrap, className);
      return /*#__PURE__*/React.createElement("span", _extends({
        tabIndex: -1,
        className: classNames
      }, otherProps), children);
    }
  }]);

  return TabFocusTrap;
}(Component$1);
TabFocusTrap.displayName = "TabFocusTrap";

_defineProperty(TabFocusTrap, "propTypes", {
  className: propTypes.string,
  children: propTypes.node.isRequired
});

function _createSuper$2(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$2()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$2 = {
  "TextLink": "TextLink__TextLink___1biUr a11y__focus-outline--default___2hwb1",
  "TextLink--primary": "TextLink__TextLink--primary___2Vc9F",
  "TextLink--positive": "TextLink__TextLink--positive___3X5ph",
  "TextLink--negative": "TextLink__TextLink--negative___3yhMk",
  "TextLink--secondary": "TextLink__TextLink--secondary___WbTVM",
  "TextLink--muted": "TextLink__TextLink--muted___TMxw0",
  "TextLink--white": "TextLink__TextLink--white___nesMH",
  "TextLink--disabled": "TextLink__TextLink--disabled___3vo9n",
  "TextLink__icon": "TextLink__TextLink__icon___3ggiB",
  "TextLink__icon-wrapper": "TextLink__TextLink__icon-wrapper___25_tI",
  "TextLink__icon-wrapper--right": "TextLink__TextLink__icon-wrapper--right___3ybuG"
};
var defaultProps$1 = {
  linkType: 'primary',
  testId: 'cf-ui-text-link',
  disabled: false,
  iconPosition: 'left'
};
var TextLink = /*#__PURE__*/function (_Component) {
  _inherits(TextLink, _Component);

  var _super = _createSuper$2(TextLink);

  function TextLink() {
    _classCallCheck(this, TextLink);

    return _super.apply(this, arguments);
  }

  _createClass(TextLink, [{
    key: "renderIcon",
    value: function renderIcon(icon, linkType) {
      if (!icon) return undefined;
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.iconPosition === 'right' ? styles$2['TextLink__icon-wrapper--right'] : styles$2['TextLink__icon-wrapper']
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: icon,
        color: linkType,
        className: styles$2.TextLink__icon
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _cn;

      var _this$props = this.props,
          children = _this$props.children,
          href = _this$props.href,
          linkType = _this$props.linkType,
          testId = _this$props.testId,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled,
          className = _this$props.className,
          icon = _this$props.icon,
          text = _this$props.text,
          iconPosition = _this$props.iconPosition,
          otherProps = _objectWithoutProperties(_this$props, ["children", "href", "linkType", "testId", "onClick", "disabled", "className", "icon", "text", "iconPosition"]);

      var classNames = classnames(styles$2.TextLink, className, (_cn = {}, _defineProperty(_cn, styles$2["TextLink--".concat(linkType)], linkType), _defineProperty(_cn, styles$2['TextLink--disabled'], disabled), _cn));
      var content = /*#__PURE__*/React.createElement(TabFocusTrap, null, icon && iconPosition === 'left' && this.renderIcon(icon, linkType), text || children, icon && iconPosition === 'right' && this.renderIcon(icon, linkType));

      if (href) {
        return /*#__PURE__*/React.createElement("a", _extends({
          className: classNames,
          "data-test-id": testId,
          onClick: disabled ? function (e) {
            e.preventDefault();
          } : onClick,
          href: href
        }, otherProps), content);
      }

      return /*#__PURE__*/React.createElement("button", _extends({
        type: "button",
        className: classNames,
        "data-test-id": testId,
        onClick: !disabled ? onClick : function () {},
        disabled: disabled
      }, otherProps), content);
    }
  }]);

  return TextLink;
}(Component$1);
TextLink.displayName = "TextLink";

_defineProperty(TextLink, "propTypes", {
  children: propTypes.node,
  linkType: propTypes.oneOf(['primary', 'positive', 'negative', 'secondary', 'muted', 'white']),
  disabled: propTypes.bool,
  testId: propTypes.string,
  onClick: propTypes.func,
  className: propTypes.string,
  icon: propTypes.any,
  text: propTypes.string,
  iconPosition: propTypes.oneOf(['right', 'left'])
});

_defineProperty(TextLink, "defaultProps", defaultProps$1);

function _createSuper$3(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$3()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$3 = {
  "Pill": "Pill__Pill___2yQFD a11y__focus-outline--default___2hwb1",
  "Pill__label": "Pill__Pill__label____EsBZ",
  "Pill__close-button": "Pill__Pill__close-button___3OlnQ a11y__focus-outline--default___2hwb1",
  "Pill__drag-icon": "Pill__Pill__drag-icon___2aB1g",
  "Pill__icon": "Pill__Pill__icon___1NILR"
};
var defaultProps$2 = {
  testId: 'cf-ui-pill'
};
var Pill = /*#__PURE__*/function (_Component) {
  _inherits(Pill, _Component);

  var _super = _createSuper$3(Pill);

  function Pill() {
    _classCallCheck(this, Pill);

    return _super.apply(this, arguments);
  }

  _createClass(Pill, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          onClose = _this$props.onClose,
          testId = _this$props.testId,
          onDrag = _this$props.onDrag,
          className = _this$props.className,
          dragHandleComponent = _this$props.dragHandleComponent,
          otherProps = _objectWithoutProperties(_this$props, ["label", "onClose", "testId", "onDrag", "className", "dragHandleComponent"]);

      var classNames = classnames(styles$3.Pill, className);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames,
        "data-test-id": testId
      }, otherProps, {
        onDrag: onDrag
      }), onDrag && (dragHandleComponent ? dragHandleComponent : /*#__PURE__*/React.createElement("span", {
        className: styles$3['Pill__drag-icon']
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "Drag",
        color: "muted",
        className: styles$3.Pill__icon
      }))), /*#__PURE__*/React.createElement("span", {
        "aria-label": label,
        title: label,
        className: styles$3.Pill__label
      }, label), onClose && /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: onClose,
        className: styles$3['Pill__close-button']
      }, /*#__PURE__*/React.createElement(TabFocusTrap, null, /*#__PURE__*/React.createElement(Icon, {
        icon: "Close",
        color: "muted",
        className: styles$3.Pill__icon
      }))));
    }
  }]);

  return Pill;
}(Component$1);
Pill.displayName = "Pill";

_defineProperty(Pill, "propTypes", {
  label: propTypes.string.isRequired,
  onClose: propTypes.func,
  onDrag: propTypes.func,
  className: propTypes.string,
  testId: propTypes.string,
  style: propTypes.any,
  dragHandleComponent: propTypes.node
});

_defineProperty(Pill, "defaultProps", defaultProps$2);

function _createSuper$4(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$4()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$4 = {
  "HelpText": "HelpText__HelpText___uWbja"
};
var defaultProps$3 = {
  testId: 'cf-ui-help-text'
};
var HelpText = /*#__PURE__*/function (_Component) {
  _inherits(HelpText, _Component);

  var _super = _createSuper$4(HelpText);

  function HelpText() {
    _classCallCheck(this, HelpText);

    return _super.apply(this, arguments);
  }

  _createClass(HelpText, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      var classNames = classnames(styles$4.HelpText, className);
      return /*#__PURE__*/React.createElement("p", _extends({}, otherProps, {
        className: classNames,
        "data-test-id": testId
      }), children);
    }
  }]);

  return HelpText;
}(Component$1);
HelpText.displayName = "HelpText";

_defineProperty(HelpText, "propTypes", {
  className: propTypes.string,
  testId: propTypes.string,
  style: propTypes.any,
  children: propTypes.node.isRequired
});

_defineProperty(HelpText, "defaultProps", defaultProps$3);

function _createSuper$5(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$5()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$5 = {
  "FormLabel": "FormLabel__FormLabel___3d6zQ",
  "FormLabel__required-text": "FormLabel__FormLabel__required-text___3mvdm"
};
var defaultProps$4 = {
  testId: 'cf-ui-form-label',
  requiredText: 'required',
  required: false
};
var FormLabel = /*#__PURE__*/function (_Component) {
  _inherits(FormLabel, _Component);

  var _super = _createSuper$5(FormLabel);

  function FormLabel() {
    _classCallCheck(this, FormLabel);

    return _super.apply(this, arguments);
  }

  _createClass(FormLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          htmlFor = _this$props.htmlFor,
          requiredText = _this$props.requiredText,
          required = _this$props.required,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "htmlFor", "requiredText", "required"]);

      var classNames = classnames(styles$5.FormLabel, className);
      return /*#__PURE__*/React.createElement("label", _extends({
        className: classNames,
        "data-test-id": testId,
        htmlFor: htmlFor
      }, otherProps), children, required && !!requiredText.length && /*#__PURE__*/React.createElement("span", {
        className: styles$5['FormLabel__required-text']
      }, "(", requiredText, ")"));
    }
  }]);

  return FormLabel;
}(Component$1);
FormLabel.displayName = "FormLabel";

_defineProperty(FormLabel, "propTypes", {
  htmlFor: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
  testId: propTypes.string,
  className: propTypes.string,
  requiredText: propTypes.string,
  required: propTypes.bool
});

_defineProperty(FormLabel, "defaultProps", defaultProps$4);

function _createSuper$6(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$6()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$6 = {
  "ValidationMessage": "ValidationMessage__ValidationMessage___3_rEq",
  "ValidationMessage__icon": "ValidationMessage__ValidationMessage__icon___3HPCh",
  "ValidationMessage__text": "ValidationMessage__ValidationMessage__text___8FBj5"
};
var defaultProps$5 = {
  testId: 'cf-ui-validation-message'
};
var ValidationMessage = /*#__PURE__*/function (_Component) {
  _inherits(ValidationMessage, _Component);

  var _super = _createSuper$6(ValidationMessage);

  function ValidationMessage() {
    _classCallCheck(this, ValidationMessage);

    return _super.apply(this, arguments);
  }

  _createClass(ValidationMessage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      var classNames = classnames(styles$6['ValidationMessage'], className);
      return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
        className: classNames,
        "data-test-id": testId
      }), /*#__PURE__*/React.createElement(Icon, {
        icon: "ErrorCircle",
        className: styles$6['ValidationMessage__icon'],
        color: "negative"
      }), /*#__PURE__*/React.createElement("p", {
        className: styles$6['ValidationMessage__text']
      }, children));
    }
  }]);

  return ValidationMessage;
}(Component$1);
ValidationMessage.displayName = "ValidationMessage";

_defineProperty(ValidationMessage, "propTypes", {
  className: propTypes.string,
  testId: propTypes.string,
  style: propTypes.any,
  children: propTypes.node.isRequired
});

_defineProperty(ValidationMessage, "defaultProps", defaultProps$5);

var toggleSelection = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
};

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = toggleSelection();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

var copyToClipboard = copy;

var Component = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(React);

var _copyToClipboard = _interopRequireDefault(copyToClipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  function CopyToClipboard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CopyToClipboard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, ["text", "onCopy", "options", "children"]);

      var elem = _react["default"].Children.only(children);

      return _react["default"].cloneElement(elem, _objectSpread({}, props, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});
});

unwrapExports(Component);
var Component_1 = Component.CopyToClipboard;

var CopyToClipboard = Component.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
var lib = CopyToClipboard;

var isBrowser = typeof window !== 'undefined';

var throttle = function throttle() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
  var fn = arguments.length > 1 ? arguments[1] : undefined;
  var lastCall = 0; // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var throttleExec = function throttleExec() {
    var now = new Date().getTime();

    if (now - lastCall < delay) {
      return;
    }

    lastCall = now;
    return fn.apply(void 0, arguments); // eslint-disable-line
  };

  return throttleExec;
};

function _createSuper$7(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$7()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$7 = {
  "InViewport": "InViewport__InViewport___2o6g4"
};
var defaultProps$6 = {
  testId: 'cf-ui-in-viewport',
  offset: 0
};
var InViewport = /*#__PURE__*/function (_Component) {
  _inherits(InViewport, _Component);

  var _super = _createSuper$7(InViewport);

  function InViewport() {
    var _this;

    _classCallCheck(this, InViewport);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "tGetDomPosition", null);

    _defineProperty(_assertThisInitialized(_this), "nodeRef", null);

    _defineProperty(_assertThisInitialized(_this), "lastOverflowAt", null);

    _defineProperty(_assertThisInitialized(_this), "tOnOverflowTop", _this.props.onOverflowTop && throttle(100, _this.props.onOverflowTop));

    _defineProperty(_assertThisInitialized(_this), "tOnOverflowBottom", _this.props.onOverflowBottom && throttle(100, _this.props.onOverflowBottom));

    _defineProperty(_assertThisInitialized(_this), "tOnOverflowRight", _this.props.onOverflowRight && throttle(100, _this.props.onOverflowRight));

    _defineProperty(_assertThisInitialized(_this), "tOnOverflowLeft", _this.props.onOverflowLeft && throttle(100, _this.props.onOverflowLeft));

    _defineProperty(_assertThisInitialized(_this), "getDomPosition", function () {
      if (isBrowser && _this.nodeRef) {
        var html = document.documentElement;

        var boundingClientRect = _this.nodeRef.getBoundingClientRect();

        var windowWidth = window.innerWidth || html.clientWidth;
        var windowHeight = window.innerHeight || html.clientHeight;

        _this.handleOverflow(boundingClientRect, windowWidth, windowHeight);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "bindEventListeners", function () {
      _this.tGetDomPosition = throttle(600, _this.getDomPosition);

      if (isBrowser) {
        window.addEventListener('scroll', _this.tGetDomPosition, true);
        window.addEventListener('resize', _this.tGetDomPosition);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOverflow", function (_ref, windowWidth, windowHeight) {
      var top = _ref.top,
          left = _ref.left,
          bottom = _ref.bottom,
          right = _ref.right;
      var offset = _this.props.offset;
      var topThreshold = 0 - offset;
      var leftThreshold = 0 - offset;
      var rightThreshold = windowWidth + offset;
      var bottomThreshold = windowHeight + offset;

      if (top + right + bottom + left !== 0) {
        if (top < topThreshold && _this.lastOverflowAt !== 'bottom') {
          _this.lastOverflowAt = 'top';
          _this.tOnOverflowTop && _this.tOnOverflowTop();
        } else if (left < leftThreshold && _this.lastOverflowAt !== 'right') {
          _this.lastOverflowAt = 'left';
          _this.tOnOverflowLeft && _this.tOnOverflowLeft();
        } else if (bottom > bottomThreshold && _this.lastOverflowAt !== 'top') {
          _this.lastOverflowAt = 'bottom';
          _this.tOnOverflowBottom && _this.tOnOverflowBottom();
        } else if (right > rightThreshold && _this.lastOverflowAt !== 'left') {
          _this.lastOverflowAt = 'right';
          _this.tOnOverflowRight && _this.tOnOverflowRight();
        }
      }
    });

    return _this;
  }

  _createClass(InViewport, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getDomPosition();
      this.bindEventListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.getDomPosition();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (isBrowser && this.tGetDomPosition) {
        window.removeEventListener('scroll', this.tGetDomPosition, true);
        window.removeEventListener('resize', this.tGetDomPosition);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          onOverflowBottom = _this$props.onOverflowBottom,
          onOverflowLeft = _this$props.onOverflowLeft,
          onOverflowRight = _this$props.onOverflowRight,
          onOverflowTop = _this$props.onOverflowTop,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "onOverflowBottom", "onOverflowLeft", "onOverflowRight", "onOverflowTop"]);

      var classNames = classnames(styles$7['InViewport'], className);
      return /*#__PURE__*/React.createElement("div", _extends({
        ref: function ref(_ref2) {
          _this2.nodeRef = _ref2;
        },
        className: classNames,
        "data-test-id": testId
      }, otherProps), children);
    }
  }]);

  return InViewport;
}(Component$1);
InViewport.displayName = "InViewport";

_defineProperty(InViewport, "propTypes", {
  offset: propTypes.number.isRequired,
  onOverflowTop: propTypes.any,
  onOverflowRight: propTypes.any,
  onOverflowBottom: propTypes.any,
  onOverflowLeft: propTypes.any,
  className: propTypes.string,
  children: propTypes.node,
  testId: propTypes.string
});

_defineProperty(InViewport, "defaultProps", defaultProps$6);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$8(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$8()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$8 = {
  "Tooltip__target-wrapper": "Tooltip__Tooltip__target-wrapper___Mtw42",
  "Tooltip": "Tooltip__Tooltip___32xAi",
  "Tooltip--hidden": "Tooltip__Tooltip--hidden___3uqEe",
  "Tooltip--place-bottom": "Tooltip__Tooltip--place-bottom___3qAh6",
  "Tooltip--place-top": "Tooltip__Tooltip--place-top___1_DNW",
  "Tooltip--place-left": "Tooltip__Tooltip--place-left___1_Rl2",
  "Tooltip--place-right": "Tooltip__Tooltip--place-right___H8LiN"
};

var TooltipContainer = function TooltipContainer(props) {
  var children = props.children,
      setRef = props.setRef,
      containerElement = props.containerElement,
      targetWrapperClassName = props.targetWrapperClassName,
      otherProps = _objectWithoutProperties(props, ["children", "setRef", "containerElement", "targetWrapperClassName"]);

  var ContainerElement = containerElement;
  return /*#__PURE__*/React.createElement(ContainerElement, _extends({
    ref: setRef,
    className: classnames(styles$8['Tooltip__target-wrapper'], targetWrapperClassName)
  }, otherProps), children);
};

TooltipContainer.displayName = "TooltipContainer";
TooltipContainer.propTypes = {
  children: propTypes.node.isRequired,
  setRef: propTypes.any.isRequired,
  containerElement: propTypes.any.isRequired,
  targetWrapperClassName: propTypes.string,
  onMouseLeave: propTypes.any.isRequired,
  onMouseOver: propTypes.any.isRequired,
  onFocus: propTypes.any.isRequired,
  onBlur: propTypes.any.isRequired
};
var defaultProps$7 = {
  containerElement: 'span',
  isVisible: false,
  testId: 'cf-ui-tooltip',
  place: 'top',
  maxWidth: 360
};

var TooltipWrapper = /*#__PURE__*/function (_Component) {
  _inherits(TooltipWrapper, _Component);

  var _super = _createSuper$8(TooltipWrapper);

  function TooltipWrapper() {
    var _this;

    _classCallCheck(this, TooltipWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "tooltipDomNode", void 0);

    _defineProperty(_assertThisInitialized(_this), "containerDomNode", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      calculatedPosition: {
        top: undefined,
        left: undefined
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calculatePosition", function () {
      var _this$props = _this.props,
          containerDomNode = _this$props.containerDomNode,
          place = _this$props.place;

      if (!containerDomNode || !_this.tooltipDomNode) {
        return {
          top: undefined,
          left: undefined
        };
      }

      var calculatedPosition = {};
      var containerRect = containerDomNode.getBoundingClientRect();

      var tooltipRect = _this.tooltipDomNode.getBoundingClientRect();

      var carretVerticalOffset = 20;
      var carretHorizontalOffset = 12;

      switch (place) {
        case 'top':
          calculatedPosition = {
            left: containerRect.left + (containerRect.width / 2 - tooltipRect.width / 2),
            top: containerRect.top - (tooltipRect.height + carretVerticalOffset)
          };
          break;

        case 'bottom':
          calculatedPosition = {
            left: containerRect.left + (containerRect.width / 2 - tooltipRect.width / 2),
            top: containerRect.top + containerRect.height
          };
          break;

        case 'left':
          calculatedPosition = {
            left: containerRect.left - (tooltipRect.width + carretHorizontalOffset),
            top: containerRect.top + containerRect.height / 2 - tooltipRect.height / 2 - 10 // Tooltip margin

          };
          break;

        case 'right':
          calculatedPosition = {
            left: containerRect.left + (containerRect.width + carretHorizontalOffset),
            top: containerRect.top + containerRect.height / 2 - tooltipRect.height / 2 - 10 // Tooltip margin

          };
          break;

        default:
          calculatedPosition = {};
      }

      return calculatedPosition;
    });

    return _this;
  }

  _createClass(TooltipWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        calculatedPosition: this.calculatePosition()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          isVisible = _this$props2.isVisible,
          id = _this$props2.id,
          maxWidth = _this$props2.maxWidth,
          className = _this$props2.className,
          testId = _this$props2.testId,
          setPlace = _this$props2.setPlace,
          children = _this$props2.children;
      return /*#__PURE__*/React.createElement("div", {
        role: "tooltip",
        id: id,
        "aria-hidden": isVisible ? 'false' : 'true',
        style: _objectSpread({}, this.state.calculatedPosition, {
          maxWidth: maxWidth
        }),
        ref: function ref(_ref) {
          _this2.tooltipDomNode = _ref;
        },
        contentEditable: false,
        onFocus: function onFocus() {
          _this2.setState({
            isVisible: false
          });
        },
        onMouseOver: function onMouseOver() {
          _this2.setState({
            isVisible: false
          });
        },
        className: className,
        "data-test-id": testId
      }, /*#__PURE__*/React.createElement(InViewport, {
        onOverflowTop: function onOverflowTop() {
          return setPlace('bottom');
        },
        onOverflowLeft: function onOverflowLeft() {
          return setPlace('right');
        },
        onOverflowBottom: function onOverflowBottom() {
          return setPlace('top');
        },
        onOverflowRight: function onOverflowRight() {
          return setPlace('left');
        }
      }, children));
    }
  }]);

  return TooltipWrapper;
}(Component$1);

TooltipWrapper.displayName = "TooltipWrapper";

_defineProperty(TooltipWrapper, "propTypes", {
  children: propTypes.node.isRequired,
  containerDomNode: propTypes.any,
  place: propTypes.oneOf(['top', 'bottom', 'right', 'left']),
  isVisible: propTypes.bool,
  id: propTypes.string,
  maxWidth: propTypes.oneOfType([propTypes.number, propTypes.string]),
  className: propTypes.string,
  testId: propTypes.string,
  setPlace: propTypes.any.isRequired
});

var Tooltip = /*#__PURE__*/function (_Component2) {
  _inherits(Tooltip, _Component2);

  var _super2 = _createSuper$8(Tooltip);

  function Tooltip(props) {
    var _this3;

    _classCallCheck(this, Tooltip);

    _this3 = _super2.call(this, props);

    _defineProperty(_assertThisInitialized(_this3), "portalTarget", null);

    _defineProperty(_assertThisInitialized(_this3), "place", 'top');

    _defineProperty(_assertThisInitialized(_this3), "containerDomNode", void 0);

    _defineProperty(_assertThisInitialized(_this3), "tooltipDomNode", void 0);

    _defineProperty(_assertThisInitialized(_this3), "state", {
      isVisible: _this3.props.isVisible
    });

    _defineProperty(_assertThisInitialized(_this3), "setPlace", function (place) {
      if (_this3.state.isVisible) {
        _this3.place = place;

        _this3.forceUpdate();
      }
    });

    _defineProperty(_assertThisInitialized(_this3), "renderTooltip", function (content) {
      if (!_this3.portalTarget) {
        return null;
      }

      var placeClass = "Tooltip--place-".concat(_this3.place);
      var classNames = classnames(styles$8['Tooltip'], styles$8[placeClass], _this3.props.className, _defineProperty({}, styles$8['Tooltip--hidden'], !_this3.state.isVisible));
      return ReactDOM.createPortal( /*#__PURE__*/React.createElement(TooltipWrapper, {
        containerDomNode: _this3.containerDomNode,
        place: _this3.place,
        isVisible: _this3.state.isVisible,
        id: _this3.props.id,
        maxWidth: _this3.props.maxWidth,
        className: classNames,
        testId: _this3.props.testId,
        setPlace: _this3.setPlace
      }, content), _this3.portalTarget);
    });

    _this3.place = props.place;
    return _this3;
  }

  _createClass(Tooltip, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (typeof window !== "undefined") {
        this.portalTarget = window.document.createElement('div');
        window.document.body.appendChild(this.portalTarget);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isVisible) {
        this.setState({
          isVisible: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.content !== this.props.content) {
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.portalTarget) {
        window.document.body.removeChild(this.portalTarget);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          targetWrapperClassName = _this$props3.targetWrapperClassName,
          content = _this$props3.content,
          _onMouseLeave = _this$props3.onMouseLeave,
          _onMouseOver = _this$props3.onMouseOver,
          _onFocus = _this$props3.onFocus,
          containerElement = _this$props3.containerElement,
          _onBlur = _this$props3.onBlur,
          children = _this$props3.children,
          place = _this$props3.place,
          isVisible = _this$props3.isVisible,
          testId = _this$props3.testId,
          maxWidth = _this$props3.maxWidth,
          otherProps = _objectWithoutProperties(_this$props3, ["className", "targetWrapperClassName", "content", "onMouseLeave", "onMouseOver", "onFocus", "containerElement", "onBlur", "children", "place", "isVisible", "testId", "maxWidth"]);

      return /*#__PURE__*/React.createElement(TooltipContainer, _extends({
        containerElement: containerElement,
        onMouseOver: function onMouseOver(e) {
          _this4.setState({
            isVisible: true
          });

          if (_onMouseOver) {
            _onMouseOver(e);
          }
        },
        onMouseLeave: function onMouseLeave(e) {
          _this4.setState({
            isVisible: false
          });

          if (_onMouseLeave) {
            _onMouseLeave(e);
          }
        },
        onFocus: function onFocus(e) {
          _this4.setState({
            isVisible: true
          });

          if (_onFocus) {
            _onFocus(e);
          }
        },
        onBlur: function onBlur(e) {
          _this4.setState({
            isVisible: false
          });

          if (_onBlur) {
            _onBlur(e);
          }
        },
        setRef: function setRef(ref) {
          _this4.containerDomNode = ref;
        },
        targetWrapperClassName: targetWrapperClassName,
        "aria-describedby": this.props.id
      }, otherProps), /*#__PURE__*/React.createElement(React.Fragment, null, children, content && this.state.isVisible && this.renderTooltip(content)));
    }
  }]);

  return Tooltip;
}(Component$1);
Tooltip.displayName = "Tooltip";

_defineProperty(Tooltip, "propTypes", {
  children: propTypes.node.isRequired,
  containerElement: propTypes.node,
  place: propTypes.oneOf(['top', 'bottom', 'right', 'left']),
  isVisible: propTypes.bool,
  maxWidth: propTypes.oneOfType([propTypes.number, propTypes.string]),
  testId: propTypes.string,
  id: propTypes.string,
  className: propTypes.string,
  content: propTypes.node,
  targetWrapperClassName: propTypes.string,
  onMouseOver: propTypes.any,
  onMouseLeave: propTypes.any,
  onFocus: propTypes.any,
  onBlur: propTypes.any
});

_defineProperty(Tooltip, "defaultProps", defaultProps$7);

function _createSuper$9(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$9()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$9 = {
  "CopyButton": "CopyButton__CopyButton___OoA5D",
  "CopyButton__button": "CopyButton__CopyButton__button___52Bc0 a11y__focus-outline--default___2hwb1",
  "CopyButton__text": "CopyButton__CopyButton__text___269PQ helpers__sr-only___3Kv3z",
  "CopyButton__TabFocusTrap": "CopyButton__CopyButton__TabFocusTrap___1Q_DQ"
};
var defaultProps$8 = {
  testId: 'cf-ui-copy-button',
  tooltipText: /*#__PURE__*/React.createElement(React.Fragment, null, "Copy to ", /*#__PURE__*/React.createElement("br", null), " clipboard"),
  tooltipCopiedText: 'Copied!'
};
var CopyButton = /*#__PURE__*/function (_Component) {
  _inherits(CopyButton, _Component);

  var _super = _createSuper$9(CopyButton);

  function CopyButton() {
    var _this;

    _classCallCheck(this, CopyButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      copied: false
    });

    _defineProperty(_assertThisInitialized(_this), "copyButton", null);

    _defineProperty(_assertThisInitialized(_this), "tooltipAnchor", null);

    _defineProperty(_assertThisInitialized(_this), "onCopy", function (e) {
      if (_this.props.onCopy) {
        _this.props.onCopy(e);
      }

      _this.setState({
        copied: true
      });

      setTimeout(function () {
        _this.setState({
          copied: false
        });

        if (_this.copyButton) {
          _this.copyButton.blur();
        }
      }, 1000);
    });

    return _this;
  }

  _createClass(CopyButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          copyValue = _this$props.copyValue,
          className = _this$props.className,
          testId = _this$props.testId,
          onCopy = _this$props.onCopy,
          tooltipPlace = _this$props.tooltipPlace,
          tooltipText = _this$props.tooltipText,
          tooltipCopiedText = _this$props.tooltipCopiedText,
          otherProps = _objectWithoutProperties(_this$props, ["copyValue", "className", "testId", "onCopy", "tooltipPlace", "tooltipText", "tooltipCopiedText"]);

      var classNames = classnames(styles$9['CopyButton'], className);
      return /*#__PURE__*/React.createElement("div", _extends({
        ref: function ref(_ref2) {
          _this2.tooltipAnchor = _ref2;
        },
        className: classNames,
        id: "copyButton",
        "data-test-id": testId
      }, otherProps), /*#__PURE__*/React.createElement(lib, {
        text: copyValue || '',
        onCopy: this.onCopy
      }, /*#__PURE__*/React.createElement(Tooltip, {
        place: tooltipPlace,
        content: this.state.copied ? tooltipCopiedText : /*#__PURE__*/React.createElement("span", null, tooltipText)
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        ref: function ref(_ref) {
          _this2.copyButton = _ref;
        },
        className: styles$9['CopyButton__button']
      }, /*#__PURE__*/React.createElement(TabFocusTrap, {
        className: styles$9['CopyButton__TabFocusTrap']
      }, /*#__PURE__*/React.createElement("span", {
        className: styles$9['CopyButton__text']
      }, "Copy ", copyValue, " to clipboard"), /*#__PURE__*/React.createElement(Icon, {
        icon: "Copy",
        color: "muted"
      }))))));
    }
  }]);

  return CopyButton;
}(Component$1);
CopyButton.displayName = "CopyButton";

_defineProperty(CopyButton, "propTypes", {
  copyValue: propTypes.string,
  onCopy: propTypes.func,
  className: propTypes.string,
  testId: propTypes.string,
  tooltipPlace: propTypes.any,
  tooltipText: propTypes.node,
  tooltipCopiedText: propTypes.node
});

_defineProperty(CopyButton, "defaultProps", defaultProps$8);

function _createSuper$a(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$a()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$a = {
  "TextInput": "TextInput__TextInput___36-K-",
  "TextInput__input": "TextInput__TextInput__input___27vDB a11y__focus-border--default___60AXp",
  "TextInput--small": "TextInput__TextInput--small___19AFQ",
  "TextInput--medium": "TextInput__TextInput--medium___1bR2D",
  "TextInput--large": "TextInput__TextInput--large___KwY4O",
  "TextInput--full": "TextInput__TextInput--full___1EJEW",
  "TextInput--disabled": "TextInput__TextInput--disabled___2t7VS",
  "TextInput--negative": "TextInput__TextInput--negative___iVq__",
  "TextInput__copy-button": "TextInput__TextInput__copy-button___3Sy2W"
};
var defaultProps$9 = {
  withCopyButton: false,
  testId: 'cf-ui-text-input',
  disabled: false,
  isReadOnly: false,
  required: false,
  width: 'full',
  willBlurOnEsc: true
};
var TextInput = /*#__PURE__*/function (_Component) {
  _inherits(TextInput, _Component);

  var _super = _createSuper$a(TextInput);

  function TextInput() {
    var _this;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.value
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      if (_this.props.disabled) {
        e.target.select();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var ESC = 27;

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }

      if (e.keyCode === ESC && _this.props.willBlurOnEsc) {
        e.currentTarget.blur();
      }
    });

    return _this;
  }

  _createClass(TextInput, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cn,
          _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          withCopyButton = _this$props.withCopyButton,
          placeholder = _this$props.placeholder,
          maxLength = _this$props.maxLength,
          disabled = _this$props.disabled,
          required = _this$props.required,
          isReadOnly = _this$props.isReadOnly,
          _onChange = _this$props.onChange,
          testId = _this$props.testId,
          onBlur = _this$props.onBlur,
          onCopy = _this$props.onCopy,
          error = _this$props.error,
          width = _this$props.width,
          value = _this$props.value,
          type = _this$props.type,
          name = _this$props.name,
          id = _this$props.id,
          inputRef = _this$props.inputRef,
          willBlurOnEsc = _this$props.willBlurOnEsc,
          otherProps = _objectWithoutProperties(_this$props, ["className", "withCopyButton", "placeholder", "maxLength", "disabled", "required", "isReadOnly", "onChange", "testId", "onBlur", "onCopy", "error", "width", "value", "type", "name", "id", "inputRef", "willBlurOnEsc"]);

      var widthClass = "TextInput--".concat(width);
      var classNames = classnames(styles$a['TextInput'], className, styles$a[widthClass], (_cn = {}, _defineProperty(_cn, styles$a['TextInput--disabled'], disabled), _defineProperty(_cn, styles$a['TextInput--negative'], error), _cn));
      return /*#__PURE__*/React.createElement("div", {
        className: classNames
      }, /*#__PURE__*/React.createElement("input", _extends({
        onKeyDown: this.handleKeyDown,
        "aria-label": name,
        className: styles$a['TextInput__input'],
        id: id,
        name: name,
        required: required,
        placeholder: placeholder,
        maxLength: maxLength,
        "data-test-id": testId,
        disabled: disabled,
        onBlur: onBlur,
        onFocus: this.handleFocus,
        onChange: function onChange(e) {
          if (disabled || isReadOnly) return;

          if (_onChange) {
            _onChange(e);
          }

          _this2.setState({
            value: e.target.value
          });
        },
        value: this.state.value,
        type: type,
        ref: inputRef
      }, otherProps)), withCopyButton && /*#__PURE__*/React.createElement(CopyButton, {
        onCopy: onCopy,
        copyValue: this.state.value,
        className: styles$a['TextInput__copy-button']
      }));
    }
  }]);

  return TextInput;
}(Component$1);
TextInput.displayName = "TextInput";

_defineProperty(TextInput, "propTypes", {
  width: propTypes.oneOf(['small', 'medium', 'large', 'full']),
  isReadOnly: propTypes.bool,
  type: propTypes.oneOf(['text', 'password', 'email', 'number', 'search', 'url', 'date', 'time']),
  name: propTypes.string,
  id: propTypes.string,
  className: propTypes.string,
  withCopyButton: propTypes.bool,
  testId: propTypes.string,
  onCopy: propTypes.func,
  value: propTypes.string,
  inputRef: propTypes.any,
  error: propTypes.bool,
  willBlurOnEsc: propTypes.bool.isRequired
});

_defineProperty(TextInput, "defaultProps", defaultProps$9);

function _createSuper$b(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$b()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$b = {
  "Textarea": "Textarea__Textarea___qcph7",
  "Textarea__textarea": "Textarea__Textarea__textarea___30c64 a11y__focus-border--default___60AXp",
  "Textarea--small": "Textarea__Textarea--small___3duGT",
  "Textarea--medium": "Textarea__Textarea--medium___2ylrR",
  "Textarea--large": "Textarea__Textarea--large___2jIb0",
  "Textarea--full": "Textarea__Textarea--full___1OW4s",
  "Textarea--disabled": "Textarea__Textarea--disabled___2tLQn",
  "Textarea--negative": "Textarea__Textarea--negative___1RyoO"
};
var defaultProps$a = {
  testId: 'cf-ui-textarea',
  disabled: false,
  required: false,
  width: 'full',
  willBlurOnEsc: true
};
var Textarea = /*#__PURE__*/function (_Component) {
  _inherits(Textarea, _Component);

  var _super = _createSuper$b(Textarea);

  function Textarea() {
    var _this;

    _classCallCheck(this, Textarea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.value
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var ESC = 27;

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }

      if (e.keyCode === ESC && _this.props.willBlurOnEsc) {
        e.currentTarget.blur();
      }
    });

    return _this;
  }

  _createClass(Textarea, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cn,
          _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          testId = _this$props.testId,
          placeholder = _this$props.placeholder,
          maxLength = _this$props.maxLength,
          _onChange = _this$props.onChange,
          disabled = _this$props.disabled,
          required = _this$props.required,
          onBlur = _this$props.onBlur,
          error = _this$props.error,
          width = _this$props.width,
          value = _this$props.value,
          name = _this$props.name,
          rows = _this$props.rows,
          id = _this$props.id,
          willBlurOnEsc = _this$props.willBlurOnEsc,
          textareaRef = _this$props.textareaRef,
          otherProps = _objectWithoutProperties(_this$props, ["className", "testId", "placeholder", "maxLength", "onChange", "disabled", "required", "onBlur", "error", "width", "value", "name", "rows", "id", "willBlurOnEsc", "textareaRef"]);

      var widthClass = "Textarea--".concat(width);
      var classNames = classnames(styles$b['Textarea'], className, styles$b[widthClass], (_cn = {}, _defineProperty(_cn, styles$b['Textarea--disabled'], disabled), _defineProperty(_cn, styles$b['Textarea--negative'], error), _cn));
      return /*#__PURE__*/React.createElement("div", {
        className: classNames
      }, /*#__PURE__*/React.createElement("textarea", _extends({
        "data-test-id": testId,
        "aria-label": name,
        className: styles$b['Textarea__textarea'],
        id: id,
        rows: rows,
        onBlur: onBlur,
        disabled: disabled,
        placeholder: placeholder,
        name: name,
        onChange: function onChange(e) {
          if (_onChange) {
            _onChange(e);
          }

          _this2.setState({
            value: e.target.value
          });
        },
        maxLength: maxLength,
        value: disabled ? value : this.state && this.state.value,
        onKeyDown: this.handleKeyDown,
        ref: textareaRef
      }, otherProps)));
    }
  }]);

  return Textarea;
}(Component$1);
Textarea.displayName = "Textarea";

_defineProperty(Textarea, "propTypes", {
  name: propTypes.string,
  id: propTypes.string,
  testId: propTypes.string,
  placeholder: propTypes.string,
  className: propTypes.string,
  width: propTypes.oneOf(['small', 'medium', 'large', 'full']),
  maxLength: propTypes.number,
  required: propTypes.bool,
  disabled: propTypes.bool,
  value: propTypes.string,
  rows: propTypes.number,
  error: propTypes.bool,
  onChange: propTypes.func,
  onBlur: propTypes.func,
  onFocus: propTypes.func,
  onKeyPress: propTypes.func,
  onKeyDown: propTypes.func,
  onKeyUp: propTypes.func,
  willBlurOnEsc: propTypes.bool.isRequired,
  textareaRef: propTypes.any
});

_defineProperty(Textarea, "defaultProps", defaultProps$a);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$c(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$c()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$c = {
  "TextField": "TextField__TextField___Sf6eo",
  "TextField--small": "TextField__TextField--small___13h4C",
  "TextField--medium": "TextField__TextField--medium___1bB-F",
  "TextField--large": "TextField__TextField--large___3GaTm",
  "TextField--full": "TextField__TextField--full___11DBK",
  "TextField__label-wrapper": "TextField__TextField__label-wrapper___2-MJT",
  "TextField__label-link": "TextField__TextField__label-link___u94cw",
  "TextField__validation-message": "TextField__TextField__validation-message___1Idkl",
  "TextField__help-text": "TextField__TextField__help-text___p4rVf",
  "TextField__hints": "TextField__TextField__hints___3Di2P",
  "TextField__count": "TextField__TextField__count___jiTTs"
};
var defaultProps$b = {
  testId: 'cf-ui-text-field',
  textarea: false,
  required: false,
  countCharacters: false,
  width: 'full'
};
var TextField = /*#__PURE__*/function (_Component) {
  _inherits(TextField, _Component);

  var _super = _createSuper$c(TextField);

  function TextField() {
    var _this;

    _classCallCheck(this, TextField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.value || '',
      initialValue: _this.props.value
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (evt) {
      _this.setState({
        value: evt.target.value
      });

      if (_this.props.onChange) _this.props.onChange(evt);
    });

    return _this;
  }

  _createClass(TextField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          validationMessage = _this$props.validationMessage,
          className = _this$props.className,
          textInputProps = _this$props.textInputProps,
          testId = _this$props.testId,
          width = _this$props.width,
          formLabelProps = _this$props.formLabelProps,
          textLinkProps = _this$props.textLinkProps,
          labelText = _this$props.labelText,
          helpText = _this$props.helpText,
          textarea = _this$props.textarea,
          countCharacters = _this$props.countCharacters,
          required = _this$props.required,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          value = _this$props.value,
          name = _this$props.name,
          id = _this$props.id,
          otherProps = _objectWithoutProperties(_this$props, ["validationMessage", "className", "textInputProps", "testId", "width", "formLabelProps", "textLinkProps", "labelText", "helpText", "textarea", "countCharacters", "required", "onChange", "onBlur", "onFocus", "value", "name", "id"]);

      var widthClass = "TextField--".concat(width);
      var classNames = classnames(styles$c['TextField'], styles$c[widthClass], className); // eslint-disable-next-line @typescript-eslint/no-explicit-any

      var Element = textarea ? Textarea : TextInput;
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames
      }, otherProps, {
        "data-test-id": testId
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$c['TextField__label-wrapper']
      }, /*#__PURE__*/React.createElement(FormLabel, _extends({}, formLabelProps, {
        htmlFor: id,
        required: required
      }), labelText), textLinkProps && /*#__PURE__*/React.createElement(TextLink, _objectSpread$1({}, textLinkProps, {
        className: styles$c['TextField__label-link']
      }), textLinkProps.text)), /*#__PURE__*/React.createElement(Element, _objectSpread$1({
        error: !!validationMessage,
        name: name,
        id: id,
        onBlur: onBlur,
        onFocus: onFocus,
        onChange: this.handleOnChange,
        value: value,
        required: required
      }, textInputProps, {
        width: 'full'
      })), validationMessage && /*#__PURE__*/React.createElement(ValidationMessage, {
        className: styles$c['TextField__validation-message']
      }, validationMessage), (helpText || countCharacters) && /*#__PURE__*/React.createElement("div", {
        className: styles$c['TextField__hints']
      }, helpText && /*#__PURE__*/React.createElement(HelpText, {
        className: styles$c['TextField__help-text']
      }, helpText), countCharacters && textInputProps && textInputProps.maxLength && /*#__PURE__*/React.createElement(HelpText, {
        className: classnames(styles$c['TextField__help-text'], styles$c['TextField__count'])
      }, this.state.value ? this.state.value.length : 0, "/", textInputProps.maxLength)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.value !== state.initialValue) {
        return _objectSpread$1({}, state, {
          value: props.value,
          initialValue: props.value
        });
      }

      return state;
    }
  }]);

  return TextField;
}(Component$1);
TextField.displayName = "TextField";

_defineProperty(TextField, "propTypes", {
  name: propTypes.string.isRequired,
  id: propTypes.string.isRequired,
  width: propTypes.string,
  labelText: propTypes.string.isRequired,
  value: propTypes.string,
  validationMessage: propTypes.string,
  testId: propTypes.string,
  className: propTypes.string,
  formLabelProps: propTypes.any,
  textLinkProps: propTypes.any,
  textInputProps: propTypes.oneOfType([propTypes.any, propTypes.any]),
  helpText: propTypes.string,
  required: propTypes.bool,
  textarea: propTypes.bool,
  countCharacters: propTypes.bool,
  onChange: propTypes.func,
  onBlur: propTypes.func,
  onFocus: propTypes.func
});

_defineProperty(TextField, "defaultProps", defaultProps$b);

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$d(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$d()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$d = {
  "Card": "Card__Card___1_26G",
  "Card--padding-default": "Card__Card--padding-default___xgDF9",
  "Card--padding-large": "Card__Card--padding-large___2KzUK",
  "Card--padding-none": "Card__Card--padding-none___1_Xu1",
  "Card--is-interactive": "Card__Card--is-interactive___3nFqr",
  "Card--is-selected": "Card__Card--is-selected___IBDSP"
};
var defaultProps$c = {
  padding: 'default',
  testId: 'cf-ui-card',
  selected: false
};
var Card = /*#__PURE__*/function (_Component) {
  _inherits(Card, _Component);

  var _super = _createSuper$d(Card);

  function Card() {
    var _this;

    _classCallCheck(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      if (!_this.props.onClick) return;

      _this.props.onClick(event);
    });

    return _this;
  }

  _createClass(Card, [{
    key: "render",
    value: function render() {
      var _cn;

      var _this$props = this.props,
          className = _this$props.className,
          testId = _this$props.testId,
          children = _this$props.children,
          href = _this$props.href,
          onClick = _this$props.onClick,
          padding = _this$props.padding,
          selected = _this$props.selected,
          otherProps = _objectWithoutProperties(_this$props, ["className", "testId", "children", "href", "onClick", "padding", "selected"]);

      var classNames = classnames(styles$d.Card, className, (_cn = {}, _defineProperty(_cn, styles$d["Card--padding-".concat(padding)], padding), _defineProperty(_cn, styles$d['Card--is-interactive'], onClick || href), _defineProperty(_cn, styles$d['Card--is-selected'], selected), _cn));
      var Element = href ? 'a' : 'div';
      return React.createElement(Element, _objectSpread$2({
        href: href,
        className: classNames,
        onClick: this.handleClick,
        'data-test-id': testId
      }, otherProps), children);
    }
  }]);

  return Card;
}(Component$1);
Card.displayName = "Card";

_defineProperty(Card, "propTypes", {
  href: propTypes.string,
  onClick: propTypes.func,
  padding: propTypes.oneOf(['default', 'large', 'none']),
  selected: propTypes.bool,
  title: propTypes.string,
  style: propTypes.any,
  className: propTypes.string,
  testId: propTypes.string,
  children: propTypes.node.isRequired
});

_defineProperty(Card, "defaultProps", defaultProps$c);

function _createSuper$e(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$e()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$e = {
  "DropdownListItem": "DropdownListItem__DropdownListItem___LOUnP",
  "DropdownListItem__button": "DropdownListItem__DropdownListItem__button___1Po6h a11y__focus-outline--default___2hwb1",
  "DropdownListItem__submenu-toggle": "DropdownListItem__DropdownListItem__submenu-toggle___1SVw1",
  "DropdownListItem__button__inner-wrapper": "DropdownListItem__DropdownListItem__button__inner-wrapper___LFlkP",
  "DropdownListItem--disabled": "DropdownListItem__DropdownListItem--disabled___1txXv",
  "DropdownListItem--active": "DropdownListItem__DropdownListItem--active___21eet",
  "DropdownListItem--title": "DropdownListItem__DropdownListItem--title___CyVKB"
};
var defaultProps$d = {
  testId: 'cf-ui-dropdown-list-item',
  isDisabled: false,
  isActive: false,
  isTitle: false
};
var DropdownListItem = /*#__PURE__*/function (_Component) {
  _inherits(DropdownListItem, _Component);

  var _super = _createSuper$e(DropdownListItem);

  function DropdownListItem() {
    var _this;

    _classCallCheck(this, DropdownListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderSubmenuToggle", function () {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onEnter = _this$props.onEnter,
          onLeave = _this$props.onLeave,
          onFocus = _this$props.onFocus,
          children = _this$props.children,
          submenuToggleLabel = _this$props.submenuToggleLabel,
          testId = _this$props.testId,
          isDisabled = _this$props.isDisabled,
          isActive = _this$props.isActive,
          isTitle = _this$props.isTitle,
          otherProps = _objectWithoutProperties(_this$props, ["onClick", "onEnter", "onLeave", "onFocus", "children", "submenuToggleLabel", "testId", "isDisabled", "isActive", "isTitle"]);

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", _extends({
        type: "button",
        "data-test-id": "cf-ui-dropdown-submenu-toggle",
        className: styles$e['DropdownListItem__button'],
        onClick: onClick,
        onMouseEnter: onEnter,
        onFocus: onFocus,
        onMouseLeave: onLeave
      }, otherProps), /*#__PURE__*/React.createElement(TabFocusTrap, {
        className: styles$e['DropdownListItem__button__inner-wrapper']
      }, submenuToggleLabel)), children);
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function () {
      var _this$props2 = _this.props,
          _onClick = _this$props2.onClick,
          _onMouseDown = _this$props2.onMouseDown,
          href = _this$props2.href,
          isDisabled = _this$props2.isDisabled,
          children = _this$props2.children,
          isTitle = _this$props2.isTitle,
          isActive = _this$props2.isActive,
          testId = _this$props2.testId,
          listItemRef = _this$props2.listItemRef,
          otherProps = _objectWithoutProperties(_this$props2, ["onClick", "onMouseDown", "href", "isDisabled", "children", "isTitle", "isActive", "testId", "listItemRef"]);

      var isClickable = _onClick || _onMouseDown || href;

      if (isClickable) {
        var Element = href ? 'a' : 'button';
        var buttonProps = {
          disabled: isDisabled,
          'aria-disabled': isDisabled
        };
        var linkProps = {
          href: href
        };
        return /*#__PURE__*/React.createElement(Element, _extends({
          type: "button",
          onClick: function onClick(e) {
            if (!isDisabled && _onClick) {
              _onClick(e);
            }
          },
          onMouseDown: function onMouseDown(e) {
            if (!isDisabled && _onMouseDown) {
              _onMouseDown(e);
            }
          }
        }, href ? linkProps : buttonProps, otherProps, {
          "data-test-id": "cf-ui-dropdown-list-item-button",
          className: styles$e['DropdownListItem__button']
        }), /*#__PURE__*/React.createElement(TabFocusTrap, {
          className: styles$e['DropdownListItem__button__inner-wrapper']
        }, children));
      }

      return /*#__PURE__*/React.createElement("span", otherProps, children);
    });

    return _this;
  }

  _createClass(DropdownListItem, [{
    key: "render",
    value: function render() {
      var _cn;

      var _this$props3 = this.props,
          className = _this$props3.className,
          isDisabled = _this$props3.isDisabled,
          testId = _this$props3.testId,
          listItemRef = _this$props3.listItemRef,
          isActive = _this$props3.isActive,
          onClick = _this$props3.onClick,
          onMouseDown = _this$props3.onMouseDown,
          href = _this$props3.href,
          submenuToggleLabel = _this$props3.submenuToggleLabel,
          isTitle = _this$props3.isTitle;
      var classNames = classnames(styles$e['DropdownListItem'], className, (_cn = {}, _defineProperty(_cn, styles$e['DropdownListItem__submenu-toggle'], submenuToggleLabel || onClick || onMouseDown || href), _defineProperty(_cn, styles$e['DropdownListItem--disabled'], isDisabled), _defineProperty(_cn, styles$e['DropdownListItem--active'], isActive), _defineProperty(_cn, styles$e['DropdownListItem--title'], isTitle), _cn));
      return /*#__PURE__*/React.createElement("li", {
        className: classNames,
        "data-test-id": testId,
        ref: listItemRef,
        role: "menuitem"
      }, submenuToggleLabel ? this.renderSubmenuToggle() : this.renderListItem());
    }
  }]);

  return DropdownListItem;
}(Component$1);
DropdownListItem.displayName = "DropdownListItem";

_defineProperty(DropdownListItem, "propTypes", {
  isDisabled: propTypes.bool.isRequired,
  listItemRef: propTypes.any,
  isActive: propTypes.bool.isRequired,
  isTitle: propTypes.bool.isRequired,
  children: propTypes.node.isRequired,
  onClick: propTypes.func,
  onMouseDown: propTypes.func,
  submenuToggleLabel: propTypes.string,
  href: propTypes.string,
  onFocus: propTypes.func,
  onLeave: propTypes.func,
  onEnter: propTypes.func,
  className: propTypes.string,
  testId: propTypes.string
});

_defineProperty(DropdownListItem, "defaultProps", defaultProps$d);

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$f(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$f()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$f = {
  "DropdownContainer": "DropdownContainer__DropdownContainer___3WlJM",
  "DropdownContainer__submenu": "DropdownContainer__DropdownContainer__submenu___32iPV",
  "DropdownContainer__container-position--right": "DropdownContainer__DropdownContainer__container-position--right___1EoB6",
  "DropdownContainer__container-position--left": "DropdownContainer__DropdownContainer__container-position--left___3dbcX"
};
var defaultProps$e = {
  testId: 'cf-ui-dropdown-portal',
  position: 'bottom-left',
  submenu: false,
  isAutoalignmentEnabled: true,
  getRef: function getRef() {}
};

var DropdownContainer = /*#__PURE__*/function (_Component) {
  _inherits(DropdownContainer, _Component);

  var _super = _createSuper$f(DropdownContainer);

  function DropdownContainer() {
    var _this;

    _classCallCheck(this, DropdownContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "portalTarget", document.createElement('div'));

    _defineProperty(_assertThisInitialized(_this), "dropdown", null);

    _defineProperty(_assertThisInitialized(_this), "lastOverflowAt", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      position: _this.props.position,
      dropdownDimensions: {
        width: 0,
        height: 0
      }
    });

    _defineProperty(_assertThisInitialized(_this), "trackOutsideClick", function (e) {
      if (_this.dropdown && !_this.dropdown.contains(e.target) && _this.props.dropdownAnchor && !_this.props.dropdownAnchor.contains(e.target)) {
        if (_this.props.onClose) {
          _this.props.onClose();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOverflow", function (overflowAt) {
      if (!_this.props.isAutoalignmentEnabled) {
        return;
      }

      if (overflowAt === _this.lastOverflowAt) {
        return;
      }

      var resolutions = {
        right: {
          'bottom-left': 'bottom-right',
          'top-left': 'top-right',
          right: 'left'
        },
        left: {
          'bottom-right': 'bottom-left',
          'top-right': 'top-left',
          left: 'right'
        },
        top: {
          'top-left': 'bottom-left',
          'top-right': 'bottom-right'
        },
        bottom: {
          'bottom-left': 'top-left',
          'bottom-right': 'top-right'
        }
      };
      var currentPosition = _this.state.position;
      var resolution = resolutions[overflowAt][currentPosition];

      if (resolution) {
        _this.setState({
          position: resolution
        }, function () {
          _this.lastOverflowAt = overflowAt;
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calculatePosition", function () {
      var anchorDimensionsAndPositon = _this.props.anchorDimensionsAndPositon;
      var _this$state = _this.state,
          dropdownDimensions = _this$state.dropdownDimensions,
          position = _this$state.position;

      if (!anchorDimensionsAndPositon || !dropdownDimensions) {
        return false;
      }

      switch (position) {
        case 'bottom-left':
          return {
            top: anchorDimensionsAndPositon.top + anchorDimensionsAndPositon.height,
            left: anchorDimensionsAndPositon.left
          };

        case 'top-left':
          return {
            bottom: window.innerHeight - anchorDimensionsAndPositon.top,
            left: anchorDimensionsAndPositon.left
          };

        case 'bottom-right':
          return {
            top: anchorDimensionsAndPositon.top + anchorDimensionsAndPositon.height,
            left: anchorDimensionsAndPositon.left - (dropdownDimensions.width - anchorDimensionsAndPositon.width)
          };

        case 'top-right':
          return {
            bottom: window.innerHeight - anchorDimensionsAndPositon.top,
            left: anchorDimensionsAndPositon.left - (dropdownDimensions.width - anchorDimensionsAndPositon.width)
          };
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSubmenuClassNames", function () {
      return classnames(styles$f['DropdownContainer__submenu'], styles$f["DropdownContainer__container-position--".concat(_this.state.position)]);
    });

    return _this;
  }

  _createClass(DropdownContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.appendChild(this.portalTarget);

      if (this.dropdown) {
        var dropdownRect = this.dropdown.getBoundingClientRect();
        this.setState({
          dropdownDimensions: {
            width: dropdownRect.width,
            height: dropdownRect.height
          }
        });
      }

      document.addEventListener('mousedown', this.trackOutsideClick, true);
      this.props.getRef(this.dropdown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!this.dropdown) {
        return;
      }

      var dropdownRect = this.dropdown.getBoundingClientRect();

      if (dropdownRect.width !== prevState.dropdownDimensions.width || dropdownRect.height !== prevState.dropdownDimensions.height) {
        this.setState({
          dropdownDimensions: {
            width: dropdownRect.width,
            height: dropdownRect.height
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeChild(this.portalTarget);
      document.removeEventListener('mousedown', this.trackOutsideClick, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          submenu = _this$props.submenu,
          className = _this$props.className,
          width = _this$props.width,
          testId = _this$props.testId;
      var classNames = classnames(className, styles$f['DropdownContainer'], submenu ? this.getSubmenuClassNames() : '');
      var dropdown = /*#__PURE__*/React.createElement("div", {
        ref: function (_ref) {
          function ref(_x) {
            return _ref.apply(this, arguments);
          }

          ref.toString = function () {
            return _ref.toString();
          };

          return ref;
        }(function (ref) {
          _this2.dropdown = ref;
        }),
        "data-test-id": testId,
        style: _objectSpread$3({}, width ? {
          width: "".concat(width, "px")
        } : {}, {}, !submenu && this.calculatePosition()),
        className: classNames,
        onMouseEnter: function onMouseEnter() {
          if (_this2.props.openSubmenu) {
            _this2.props.openSubmenu(true);
          }
        },
        onFocus: function onFocus() {
          if (_this2.props.openSubmenu) {
            _this2.props.openSubmenu(true);
          }
        },
        onMouseLeave: function onMouseLeave() {
          if (_this2.props.openSubmenu) {
            _this2.props.openSubmenu(false);
          }
        }
      }, /*#__PURE__*/React.createElement(InViewport, {
        onOverflowLeft: function onOverflowLeft() {
          return _this2.handleOverflow('left');
        },
        onOverflowRight: function onOverflowRight() {
          return _this2.handleOverflow('right');
        },
        onOverflowTop: function onOverflowTop() {
          return _this2.handleOverflow('top');
        },
        onOverflowBottom: function onOverflowBottom() {
          return _this2.handleOverflow('bottom');
        }
      }, this.props.children));
      return submenu ? dropdown : ReactDOM.createPortal(dropdown, this.portalTarget);
    }
  }]);

  return DropdownContainer;
}(Component$1);

DropdownContainer.displayName = "DropdownContainer";

_defineProperty(DropdownContainer, "propTypes", {
  onClose: propTypes.any,
  dropdownAnchor: propTypes.oneOfType([propTypes.any, propTypes.oneOf([null])]),
  className: propTypes.string,
  children: propTypes.node,
  testId: propTypes.string,
  openSubmenu: propTypes.func,
  anchorDimensionsAndPositon: propTypes.any,
  position: propTypes.any.isRequired,
  getRef: propTypes.func,
  submenu: propTypes.bool,
  width: propTypes.oneOfType([propTypes.number, propTypes.oneOf([false])]),
  isAutoalignmentEnabled: propTypes.bool
});

_defineProperty(DropdownContainer, "defaultProps", defaultProps$e);

function _createSuper$g(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$g()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$g = {
  "Dropdown": "Dropdown__Dropdown___nAsJ-"
};
var defaultProps$f = {
  testId: 'cf-ui-dropdown',
  position: 'bottom-left',
  isOpen: false,
  isAutoalignmentEnabled: true,
  getContainerRef: function getContainerRef() {}
};
var Dropdown = /*#__PURE__*/function (_Component) {
  _inherits(Dropdown, _Component);

  var _super = _createSuper$g(Dropdown);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "toggleElementWrapper", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: _this.props.isOpen,
      position: _this.props.position,
      anchorDimensionsAndPositon: {
        top: 0,
        left: 0,
        height: 0,
        width: 0
      }
    });

    _defineProperty(_assertThisInitialized(_this), "dropdownAnchor", null);

    _defineProperty(_assertThisInitialized(_this), "setAnchorDimensions", function () {
      if (_this.dropdownAnchor) {
        var dropdownAnchorRect = _this.dropdownAnchor.getBoundingClientRect();

        _this.setState({
          anchorDimensionsAndPositon: {
            top: dropdownAnchorRect.top,
            left: dropdownAnchorRect.left,
            width: dropdownAnchorRect.width,
            height: dropdownAnchorRect.height
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "bindEventListeners", function () {
      if (_this.state.isOpen) {
        document.addEventListener('keydown', _this.handleEscapeKey, true);
        window.addEventListener('resize', _this.setAnchorDimensions, true);
        document.addEventListener('scroll', _this.setAnchorDimensions, true);
      } else {
        document.removeEventListener('keydown', _this.handleEscapeKey, true);
        window.removeEventListener('resize', _this.setAnchorDimensions, true);
        document.removeEventListener('scroll', _this.setAnchorDimensions, true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openMenu", function (isOpen) {
      _this.setState({
        isOpen: isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEscapeKey", function (event) {
      var ESCAPE_KEYCODE = 27;

      if (event.keyCode === ESCAPE_KEYCODE) {
        event.stopPropagation();

        _this.setState({
          isOpen: false
        });

        if (_this.props.onClose) {
          _this.props.onClose();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openSubmenu", function (isOpen) {
      if (_this.props.submenuToggleLabel) {
        _this.openMenu(isOpen);
      }
    });

    return _this;
  }

  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!isBrowser) {
        return;
      }

      this.setAnchorDimensions();
      this.bindEventListeners();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      this.setState({
        isOpen: newProps.isOpen
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isBrowser) {
        return;
      }

      if (prevProps.isOpen !== this.props.isOpen) {
        this.setAnchorDimensions();
      }

      this.bindEventListeners();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!isBrowser) {
        return;
      }

      document.removeEventListener('keydown', this.handleEscapeKey, true);
      window.removeEventListener('resize', this.setAnchorDimensions, true);
      document.removeEventListener('scroll', this.setAnchorDimensions, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          toggleElement = _this$props.toggleElement,
          testId = _this$props.testId,
          submenuToggleLabel = _this$props.submenuToggleLabel,
          getContainerRef = _this$props.getContainerRef,
          dropdownContainerClassName = _this$props.dropdownContainerClassName,
          children = _this$props.children,
          isOpen = _this$props.isOpen,
          isAutoalignmentEnabled = _this$props.isAutoalignmentEnabled,
          isFullWidth = _this$props.isFullWidth,
          otherProps = _objectWithoutProperties(_this$props, ["className", "toggleElement", "testId", "submenuToggleLabel", "getContainerRef", "dropdownContainerClassName", "children", "isOpen", "isAutoalignmentEnabled", "isFullWidth"]);

      var classNames = classnames(styles$g['Dropdown'], className);
      var width = isFullWidth && this.state.anchorDimensionsAndPositon.width;
      var containerTestId = testId ? "".concat(testId, "-container") : testId;
      return submenuToggleLabel ? /*#__PURE__*/React.createElement(DropdownListItem, _extends({
        testId: testId,
        submenuToggleLabel: submenuToggleLabel,
        onEnter: function onEnter() {
          return _this2.openMenu(true);
        },
        onLeave: function onLeave() {
          return _this2.openMenu(false);
        }
      }, otherProps), toggleElement && React.cloneElement(toggleElement, {
        'aria-haspopup': 'menu',
        'aria-expanded': this.state.isOpen
      }), this.state.isOpen && /*#__PURE__*/React.createElement(DropdownContainer, {
        anchorDimensionsAndPositon: this.state.anchorDimensionsAndPositon,
        position: this.props.position,
        width: width,
        className: dropdownContainerClassName,
        getRef: getContainerRef,
        dropdownAnchor: this.dropdownAnchor,
        onClose: this.props.onClose,
        openSubmenu: this.openSubmenu,
        submenu: true
      }, this.props.children)) : /*#__PURE__*/React.createElement("div", _extends({
        "data-test-id": testId,
        className: classNames,
        ref: function (_ref) {
          function ref(_x) {
            return _ref.apply(this, arguments);
          }

          ref.toString = function () {
            return _ref.toString();
          };

          return ref;
        }(function (ref) {
          if (!submenuToggleLabel) {
            _this2.dropdownAnchor = ref;
          }
        })
      }, otherProps), toggleElement && React.cloneElement(toggleElement, {
        'aria-haspopup': 'menu',
        'aria-expanded': this.state.isOpen
      }), this.state.isOpen && /*#__PURE__*/React.createElement(DropdownContainer, {
        className: dropdownContainerClassName,
        getRef: getContainerRef,
        submenu: false,
        width: width,
        testId: containerTestId,
        dropdownAnchor: this.dropdownAnchor,
        isAutoalignmentEnabled: isAutoalignmentEnabled,
        anchorDimensionsAndPositon: this.state.anchorDimensionsAndPositon,
        onClose: this.props.onClose,
        openSubmenu: this.openSubmenu,
        position: this.props.position
      }, this.props.children));
    }
  }]);

  return Dropdown;
}(Component$1);
Dropdown.displayName = "Dropdown";

_defineProperty(Dropdown, "propTypes", {
  toggleElement: propTypes.element,
  submenuToggleLabel: propTypes.string,
  position: propTypes.oneOf(['top', 'right', 'left', 'bottom-left', 'bottom-right', 'top-right', 'top-left']).isRequired,
  isOpen: propTypes.bool.isRequired,
  onClose: propTypes.any,
  testId: propTypes.string,
  dropdownContainerClassName: propTypes.string,
  getContainerRef: propTypes.func,
  className: propTypes.string,
  children: propTypes.node.isRequired,
  isFullWidth: propTypes.bool,
  isAutoalignmentEnabled: propTypes.bool
});

_defineProperty(Dropdown, "defaultProps", defaultProps$f);

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$h(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$h()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$h = {
  "IconButton": "IconButton__IconButton___1_XeU a11y__focus-outline--default___2hwb1",
  "IconButton__inner": "IconButton__IconButton__inner___3fnmT",
  "IconButton--disabled": "IconButton__IconButton--disabled___1YhDh",
  "IconButton--primary": "IconButton__IconButton--primary___1nYDN",
  "IconButton__icon": "IconButton__IconButton__icon___3yZQN",
  "IconButton--positive": "IconButton__IconButton--positive___HkCX3",
  "IconButton--negative": "IconButton__IconButton--negative___dW81q",
  "IconButton--secondary": "IconButton__IconButton--secondary___3Gc3d",
  "IconButton--muted": "IconButton__IconButton--muted___22_IZ",
  "IconButton--white": "IconButton__IconButton--white___3GUQP",
  "IconButton__label": "IconButton__IconButton__label___1kp5y helpers__sr-only___3Kv3z",
  "IconButton__dropdown": "IconButton__IconButton__dropdown___NoDIS"
};
var defaultProps$g = {
  disabled: false,
  testId: 'cf-ui-icon-button',
  buttonType: 'primary',
  withDropdown: false
};
var IconButton = /*#__PURE__*/function (_Component) {
  _inherits(IconButton, _Component);

  var _super = _createSuper$h(IconButton);

  function IconButton() {
    _classCallCheck(this, IconButton);

    return _super.apply(this, arguments);
  }

  _createClass(IconButton, [{
    key: "render",
    value: function render() {
      var _cn;

      var _this$props = this.props,
          label = _this$props.label,
          iconProps = _this$props.iconProps,
          href = _this$props.href,
          testId = _this$props.testId,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          buttonType = _this$props.buttonType,
          withDropdown = _this$props.withDropdown,
          className = _this$props.className,
          otherProps = _objectWithoutProperties(_this$props, ["label", "iconProps", "href", "testId", "disabled", "onClick", "buttonType", "withDropdown", "className"]);

      var classNames = classnames(styles$h.IconButton, className, (_cn = {}, _defineProperty(_cn, styles$h['IconButton--disabled'], disabled), _defineProperty(_cn, styles$h["IconButton--".concat(buttonType)], buttonType), _cn));

      var elementProps = _objectSpread$4({
        className: classNames,
        onClick: !disabled ? onClick : undefined,
        'data-test-id': testId
      }, otherProps);

      var content = /*#__PURE__*/React.createElement(TabFocusTrap, {
        className: styles$h.IconButton__inner
      }, /*#__PURE__*/React.createElement(Icon, _extends({}, iconProps, {
        className: classnames(styles$h.IconButton__icon, iconProps.className)
      })), /*#__PURE__*/React.createElement("span", {
        className: styles$h.IconButton__label
      }, label), withDropdown && /*#__PURE__*/React.createElement(Icon, {
        icon: "ChevronDown",
        color: "secondary",
        className: styles$h.IconButton__dropdown
      }));

      if (href) {
        if (disabled) {
          return /*#__PURE__*/React.createElement("a", elementProps, content);
        }

        return /*#__PURE__*/React.createElement("a", _extends({}, elementProps, {
          href: href
        }), "content");
      }

      return /*#__PURE__*/React.createElement("button", _extends({}, elementProps, {
        type: "button",
        disabled: disabled
      }), content);
    }
  }]);

  return IconButton;
}(Component$1);
IconButton.displayName = "IconButton";

_defineProperty(IconButton, "propTypes", {
  label: propTypes.string.isRequired,
  href: propTypes.string,
  iconProps: propTypes.any.isRequired,
  disabled: propTypes.bool,
  buttonType: propTypes.oneOf(['primary', 'positive', 'negative', 'secondary', 'muted', 'white']),
  withDropdown: propTypes.bool,
  className: propTypes.string,
  testId: propTypes.string
});

_defineProperty(IconButton, "defaultProps", defaultProps$g);

function _createSuper$i(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$i()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$h = {
  testId: 'cf-ui-card-actions',
  isDisabled: false
};
var CardActions = /*#__PURE__*/function (_Component) {
  _inherits(CardActions, _Component);

  var _super = _createSuper$i(CardActions);

  function CardActions() {
    var _this;

    _classCallCheck(this, CardActions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isDropdownOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      _this.setState(function (prevState) {
        return {
          isDropdownOpen: !prevState.isDropdownOpen
        };
      });

      if (_this.props.iconButtonProps && _this.props.iconButtonProps.onClick) {
        event.stopPropagation();
      }
    });

    return _this;
  }

  _createClass(CardActions, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          iconButtonProps = _this$props.iconButtonProps,
          isDisabled = _this$props.isDisabled,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "iconButtonProps", "isDisabled"]);

      return /*#__PURE__*/React.createElement(Dropdown, _extends({
        onClose: function onClose() {
          _this2.setState({
            isDropdownOpen: false
          });
        },
        position: "bottom-right",
        isAutoalignmentEnabled: false,
        className: className,
        isOpen: this.state.isDropdownOpen,
        testId: testId,
        toggleElement: /*#__PURE__*/React.createElement(IconButton, _extends({
          iconProps: {
            icon: 'MoreHorizontal'
          },
          buttonType: "secondary",
          disabled: isDisabled,
          label: "Actions"
        }, iconButtonProps, {
          onClick: function onClick(event) {
            event.preventDefault();

            _this2.handleClick(event);
          }
        }))
      }, otherProps), React.Children.map(children, function (listItems) {
        return React.Children.map(listItems, function (item) {
          // React.Children behaves differently if the object is a Fragment.
          var resolvedChildren = item.type === React.Fragment ? item.props.children : item;
          var enhancedChildren = React.Children.map(resolvedChildren, function (child) {
            return React.cloneElement(child, {
              onClick: function onClick(e) {
                if (child.props.onClick) {
                  child.props.onClick(e);
                }

                _this2.setState({
                  isDropdownOpen: false
                });

                e.stopPropagation();
              }
            });
          });
          return enhancedChildren;
        });
      }));
    }
  }]);

  return CardActions;
}(Component$1);
CardActions.displayName = "CardActions";

_defineProperty(CardActions, "propTypes", {
  className: propTypes.string,
  iconButtonProps: propTypes.any,
  isDisabled: propTypes.bool,
  children: propTypes.oneOfType([propTypes.element, propTypes.arrayOf(propTypes.element)]).isRequired
});

_defineProperty(CardActions, "defaultProps", defaultProps$h);

var truncate = createCommonjsModule(function (module) {
/*global module:true*/
/*jslint nomen:true*/
/**
 * @module Utility
 */
(function (context, undefined$1) {

    var DEFAULT_TRUNCATE_SYMBOL = '…',
        // Limit emails to no more than about 600 chars, well over the max of ~300.
        // cf. RFC: https://www.rfc-editor.org/errata_search.php?eid=1690
        URL_REGEX = /(((ftp|https?):\/\/)[\-\w@:%_\+.~#?,&\/\/=]+)|((mailto:)?[_.\w-]{1,300}@(.{1,300}\.)[a-zA-Z]{2,3})/g;

    function __appendEllipsis(string, options, content) {
        if (content.length === string.length || !options.ellipsis) {
            return content;
        }
        content += options.ellipsis;
        return content;
    }
    /**
     * Truncate HTML string and keep tag safe.
     *
     * @method truncate
     * @param {String} string string needs to be truncated
     * @param {Number} maxLength length of truncated string
     * @param {Object} options (optional)
     * @param {Boolean|String} [options.ellipsis] omission symbol for truncated string, '...' by default
     * @return {String} truncated string
     */
    function truncate(string, maxLength, options) {
        var content = '', // truncated text storage
            matches = true,
            remainingLength = maxLength,
            result,
            index;

        options = options || {};
        options.ellipsis = (typeof options.ellipsis === "undefined") ? DEFAULT_TRUNCATE_SYMBOL : options.ellipsis;

        if (!string || string.length === 0) {
            return '';
        }

        matches = true;
        while (matches) {
            URL_REGEX.lastIndex = content.length;
            matches = URL_REGEX.exec(string);

            if (!matches || (matches.index - content.length) >= remainingLength) {
                content += string.substring(content.length, maxLength);
                return __appendEllipsis(string, options, content);
            }

            result = matches[0];
            index = matches.index;
            content += string.substring(content.length, index + result.length);
            remainingLength -= index + result.length;

            if (remainingLength <= 0) {
                break;
            }
        }

        return __appendEllipsis(string, options, content);
    }

    if ( module.exports) {
        module.exports = truncate;
    } else {
        context.truncate = truncate;
    }
}(String));
});

function _createSuper$j(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$j()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$i = {
  "Tag": "Tag__Tag___Y-myd",
  "Tag--primary": "Tag__Tag--primary___2Hk3I",
  "Tag--positive": "Tag__Tag--positive___1cepi",
  "Tag--negative": "Tag__Tag--negative___12luW",
  "Tag--warning": "Tag__Tag--warning___3Bet2",
  "Tag--secondary": "Tag__Tag--secondary___2vTK0",
  "Tag--muted": "Tag__Tag--muted___1Uba5"
};
var statusTagTypeMap = {
  published: 'positive',
  draft: 'warning',
  archived: 'negative',
  changed: 'primary'
};
var defaultProps$i = {
  tagType: 'primary',
  testId: 'cf-ui-tag'
};
var Tag = /*#__PURE__*/function (_Component) {
  _inherits(Tag, _Component);

  var _super = _createSuper$j(Tag);

  function Tag() {
    _classCallCheck(this, Tag);

    return _super.apply(this, arguments);
  }

  _createClass(Tag, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          tagType = _this$props.tagType,
          entityStatusType = _this$props.entityStatusType,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "tagType", "entityStatusType", "testId"]);

      var classNames = classnames(styles$i.Tag, className, _defineProperty({}, styles$i["Tag--".concat(entityStatusType ? statusTagTypeMap[entityStatusType] : tagType)], entityStatusType ? statusTagTypeMap[entityStatusType] : tagType));
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames,
        "data-test-id": testId
      }, otherProps), children);
    }
  }]);

  return Tag;
}(Component$1);
Tag.displayName = "Tag";

_defineProperty(Tag, "propTypes", {
  tagType: propTypes.oneOf(['primary', 'positive', 'negative', 'warning', 'secondary', 'muted']),
  style: propTypes.any,
  className: propTypes.string,
  testId: propTypes.string,
  children: propTypes.node.isRequired,
  entityStatusType: propTypes.oneOf(['published', 'draft', 'archived', 'changed'])
});

_defineProperty(Tag, "defaultProps", defaultProps$i);

function _createSuper$k(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$k()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$j = {
  "SkeletonContainer": "SkeletonContainer__SkeletonContainer___23jiu"
};
var idCounter = 0;
var defaultProps$j = {
  testId: 'cf-ui-skeleton-form',
  ariaLabel: 'Loading component...',
  width: '100%',
  height: '100%',
  preserveAspectRatio: 'xMidYMid meet',

  get clipId() {
    return "cf-ui-skeleton-clip-".concat(idCounter++);
  },

  get gradientId() {
    return "cf-ui-skeleton-clip-gradient-".concat(idCounter++);
  },

  get animateId() {
    return "animation-".concat(idCounter++);
  },

  backgroundColor: '#e5ebed',
  backgroundOpacity: 1,
  animate: true,
  speed: 2,
  foregroundColor: '#f7f9fa',
  foregroundOpacity: 1,
  svgWidth: '100%',
  svgHeight: '100%'
};
var SkeletonContainer = /*#__PURE__*/function (_Component) {
  _inherits(SkeletonContainer, _Component);

  var _super = _createSuper$k(SkeletonContainer);

  function SkeletonContainer() {
    _classCallCheck(this, SkeletonContainer);

    return _super.apply(this, arguments);
  }

  _createClass(SkeletonContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          ariaLabel = _this$props.ariaLabel,
          width = _this$props.width,
          height = _this$props.height,
          preserveAspectRatio = _this$props.preserveAspectRatio,
          clipId = _this$props.clipId,
          gradientId = _this$props.gradientId,
          animateId = _this$props.animateId,
          backgroundColor = _this$props.backgroundColor,
          backgroundOpacity = _this$props.backgroundOpacity,
          animate = _this$props.animate,
          speed = _this$props.speed,
          foregroundColor = _this$props.foregroundColor,
          foregroundOpacity = _this$props.foregroundOpacity,
          svgWidth = _this$props.svgWidth,
          svgHeight = _this$props.svgHeight,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "ariaLabel", "width", "height", "preserveAspectRatio", "clipId", "gradientId", "animateId", "backgroundColor", "backgroundOpacity", "animate", "speed", "foregroundColor", "foregroundOpacity", "svgWidth", "svgHeight"]);

      var classNames = classnames(styles$j['SkeletonContainer'], className);
      return /*#__PURE__*/React.createElement("svg", _extends({
        role: "img",
        className: classNames,
        "aria-label": ariaLabel,
        preserveAspectRatio: preserveAspectRatio,
        width: svgWidth,
        height: svgHeight,
        "data-test-id": testId
      }, otherProps), ariaLabel ? /*#__PURE__*/React.createElement("title", null, ariaLabel) : null, /*#__PURE__*/React.createElement("rect", {
        x: "0",
        y: "0",
        width: width,
        height: height,
        clipPath: "url(#".concat(clipId, ")"),
        style: {
          fill: "url(#".concat(gradientId, ")")
        }
      }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
        id: clipId
      }, children), /*#__PURE__*/React.createElement("linearGradient", {
        id: gradientId
      }, /*#__PURE__*/React.createElement("stop", {
        offset: "0%",
        stopColor: backgroundColor,
        stopOpacity: backgroundOpacity
      }, animate && /*#__PURE__*/React.createElement("animate", {
        id: animateId,
        attributeName: "stop-color",
        values: "".concat(backgroundColor, "; ").concat(foregroundColor, "; ").concat(backgroundColor),
        dur: "".concat(speed, "s"),
        repeatCount: "indefinite"
      })), /*#__PURE__*/React.createElement("stop", {
        offset: "50%",
        stopColor: foregroundColor,
        stopOpacity: foregroundOpacity
      }, animate && /*#__PURE__*/React.createElement("animate", {
        attributeName: "stop-color",
        values: "".concat(backgroundColor, "; ").concat(foregroundColor, "; ").concat(backgroundColor),
        begin: "".concat(animateId, ".begin+0.25s"),
        dur: "".concat(speed, "s"),
        repeatCount: "indefinite"
      })), /*#__PURE__*/React.createElement("stop", {
        offset: "100%",
        stopColor: backgroundColor,
        stopOpacity: backgroundOpacity
      }, animate && /*#__PURE__*/React.createElement("animate", {
        attributeName: "stop-color",
        begin: "".concat(animateId, ".begin+0.5s"),
        values: "".concat(backgroundColor, "; ").concat(foregroundColor, "; ").concat(backgroundColor),
        dur: "".concat(speed, "s"),
        repeatCount: "indefinite"
      })))));
    }
  }]);

  return SkeletonContainer;
}(Component$1);
SkeletonContainer.displayName = "SkeletonContainer";

_defineProperty(SkeletonContainer, "propTypes", {
  width: propTypes.oneOfType([propTypes.number, propTypes.string]),
  height: propTypes.oneOfType([propTypes.number, propTypes.string]),
  preserveAspectRatio: propTypes.string,
  clipId: propTypes.string,
  gradientId: propTypes.string,
  animateId: propTypes.string,
  backgroundColor: propTypes.string,
  backgroundOpacity: propTypes.number,
  animate: propTypes.bool,
  speed: propTypes.oneOfType([propTypes.number, propTypes.string]),
  foregroundColor: propTypes.string,
  foregroundOpacity: propTypes.number,
  svgWidth: propTypes.oneOfType([propTypes.string, propTypes.number]),
  svgHeight: propTypes.oneOfType([propTypes.string, propTypes.number]),
  ariaLabel: propTypes.string,
  className: propTypes.string,
  testId: propTypes.string,
  children: propTypes.node.isRequired
});

_defineProperty(SkeletonContainer, "defaultProps", defaultProps$j);

function _createSuper$l(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$l()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$k = {
  numberOfLines: 1,
  offsetTop: 0,
  offsetLeft: 0,
  lineHeight: 21,
  marginBottom: 20
};
var SkeletonText = /*#__PURE__*/function (_Component) {
  _inherits(SkeletonText, _Component);

  var _super = _createSuper$l(SkeletonText);

  function SkeletonText() {
    var _this;

    _classCallCheck(this, SkeletonText);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getLineWidth", function (lastLine) {
      if (_this.props.width) {
        return _this.props.width;
      }

      return lastLine ? '80%' : '100%';
    });

    return _this;
  }

  _createClass(SkeletonText, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          numberOfLines = _this$props.numberOfLines,
          offsetLeft = _this$props.offsetLeft,
          offsetTop = _this$props.offsetTop,
          lineHeight = _this$props.lineHeight,
          marginBottom = _this$props.marginBottom;
      return /*#__PURE__*/React.createElement(React.Fragment, null, Array.from(Array(numberOfLines)).map(function (_, index) {
        return /*#__PURE__*/React.createElement("rect", {
          key: "skeleton-display-text-".concat(index) // eslint-disable-line
          ,
          x: offsetLeft,
          y: index * (lineHeight + marginBottom) + offsetTop,
          rx: "0",
          ry: "0",
          width: _this2.getLineWidth(numberOfLines > 1 && numberOfLines - index === 1),
          height: lineHeight
        });
      }));
    }
  }]);

  return SkeletonText;
}(Component$1);
SkeletonText.displayName = "SkeletonText";

_defineProperty(SkeletonText, "propTypes", {
  numberOfLines: propTypes.number.isRequired,
  offsetTop: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  offsetLeft: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  lineHeight: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  marginBottom: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  width: propTypes.oneOfType([propTypes.string, propTypes.number])
});

_defineProperty(SkeletonText, "defaultProps", defaultProps$k);

function _createSuper$m(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$m()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$l = {
  numberOfLines: 1,
  width: 100,
  offsetTop: 0,
  offsetLeft: 0,
  lineHeight: 21,
  marginBottom: 20
};
var SkeletonDisplayText = /*#__PURE__*/function (_Component) {
  _inherits(SkeletonDisplayText, _Component);

  var _super = _createSuper$m(SkeletonDisplayText);

  function SkeletonDisplayText() {
    _classCallCheck(this, SkeletonDisplayText);

    return _super.apply(this, arguments);
  }

  _createClass(SkeletonDisplayText, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SkeletonText, this.props);
    }
  }]);

  return SkeletonDisplayText;
}(Component$1);
SkeletonDisplayText.displayName = "SkeletonDisplayText";

_defineProperty(SkeletonDisplayText, "defaultProps", defaultProps$l);

function _createSuper$n(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$n()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$m = {
  numberOfLines: 2,
  offsetTop: 0,
  offsetLeft: 0,
  lineHeight: 16,
  marginBottom: 8
};
var SkeletonBodyText = /*#__PURE__*/function (_Component) {
  _inherits(SkeletonBodyText, _Component);

  var _super = _createSuper$n(SkeletonBodyText);

  function SkeletonBodyText() {
    _classCallCheck(this, SkeletonBodyText);

    return _super.apply(this, arguments);
  }

  _createClass(SkeletonBodyText, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SkeletonText, this.props);
    }
  }]);

  return SkeletonBodyText;
}(Component$1);
SkeletonBodyText.displayName = "SkeletonBodyText";

_defineProperty(SkeletonBodyText, "defaultProps", defaultProps$m);

var EntryCardSkeleton = function EntryCardSkeleton() {
  return /*#__PURE__*/React.createElement(SkeletonContainer, {
    width: "100%",
    clipId: "f36-entry-card-skeleton"
  }, /*#__PURE__*/React.createElement(SkeletonDisplayText, {
    numberOfLines: 1,
    offsetTop: 2.5
  }), /*#__PURE__*/React.createElement(SkeletonBodyText, {
    numberOfLines: 3,
    offsetTop: 37.5
  }));
};

EntryCardSkeleton.displayName = "EntryCardSkeleton";

function _createSuper$o(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$o()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$k = {
  "CardDragHandle": "CardDragHandle__CardDragHandle___2rqnO",
  "CardDragHandle--drag-active": "CardDragHandle__CardDragHandle--drag-active___2e8vp",
  "CardDragHandle__sr-label": "CardDragHandle__CardDragHandle__sr-label___3CueY helpers__sr-only___3Kv3z"
};
var defaultProps$n = {
  testId: 'cf-ui-card-drag-handle',
  isDragActive: false
};
var CardDragHandle = /*#__PURE__*/function (_Component) {
  _inherits(CardDragHandle, _Component);

  var _super = _createSuper$o(CardDragHandle);

  function CardDragHandle() {
    _classCallCheck(this, CardDragHandle);

    return _super.apply(this, arguments);
  }

  _createClass(CardDragHandle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          testId = _this$props.testId,
          children = _this$props.children,
          isDragActive = _this$props.isDragActive,
          otherProps = _objectWithoutProperties(_this$props, ["className", "testId", "children", "isDragActive"]);

      var classNames = classnames(styles$k.CardDragHandle, _defineProperty({}, styles$k['CardDragHandle--drag-active'], isDragActive), className);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames,
        "data-test-id": testId
      }, otherProps), /*#__PURE__*/React.createElement(Icon, {
        icon: "Drag",
        color: "muted"
      }), /*#__PURE__*/React.createElement("span", {
        className: styles$k['CardDragHandle__sr-label']
      }, children));
    }
  }]);

  return CardDragHandle;
}(Component$1);
CardDragHandle.displayName = "CardDragHandle";

_defineProperty(CardDragHandle, "propTypes", {
  children: propTypes.node.isRequired,
  className: propTypes.string,
  testId: propTypes.string,
  isDragActive: propTypes.bool
});

_defineProperty(CardDragHandle, "defaultProps", defaultProps$n);

function _createSuper$p(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$p()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$l = {
  "EntryCard": "EntryCard__EntryCard___2kIVv",
  "EntryCard--size-default": "EntryCard__EntryCard--size-default___ahhv9",
  "EntryCard--size-small": "EntryCard__EntryCard--size-small___wmiCz",
  "EntryCard__wrapper": "EntryCard__EntryCard__wrapper___2i20k",
  "EntryCard--drag-active": "EntryCard__EntryCard--drag-active___26ZqT",
  "EntryCard--is-loading": "EntryCard__EntryCard--is-loading___310RH",
  "EntryCard__meta": "EntryCard__EntryCard__meta___3BSN4",
  "EntryCard__content-type": "EntryCard__EntryCard__content-type___77aij",
  "EntryCard__actions": "EntryCard__EntryCard__actions___1yMP3",
  "EntryCard__content": "EntryCard__EntryCard__content___1pcqO",
  "EntryCard__body": "EntryCard__EntryCard__body___21HhK",
  "EntryCard__title": "EntryCard__EntryCard__title___2q3bn",
  "EntryCard__description": "EntryCard__EntryCard__description___11s4-",
  "EntryCard__thumbnail": "EntryCard__EntryCard__thumbnail___3mEp5"
};
var defaultProps$o = {
  title: 'Untitled',
  testId: 'cf-ui-entry-card',
  size: 'default'
};
var EntryCard = /*#__PURE__*/function (_Component) {
  _inherits(EntryCard, _Component);

  var _super = _createSuper$p(EntryCard);

  function EntryCard() {
    var _this;

    _classCallCheck(this, EntryCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isDropdownOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "renderTitle", function (title) {
      var truncatedTitle = truncate(title, 255, {});
      return /*#__PURE__*/React.createElement("h1", {
        title: title.length > 255 ? title : '',
        className: styles$l.EntryCard__title,
        "data-test-id": "title"
      }, truncatedTitle);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDescription", function (description) {
      var truncatedDescription = truncate(description, 95, {});
      return /*#__PURE__*/React.createElement("p", {
        className: styles$l.EntryCard__description
      }, truncatedDescription);
    });

    _defineProperty(_assertThisInitialized(_this), "renderThumbnail", function (thumbnailElement) {
      return /*#__PURE__*/React.createElement("figure", {
        className: styles$l.EntryCard__thumbnail
      }, thumbnailElement);
    });

    _defineProperty(_assertThisInitialized(_this), "renderStatus", function (status) {
      var label;
      var type;

      switch (status) {
        case 'archived':
          label = 'archived';
          type = 'negative';
          break;

        case 'changed':
          label = 'changed';
          type = 'primary';
          break;

        case 'published':
          label = 'published';
          type = 'positive';
          break;

        default:
          label = 'draft';
          type = 'warning';
      }

      return /*#__PURE__*/React.createElement(Tag, {
        tagType: type
      }, label);
    });

    return _this;
  }

  _createClass(EntryCard, [{
    key: "renderCardDragHandle",
    value: function renderCardDragHandle() {
      var _this$props = this.props,
          cardDragHandleComponent = _this$props.cardDragHandleComponent,
          isDragActive = _this$props.isDragActive,
          cardDragHandleProps = _this$props.cardDragHandleProps,
          withDragHandle = _this$props.withDragHandle;

      if (cardDragHandleComponent) {
        return cardDragHandleComponent;
      } else if (withDragHandle) {
        return /*#__PURE__*/React.createElement(CardDragHandle, _extends({
          isDragActive: isDragActive
        }, cardDragHandleProps), "Reorder entry");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cn;

      var _this$props2 = this.props,
          className = _this$props2.className,
          title = _this$props2.title,
          onClick = _this$props2.onClick,
          testId = _this$props2.testId,
          description = _this$props2.description,
          contentType = _this$props2.contentType,
          status = _this$props2.status,
          statusIcon = _this$props2.statusIcon,
          thumbnailElement = _this$props2.thumbnailElement,
          loading = _this$props2.loading,
          dropdownListElements = _this$props2.dropdownListElements,
          isDragActive = _this$props2.isDragActive,
          size = _this$props2.size,
          cardDragHandleComponent = _this$props2.cardDragHandleComponent,
          cardDragHandleProps = _this$props2.cardDragHandleProps,
          withDragHandle = _this$props2.withDragHandle,
          href = _this$props2.href,
          otherProps = _objectWithoutProperties(_this$props2, ["className", "title", "onClick", "testId", "description", "contentType", "status", "statusIcon", "thumbnailElement", "loading", "dropdownListElements", "isDragActive", "size", "cardDragHandleComponent", "cardDragHandleProps", "withDragHandle", "href"]);

      var classNames = classnames(styles$l.EntryCard, (_cn = {}, _defineProperty(_cn, styles$l['EntryCard--drag-active'], isDragActive), _defineProperty(_cn, styles$l["EntryCard--size-".concat(size)], size), _cn), className);
      return /*#__PURE__*/React.createElement(Card, _extends({
        className: classNames,
        onClick: !loading ? onClick : undefined,
        testId: testId,
        href: href,
        padding: "none"
      }, otherProps), loading ? /*#__PURE__*/React.createElement("div", {
        className: styles$l.EntryCard__wrapper
      }, /*#__PURE__*/React.createElement(EntryCardSkeleton, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, this.renderCardDragHandle(), /*#__PURE__*/React.createElement("article", {
        className: styles$l.EntryCard__wrapper
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles$l.EntryCard__meta
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$l['EntryCard__content-type'],
        "data-test-id": "content-type"
      }, contentType), statusIcon && typeof statusIcon === 'string' ? /*#__PURE__*/React.createElement(Icon, {
        icon: statusIcon,
        color: "muted",
        className: "f36-margin-right--xs"
      }) : statusIcon, status && this.renderStatus(status), dropdownListElements && /*#__PURE__*/React.createElement(CardActions, {
        className: styles$l['EntryCard__actions'],
        iconButtonProps: {
          onClick: function onClick(e) {
            return e.stopPropagation;
          }
        }
      }, dropdownListElements)), /*#__PURE__*/React.createElement("div", {
        className: styles$l.EntryCard__content
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$l.EntryCard__body
      }, title && this.renderTitle(title), description && size === 'default' && this.renderDescription(description)), thumbnailElement && size === 'default' && this.renderThumbnail(thumbnailElement))))));
    }
  }]);

  return EntryCard;
}(Component$1);
EntryCard.displayName = "EntryCard";

_defineProperty(EntryCard, "propTypes", {
  title: propTypes.string,
  testId: propTypes.string,
  description: propTypes.string,
  contentType: propTypes.node,
  status: propTypes.oneOf(['archived', 'changed', 'draft', 'published']),
  statusIcon: propTypes.node,
  thumbnailElement: propTypes.node,
  loading: propTypes.bool,
  onClick: propTypes.func,
  className: propTypes.string,
  dropdownListElements: propTypes.element,
  cardDragHandleComponent: propTypes.node,
  withDragHandle: propTypes.bool,
  cardDragHandleProps: propTypes.any,
  isDragActive: propTypes.bool,
  size: propTypes.oneOf(['default', 'small']).isRequired,
  href: propTypes.string
});

_defineProperty(EntryCard, "defaultProps", defaultProps$o);

function _createSuper$q(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$q()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$m = {
  "ControlledInput": "ControlledInput__ControlledInput___2XK3j",
  "ControlledInput--disabled": "ControlledInput__ControlledInput--disabled___3prPF"
};
var defaultProps$p = {
  testId: 'cf-ui-controlled-input',
  required: false,
  disabled: false,
  type: 'checkbox',
  willBlurOnEsc: true
};
var ControlledInput = /*#__PURE__*/function (_Component) {
  _inherits(ControlledInput, _Component);

  var _super = _createSuper$q(ControlledInput);

  function ControlledInput() {
    var _this;

    _classCallCheck(this, ControlledInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var ESC = 27;

      if (e.keyCode === ESC && _this.props.willBlurOnEsc) {
        e.currentTarget.blur();
      }
    });

    return _this;
  }

  _createClass(ControlledInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          id = _this$props.id,
          testId = _this$props.testId,
          required = _this$props.required,
          disabled = _this$props.disabled,
          _onFocus = _this$props.onFocus,
          _onBlur = _this$props.onBlur,
          name = _this$props.name,
          _onChange = _this$props.onChange,
          checked = _this$props.checked,
          value = _this$props.value,
          type = _this$props.type,
          labelText = _this$props.labelText,
          willBlurOnEsc = _this$props.willBlurOnEsc,
          otherProps = _objectWithoutProperties(_this$props, ["className", "id", "testId", "required", "disabled", "onFocus", "onBlur", "name", "onChange", "checked", "value", "type", "labelText", "willBlurOnEsc"]);

      var classNames = classnames(styles$m['ControlledInput'], className, _defineProperty({}, styles$m['ControlledInput--disabled'], disabled));
      return /*#__PURE__*/React.createElement("input", _extends({
        className: classNames,
        value: value,
        name: name,
        checked: this.props.checked,
        type: type,
        "data-test-id": testId,
        onChange: function onChange(e) {
          if (_onChange) {
            _onChange(e);
          }
        },
        onBlur: function onBlur(e) {
          if (_onBlur) {
            _onBlur(e);
          }
        },
        onFocus: function onFocus(e) {
          if (_onFocus) {
            _onFocus(e);
          }
        },
        "aria-label": labelText,
        id: id,
        required: required,
        disabled: disabled,
        onKeyDown: this.handleKeyDown
      }, otherProps));
    }
  }]);

  return ControlledInput;
}(Component$1);
ControlledInput.displayName = "ControlledInput";

_defineProperty(ControlledInput, "propTypes", {
  id: propTypes.string,
  required: propTypes.bool,
  labelText: propTypes.string.isRequired,
  checked: propTypes.bool,
  onChange: propTypes.func,
  name: propTypes.string,
  onBlur: propTypes.func,
  onFocus: propTypes.func,
  value: propTypes.string,
  disabled: propTypes.bool,
  type: propTypes.oneOf(['checkbox', 'radio']),
  className: propTypes.string,
  testId: propTypes.string,
  willBlurOnEsc: propTypes.bool.isRequired
});

_defineProperty(ControlledInput, "defaultProps", defaultProps$p);

function _createSuper$r(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$r()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$n = {
  "ControlledInputField": "ControlledInputField__ControlledInputField___2uIG9",
  "ControlledInputField--disabled": "ControlledInputField__ControlledInputField--disabled___HDWt6",
  "ControlledInputField__input": "ControlledInputField__ControlledInputField__input___3OMYB",
  "ControlledInputField__label": "ControlledInputField__ControlledInputField__label___a9J52",
  "ControlledInputField__label--light": "ControlledInputField__ControlledInputField__label--light___2G2AZ"
};
var defaultProps$q = {
  testId: 'cf-ui-controlled-input-field',
  labelIsLight: false,
  checked: false,
  inputType: 'checkbox'
};
var ControlledInputField = /*#__PURE__*/function (_Component) {
  _inherits(ControlledInputField, _Component);

  var _super = _createSuper$r(ControlledInputField);

  function ControlledInputField() {
    _classCallCheck(this, ControlledInputField);

    return _super.apply(this, arguments);
  }

  _createClass(ControlledInputField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          labelIsLight = _this$props.labelIsLight,
          testId = _this$props.testId,
          required = _this$props.required,
          helpText = _this$props.helpText,
          disabled = _this$props.disabled,
          labelText = _this$props.labelText,
          helpTextProps = _this$props.helpTextProps,
          formLabelProps = _this$props.formLabelProps,
          className = _this$props.className,
          checked = _this$props.checked,
          value = _this$props.value,
          validationMessage = _this$props.validationMessage,
          onChange = _this$props.onChange,
          children = _this$props.children,
          inputType = _this$props.inputType,
          inputProps = _this$props.inputProps,
          name = _this$props.name,
          otherProps = _objectWithoutProperties(_this$props, ["id", "labelIsLight", "testId", "required", "helpText", "disabled", "labelText", "helpTextProps", "formLabelProps", "className", "checked", "value", "validationMessage", "onChange", "children", "inputType", "inputProps", "name"]);

      var classNames = classnames(styles$n['ControlledInputField'], className, _defineProperty({}, styles$n['ControlledInputField--disabled'], disabled));
      return /*#__PURE__*/React.createElement("div", _extends({
        "data-test-id": testId,
        className: classNames
      }, otherProps), /*#__PURE__*/React.createElement(ControlledInput, _extends({
        id: id,
        labelText: labelText,
        type: inputType,
        name: name,
        required: required,
        checked: checked,
        disabled: disabled,
        value: value,
        onChange: onChange,
        className: styles$n.ControlledInputField__input
      }, inputProps)), /*#__PURE__*/React.createElement("div", {
        className: styles$n['Checkbox__label-wrapper']
      }, /*#__PURE__*/React.createElement(FormLabel, _extends({
        className: classnames(styles$n.ControlledInputField__label, _defineProperty({}, styles$n['ControlledInputField__label--light'], labelIsLight)),
        required: required,
        htmlFor: id
      }, formLabelProps), labelText), helpText && /*#__PURE__*/React.createElement(HelpText, _extends({
        className: styles$n['ControlledInputField__help-text']
      }, helpTextProps), helpText), validationMessage && /*#__PURE__*/React.createElement(ValidationMessage, {
        className: styles$n['ControlledInputField__validation-message']
      }, validationMessage)));
    }
  }]);

  return ControlledInputField;
}(Component$1);
ControlledInputField.displayName = "ControlledInputField";

_defineProperty(ControlledInputField, "propTypes", {
  id: propTypes.string.isRequired,
  labelText: propTypes.string.isRequired,
  labelIsLight: propTypes.bool,
  required: propTypes.bool,
  helpText: propTypes.string,
  formLabelProps: propTypes.object,
  disabled: propTypes.bool,
  helpTextProps: propTypes.object,
  validationMessage: propTypes.string,
  value: propTypes.string,
  name: propTypes.string,
  checked: propTypes.bool,
  inputProps: propTypes.object,
  inputType: propTypes.oneOf(['radio', 'checkbox']),
  onChange: propTypes.func,
  className: propTypes.string,
  testId: propTypes.string,
  children: propTypes.node
});

_defineProperty(ControlledInputField, "defaultProps", defaultProps$q);

function _createSuper$s(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$s()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$r = {
  labelIsLight: false,
  checked: false,
  inputType: 'checkbox',
  testId: 'cf-ui-checkbox-field'
};
var CheckboxField = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxField, _Component);

  var _super = _createSuper$s(CheckboxField);

  function CheckboxField() {
    _classCallCheck(this, CheckboxField);

    return _super.apply(this, arguments);
  }

  _createClass(CheckboxField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["testId"]);

      return /*#__PURE__*/React.createElement(ControlledInputField, _extends({
        testId: testId
      }, otherProps, {
        inputType: "checkbox"
      }));
    }
  }]);

  return CheckboxField;
}(Component$1);
CheckboxField.displayName = "CheckboxField";

_defineProperty(CheckboxField, "defaultProps", defaultProps$r);

function _createSuper$t(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$t()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$s = {
  required: false,
  disabled: false,
  type: 'checkbox',
  testId: 'ctf-ui-checkbox',
  willBlurOnEsc: true
};
var Checkbox = /*#__PURE__*/function (_Component) {
  _inherits(Checkbox, _Component);

  var _super = _createSuper$t(Checkbox);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _super.apply(this, arguments);
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ControlledInput, this.props);
    }
  }]);

  return Checkbox;
}(Component$1);
Checkbox.displayName = "Checkbox";

_defineProperty(Checkbox, "defaultProps", defaultProps$s);

Checkbox.defaultProps = defaultProps$s;

function _createSuper$u(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$u()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$u() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$o = {
  "Spinner": "Spinner__Spinner___32lpa",
  "rotate-cw": "Spinner__rotate-cw___dk3Pr",
  "Spinner--default": "Spinner__Spinner--default___1UP1r",
  "Spinner--small": "Spinner__Spinner--small___2hyo0",
  "Spinner--large": "Spinner__Spinner--large___3TPiL",
  "Spinner--white": "Spinner__Spinner--white___3Hsq3"
};
var defaultProps$t = {
  testId: 'cf-ui-spinner',
  size: 'default',
  color: 'default'
};
var Spinner = /*#__PURE__*/function (_Component) {
  _inherits(Spinner, _Component);

  var _super = _createSuper$u(Spinner);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _super.apply(this, arguments);
  }

  _createClass(Spinner, [{
    key: "render",
    value: function render() {
      var _cn;

      var _this$props = this.props,
          className = _this$props.className,
          size = _this$props.size,
          testId = _this$props.testId,
          color = _this$props.color,
          customSize = _this$props.customSize,
          otherProps = _objectWithoutProperties(_this$props, ["className", "size", "testId", "color", "customSize"]);

      var classNames = classnames(styles$o.Spinner, className, (_cn = {}, _defineProperty(_cn, styles$o["Spinner--".concat(size)], size), _defineProperty(_cn, styles$o["Spinner--".concat(color)], color), _cn));
      return /*#__PURE__*/React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        "data-test-id": testId,
        className: classNames,
        style: customSize ? {
          height: "".concat(customSize, "px"),
          width: "".concat(customSize, "px")
        } : {}
      }, otherProps), /*#__PURE__*/React.createElement("title", null, "Loading\u2026"), /*#__PURE__*/React.createElement("path", {
        d: "M2,10a8,8,0,0,1,8-8V0a10,10,0,0,0,0,20V18A8,8,0,0,1,2,10Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M10,0V2a8,8,0,0,1,0,16v2A10,10,0,0,0,10,0Z",
        style: {
          opacity: 0.4
        }
      }));
    }
  }]);

  return Spinner;
}(Component$1);
Spinner.displayName = "Spinner";

_defineProperty(Spinner, "propTypes", {
  size: propTypes.oneOf(['default', 'small', 'large']),
  customSize: propTypes.number,
  color: propTypes.oneOf(['default', 'white']),
  className: propTypes.string,
  testId: propTypes.string
});

_defineProperty(Spinner, "defaultProps", defaultProps$t);

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
});

unwrapExports(interopRequireDefault);

var hasClass_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];
});

unwrapExports(hasClass_1);

var addClass_1 = createCommonjsModule(function (module, exports) {



exports.__esModule = true;
exports.default = addClass;

var _hasClass = interopRequireDefault(hasClass_1);

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];
});

unwrapExports(addClass_1);

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

var removeClass = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  polyfill: polyfill
});

var PropTypes = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape = process.env.NODE_ENV !== 'production' ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape = process.env.NODE_ENV !== 'production' ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;
});

unwrapExports(PropTypes);
var PropTypes_1 = PropTypes.classNamesShape;
var PropTypes_2 = PropTypes.timeoutsShape;

var Transition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes$1 = _interopRequireWildcard(propTypes);

var _react = _interopRequireDefault(React);

var _reactDom = _interopRequireDefault(ReactDOM);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes$1.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes$1.oneOfType([PropTypes$1.func.isRequired, PropTypes$1.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes$1.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes$1.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes$1.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes$1.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes$1.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes$1.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes$1.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes$1.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes$1.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes$1.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes$1.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes$1.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes$1.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, reactLifecyclesCompat_es.polyfill)(Transition);

exports.default = _default;
});

unwrapExports(Transition_1);
var Transition_2 = Transition_1.EXITING;
var Transition_3 = Transition_1.ENTERED;
var Transition_4 = Transition_1.ENTERING;
var Transition_5 = Transition_1.EXITED;
var Transition_6 = Transition_1.UNMOUNTED;

var CSSTransition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var PropTypes$1 = _interopRequireWildcard(propTypes);

var _addClass = _interopRequireDefault(addClass_1);

var _removeClass = _interopRequireDefault(removeClass);

var _react = _interopRequireDefault(React);

var _Transition = _interopRequireDefault(Transition_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass$1 = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass$1(node, className);
    activeClassName && removeClass$1(node, activeClassName);
    doneClassName && removeClass$1(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes$1.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes$1.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(CSSTransition_1);

var ChildMapping = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;



/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, React.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) React.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, React.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, React.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, React.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, React.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, React.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, React.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, React.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
});

unwrapExports(ChildMapping);
var ChildMapping_1 = ChildMapping.getChildMapping;
var ChildMapping_2 = ChildMapping.mergeChildMappings;
var ChildMapping_3 = ChildMapping.getInitialChildMapping;
var ChildMapping_4 = ChildMapping.getNextChildMapping;

var TransitionGroup_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(propTypes);

var _react = _interopRequireDefault(React);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, reactLifecyclesCompat_es.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(TransitionGroup_1);

var ReplaceTransition_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(propTypes);

var _react = _interopRequireDefault(React);



var _TransitionGroup = _interopRequireDefault(TransitionGroup_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, ReactDOM.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];
});

unwrapExports(ReplaceTransition_1);

var reactTransitionGroup = createCommonjsModule(function (module) {

var _CSSTransition = _interopRequireDefault(CSSTransition_1);

var _ReplaceTransition = _interopRequireDefault(ReplaceTransition_1);

var _TransitionGroup = _interopRequireDefault(TransitionGroup_1);

var _Transition = _interopRequireDefault(Transition_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};
});

unwrapExports(reactTransitionGroup);
var reactTransitionGroup_1 = reactTransitionGroup.Transition;
var reactTransitionGroup_2 = reactTransitionGroup.TransitionGroup;
var reactTransitionGroup_3 = reactTransitionGroup.ReplaceTransition;
var reactTransitionGroup_4 = reactTransitionGroup.CSSTransition;

function _createSuper$v(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$v()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$v() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$p = {
  "Button": "Button__Button___1ZfFj a11y__focus-border--default___60AXp",
  "Button--disabled": "Button__Button--disabled___1E20M",
  "Button__icon": "Button__Button__icon___2YX5-",
  "Button--full-width": "Button__Button--full-width___3Fmpo",
  "Button--muted": "Button__Button--muted___2Wair",
  "Button--is-active": "Button__Button--is-active___iPvhW",
  "Button--naked": "Button__Button--naked___mB6LS",
  "Button--primary": "Button__Button--primary___JImeO",
  "Button__label": "Button__Button__label___3tcOj",
  "Button--positive": "Button__Button--positive___1t6w1",
  "Button--negative": "Button__Button--negative___22jwE",
  "Button--warning": "Button__Button--warning___2xMa4",
  "Button__inner-wrapper": "Button__Button__inner-wrapper___3qrNC",
  "Button--small": "Button__Button--small___3yyrk",
  "Button--large": "Button__Button--large___1PYrl",
  "Button__spinner": "Button__Button__spinner___3j8Aj",
  "Button--spinner--enter": "Button__Button--spinner--enter___1qgg7",
  "Button--spinner-active": "Button__Button--spinner-active___EEKjQ",
  "Button--spinner--exit": "Button__Button--spinner--exit___2RUI-",
  "Button--spinner-exit-active": "Button__Button--spinner-exit-active___3HXa7"
};
var defaultProps$u = {
  loading: false,
  isFullWidth: false,
  indicateDropdown: false,
  disabled: false,
  testId: 'cf-ui-button',
  buttonType: 'primary',
  type: 'button'
};
var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper$v(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _cn;

      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          icon = _this$props.icon,
          buttonType = _this$props.buttonType,
          size = _this$props.size,
          isFullWidth = _this$props.isFullWidth,
          _onBlur = _this$props.onBlur,
          testId = _this$props.testId,
          _onClick = _this$props.onClick,
          loading = _this$props.loading,
          disabled = _this$props.disabled,
          indicateDropdown = _this$props.indicateDropdown,
          href = _this$props.href,
          type = _this$props.type,
          isActive = _this$props.isActive,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "icon", "buttonType", "size", "isFullWidth", "onBlur", "testId", "onClick", "loading", "disabled", "indicateDropdown", "href", "type", "isActive"]);

      var classNames = classnames(styles$p.Button, className, styles$p["Button--".concat(buttonType)], (_cn = {}, _defineProperty(_cn, styles$p['Button--disabled'], disabled), _defineProperty(_cn, styles$p["Button--".concat(size)], size), _defineProperty(_cn, styles$p['Button--full-width'], isFullWidth), _defineProperty(_cn, styles$p['Button--is-active'], isActive), _cn));
      var iconColor = buttonType === 'muted' || buttonType === 'naked' ? 'secondary' : 'white'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

      var Element = href ? 'a' : 'button';
      return /*#__PURE__*/React.createElement(Element, _extends({
        onBlur: function onBlur(e) {
          if (_onBlur && !disabled) {
            _onBlur(e);
          }
        },
        onClick: function onClick(e) {
          if (_onClick && !disabled && !loading) {
            _onClick(e);
          }
        },
        "data-test-id": testId,
        className: classNames,
        disabled: disabled,
        href: !disabled ? href : null,
        type: type
      }, otherProps), /*#__PURE__*/React.createElement(TabFocusTrap, {
        className: styles$p['Button__inner-wrapper']
      }, icon && /*#__PURE__*/React.createElement(Icon, {
        className: styles$p.Button__icon,
        size: size === 'small' ? 'tiny' : 'small',
        icon: icon,
        color: iconColor
      }), children && /*#__PURE__*/React.createElement("span", {
        className: styles$p.Button__label
      }, children), indicateDropdown && /*#__PURE__*/React.createElement(Icon, {
        className: styles$p['Button__dropdown-icon'],
        icon: "ArrowDown",
        color: iconColor
      }), /*#__PURE__*/React.createElement(reactTransitionGroup_4, {
        "in": loading,
        timeout: 1000,
        classNames: {
          enter: styles$p['Button--spinner--enter'],
          enterActive: styles$p['Button--spinner-active'],
          exit: styles$p['Button--spinner--exit'],
          exitActive: styles$p['Button--spinner-exit-active']
        },
        mountOnEnter: true,
        unmountOnExit: true
      }, /*#__PURE__*/React.createElement(Spinner, {
        className: styles$p.Button__spinner,
        size: "small",
        color: buttonType === 'muted' || buttonType === 'naked' ? 'default' : 'white'
      }))));
    }
  }]);

  return Button;
}(Component$1);
Button.displayName = "Button";

_defineProperty(Button, "propTypes", {
  icon: propTypes.any,
  indicateDropdown: propTypes.bool,
  onClick: propTypes.func,
  isFullWidth: propTypes.bool,
  onBlur: propTypes.func,
  loading: propTypes.bool,
  disabled: propTypes.bool,
  testId: propTypes.string,
  buttonType: propTypes.oneOf(['primary', 'positive', 'negative', 'warning', 'muted', 'naked']),
  type: propTypes.oneOf(['button', 'submit', 'reset']),
  size: propTypes.oneOf(['small', 'large']),
  href: propTypes.string,
  style: propTypes.any,
  className: propTypes.string,
  children: propTypes.node,
  isActive: propTypes.bool
});

_defineProperty(Button, "defaultProps", defaultProps$u);

function _createSuper$w(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$w()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$w() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$q = {
  "EditorToolbar": "EditorToolbar__EditorToolbar___1zyWM"
};
var defaultProps$v = {
  testId: 'cf-ui-editor-toolbar'
};
var EditorToolbar = /*#__PURE__*/function (_Component) {
  _inherits(EditorToolbar, _Component);

  var _super = _createSuper$w(EditorToolbar);

  function EditorToolbar() {
    _classCallCheck(this, EditorToolbar);

    return _super.apply(this, arguments);
  }

  _createClass(EditorToolbar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      var classNames = classnames(styles$q['EditorToolbar'], className);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames
      }, otherProps, {
        "data-test-id": testId
      }), children);
    }
  }]);

  return EditorToolbar;
}(Component$1);
EditorToolbar.displayName = "EditorToolbar";

_defineProperty(EditorToolbar, "propTypes", {
  className: propTypes.string,
  children: propTypes.node.isRequired,
  testId: propTypes.string,
  style: propTypes.any
});

_defineProperty(EditorToolbar, "defaultProps", defaultProps$v);

function _createSuper$x(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$x()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$x() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$r = {
  "EditorToolbarButton": "EditorToolbarButton__EditorToolbarButton___2t--R",
  "EditorToolbarButton--is-active": "EditorToolbarButton__EditorToolbarButton--is-active___12pD0"
};
var defaultProps$w = {
  testId: 'cf-ui-editor-toolbar-button',
  isActive: false,
  disabled: false,
  withDropdown: false
};
var EditorToolbarButton = /*#__PURE__*/function (_Component) {
  _inherits(EditorToolbarButton, _Component);

  var _super = _createSuper$x(EditorToolbarButton);

  function EditorToolbarButton() {
    _classCallCheck(this, EditorToolbarButton);

    return _super.apply(this, arguments);
  }

  _createClass(EditorToolbarButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          label = _this$props.label,
          testId = _this$props.testId,
          icon = _this$props.icon,
          tooltip = _this$props.tooltip,
          iconButtonProps = _this$props.iconButtonProps,
          isActive = _this$props.isActive,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          withDropdown = _this$props.withDropdown,
          otherProps = _objectWithoutProperties(_this$props, ["className", "label", "testId", "icon", "tooltip", "iconButtonProps", "isActive", "disabled", "onClick", "withDropdown"]);

      var classNames = classnames(styles$r['EditorToolbarButton'], className, _defineProperty({}, styles$r['EditorToolbarButton--is-active'], isActive));
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
        content: !disabled ? tooltip : undefined
      }, /*#__PURE__*/React.createElement(IconButton, _extends({
        iconProps: {
          icon: icon
        }
      }, {
        testId: testId,
        buttonType: "secondary",
        label: label,
        className: classNames,
        onClick: !disabled ? onClick : function () {},
        disabled: disabled,
        withDropdown: withDropdown
      }, iconButtonProps, otherProps))));
    }
  }]);

  return EditorToolbarButton;
}(Component$1);
EditorToolbarButton.displayName = "EditorToolbarButton";

_defineProperty(EditorToolbarButton, "propTypes", {
  label: propTypes.string.isRequired,
  icon: propTypes.any.isRequired,
  tooltip: propTypes.string,
  iconButtonProps: propTypes.any,
  isActive: propTypes.bool,
  disabled: propTypes.bool,
  onClick: propTypes.func,
  withDropdown: propTypes.bool,
  className: propTypes.string,
  testId: propTypes.string
});

_defineProperty(EditorToolbarButton, "defaultProps", defaultProps$w);

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$y(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$y()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$y() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var cssStyles = {
  "DropdownList": "DropdownList__DropdownList___2EMLM",
  "DropdownList--border-top": "DropdownList__DropdownList--border-top___ojlyY",
  "DropdownList--border-bottom": "DropdownList__DropdownList--border-bottom___3F_82"
};
var defaultProps$x = {
  testId: 'cf-ui-dropdown-list'
};
var DropdownList = /*#__PURE__*/function (_Component) {
  _inherits(DropdownList, _Component);

  var _super = _createSuper$y(DropdownList);

  function DropdownList() {
    _classCallCheck(this, DropdownList);

    return _super.apply(this, arguments);
  }

  _createClass(DropdownList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          border = _this$props.border,
          maxHeight = _this$props.maxHeight,
          testId = _this$props.testId,
          children = _this$props.children,
          listRef = _this$props.listRef,
          styles = _this$props.styles,
          otherProps = _objectWithoutProperties(_this$props, ["className", "border", "maxHeight", "testId", "children", "listRef", "styles"]);

      var classNames = classnames(cssStyles['DropdownList'], className, _defineProperty({}, cssStyles["DropdownList--border-".concat(border)], border));
      return /*#__PURE__*/React.createElement("ul", _extends({
        ref: listRef,
        "data-test-id": testId,
        role: "menu",
        style: _objectSpread$5({
          maxHeight: maxHeight || 'auto',
          overflowY: maxHeight ? 'auto' : 'visible'
        }, styles),
        className: classNames
      }, otherProps), children);
    }
  }]);

  return DropdownList;
}(Component$1);
DropdownList.displayName = "DropdownList";

_defineProperty(DropdownList, "propTypes", {
  children: propTypes.node.isRequired,
  listRef: propTypes.any,
  className: propTypes.string,
  testId: propTypes.string,
  border: propTypes.oneOf(['top', 'bottom']),
  maxHeight: propTypes.oneOfType([propTypes.number, propTypes.any]),
  styles: propTypes.object
});

_defineProperty(DropdownList, "defaultProps", defaultProps$x);

function _createSuper$z(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$z()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$z() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$s = {
  "EditorToolbarDivider": "EditorToolbarDivider__EditorToolbarDivider___22NLC"
};
var defaultProps$y = {
  testId: 'cf-editor-toolbar-divider'
};
var EditorToolbarDivider = /*#__PURE__*/function (_Component) {
  _inherits(EditorToolbarDivider, _Component);

  var _super = _createSuper$z(EditorToolbarDivider);

  function EditorToolbarDivider() {
    _classCallCheck(this, EditorToolbarDivider);

    return _super.apply(this, arguments);
  }

  _createClass(EditorToolbarDivider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "testId"]);

      var classNames = classnames(styles$s['EditorToolbarDivider'], className);
      return /*#__PURE__*/React.createElement("span", _extends({
        "data-test-id": testId,
        className: classNames
      }, otherProps));
    }
  }]);

  return EditorToolbarDivider;
}(Component$1);
EditorToolbarDivider.displayName = "EditorToolbarDivider";

_defineProperty(EditorToolbarDivider, "propTypes", {
  testId: propTypes.string,
  className: propTypes.string
});

_defineProperty(EditorToolbarDivider, "defaultProps", defaultProps$y);

function _createSuper$A(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$A()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$A() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$t = {
  "Select__wrapper": "Select__Select__wrapper___2mbYV",
  "Select": "Select__Select___2Gi9N a11y__focus-border--default___60AXp",
  "Select--disabled": "Select__Select--disabled___156vR",
  "Select--small": "Select__Select--small___2amb5",
  "Select--medium": "Select__Select--medium___1QRqZ",
  "Select--large": "Select__Select--large___1HaJb",
  "Select--full": "Select__Select--full___AENS4",
  "Select--auto": "Select__Select--auto___3Y-B9",
  "Select--negative": "Select__Select--negative___1lj8S",
  "Select__icon": "Select__Select__icon___OBmvS"
};
var defaultProps$z = {
  testId: 'cf-ui-select',
  required: false,
  hasError: false,
  isDisabled: false,
  width: 'full',
  willBlurOnEsc: true
};
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);

  var _super = _createSuper$A(Select);

  function Select() {
    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.value
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var ESC = 27;

      if (e.keyCode === ESC && _this.props.willBlurOnEsc) {
        e.currentTarget.blur();
      }
    });

    return _this;
  }

  _createClass(Select, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cn,
          _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          required = _this$props.required,
          children = _this$props.children,
          width = _this$props.width,
          className = _this$props.className,
          testId = _this$props.testId,
          _onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          isDisabled = _this$props.isDisabled,
          hasError = _this$props.hasError,
          willBlurOnEsc = _this$props.willBlurOnEsc,
          otherProps = _objectWithoutProperties(_this$props, ["id", "name", "required", "children", "width", "className", "testId", "onChange", "onBlur", "onFocus", "isDisabled", "hasError", "willBlurOnEsc"]);

      var widthClass = "Select--".concat(width);
      var classNames = classnames(styles$t['Select'], (_cn = {}, _defineProperty(_cn, styles$t['Select--disabled'], isDisabled), _defineProperty(_cn, styles$t['Select--negative'], hasError), _cn));
      var wrapperClassNames = classnames(styles$t['Select__wrapper'], styles$t[widthClass], className);
      return /*#__PURE__*/React.createElement("div", {
        className: wrapperClassNames
      }, /*#__PURE__*/React.createElement("select", _extends({
        id: id,
        required: required,
        name: name,
        "aria-label": name,
        "data-test-id": testId,
        className: classNames,
        value: this.state.value,
        disabled: isDisabled,
        onFocus: onFocus,
        onChange: function onChange(e) {
          if (!isDisabled) {
            _this2.setState({
              value: e.target.value
            });

            if (_onChange) {
              _onChange(e);
            }
          }
        },
        onBlur: onBlur,
        onKeyDown: this.handleKeyDown
      }, otherProps), children), /*#__PURE__*/React.createElement(Icon, {
        className: styles$t['Select__icon'],
        icon: "ArrowDown",
        color: "muted"
      }));
    }
  }]);

  return Select;
}(Component$1);
Select.displayName = "Select";

_defineProperty(Select, "propTypes", {
  required: propTypes.bool,
  name: propTypes.string,
  id: propTypes.string,
  hasError: propTypes.bool,
  value: propTypes.string,
  isDisabled: propTypes.bool,
  onChange: propTypes.func,
  onBlur: propTypes.func,
  onFocus: propTypes.func,
  width: propTypes.oneOf(['auto', 'small', 'medium', 'large', 'full']),
  testId: propTypes.string,
  className: propTypes.string,
  children: propTypes.node.isRequired,
  willBlurOnEsc: propTypes.bool.isRequired
});

_defineProperty(Select, "defaultProps", defaultProps$z);

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$B(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$B()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$B() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$u = {
  "SelectField": "SelectField__SelectField___kbQlf",
  "SelectField__label-wrapper": "SelectField__SelectField__label-wrapper___3jGwo",
  "SelectField__label-link": "SelectField__SelectField__label-link___2bZnM",
  "SelectField__validation-message": "SelectField__SelectField__validation-message___1yelf",
  "SelectField__help-text": "SelectField__SelectField__help-text___H0RZB"
};
var defaultProps$A = {
  testId: 'cf-ui-select-field',
  required: false
};
var SelectField = /*#__PURE__*/function (_Component) {
  _inherits(SelectField, _Component);

  var _super = _createSuper$B(SelectField);

  function SelectField() {
    var _this;

    _classCallCheck(this, SelectField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.value
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (evt) {
      _this.setState({
        value: evt.target.value
      });

      if (_this.props.onChange) {
        _this.props.onChange(evt);
      }
    });

    return _this;
  }

  _createClass(SelectField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    } // Store a copy of the value in state.
    // This is used by this component when the `countCharacters`
    // option is on

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          validationMessage = _this$props.validationMessage,
          className = _this$props.className,
          children = _this$props.children,
          selectProps = _this$props.selectProps,
          testId = _this$props.testId,
          formLabelProps = _this$props.formLabelProps,
          textLinkProps = _this$props.textLinkProps,
          labelText = _this$props.labelText,
          helpText = _this$props.helpText,
          required = _this$props.required,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          value = _this$props.value,
          name = _this$props.name,
          id = _this$props.id,
          otherProps = _objectWithoutProperties(_this$props, ["validationMessage", "className", "children", "selectProps", "testId", "formLabelProps", "textLinkProps", "labelText", "helpText", "required", "onChange", "onBlur", "value", "name", "id"]);

      var classNames = classnames(styles$u['SelectField'], className);
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames
      }, otherProps, {
        "data-test-id": testId
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$u['SelectField__label-wrapper']
      }, /*#__PURE__*/React.createElement(FormLabel, _objectSpread$6({}, formLabelProps, {
        htmlFor: id,
        required: required
      }), labelText), textLinkProps && /*#__PURE__*/React.createElement(TextLink, _objectSpread$6({}, textLinkProps, {
        className: styles$u['SelectField__label-link']
      }), textLinkProps.text)), /*#__PURE__*/React.createElement(Select, _objectSpread$6({
        hasError: !!validationMessage,
        name: name,
        id: id,
        onBlur: onBlur,
        onChange: this.handleOnChange,
        value: this.state.value,
        required: required
      }, selectProps), children), validationMessage && /*#__PURE__*/React.createElement(ValidationMessage, {
        className: styles$u['SelectField__validation-message']
      }, validationMessage), helpText && /*#__PURE__*/React.createElement("div", {
        className: styles$u['SelectField__hints']
      }, helpText && /*#__PURE__*/React.createElement(HelpText, {
        className: styles$u['SelectField__help-text']
      }, helpText)));
    }
  }]);

  return SelectField;
}(Component$1);
SelectField.displayName = "SelectField";

_defineProperty(SelectField, "propTypes", {
  name: propTypes.string.isRequired,
  id: propTypes.string.isRequired,
  labelText: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
  value: propTypes.string,
  validationMessage: propTypes.string,
  formLabelProps: propTypes.any,
  textLinkProps: propTypes.any,
  selectProps: propTypes.any,
  helpText: propTypes.string,
  required: propTypes.bool,
  onChange: propTypes.func,
  onBlur: propTypes.func,
  testId: propTypes.string,
  className: propTypes.string
});

_defineProperty(SelectField, "defaultProps", defaultProps$A);

function _createSuper$C(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$C()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$C() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$B = {
  testId: 'cf-ui-select-option'
};
var Option = /*#__PURE__*/function (_Component) {
  _inherits(Option, _Component);

  var _super = _createSuper$C(Option);

  function Option() {
    _classCallCheck(this, Option);

    return _super.apply(this, arguments);
  }

  _createClass(Option, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["value", "children", "testId"]);

      return /*#__PURE__*/React.createElement("option", _extends({
        value: value,
        "data-test-id": testId
      }, otherProps), children);
    }
  }]);

  return Option;
}(Component$1);
Option.displayName = "Option";

_defineProperty(Option, "propTypes", {
  value: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
  testId: propTypes.string
});

_defineProperty(Option, "defaultProps", defaultProps$B);

var EntryCardSkeleton$1 = function EntryCardSkeleton() {
  return /*#__PURE__*/React.createElement(SkeletonContainer, {
    width: "100%",
    clipId: "f36-inline-entry-card-skeleton",
    svgHeight: 16
  }, /*#__PURE__*/React.createElement(SkeletonBodyText, {
    numberOfLines: 1
  }));
};

EntryCardSkeleton$1.displayName = "EntryCardSkeleton";

function _createSuper$D(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$D()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$D() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$v = {
  "InlineEntryCard": "InlineEntryCard__InlineEntryCard___2cGQw",
  "InlineEntryCard__skeleton-wrapper": "InlineEntryCard__InlineEntryCard__skeleton-wrapper___BA5rM",
  "InlineEntryCard__text-wrapper": "InlineEntryCard__InlineEntryCard__text-wrapper___3Sf6P",
  "InlineEntryCard__status-indicator": "InlineEntryCard__InlineEntryCard__status-indicator___1sYHe",
  "InlineEntryCard__status-indicator--published": "InlineEntryCard__InlineEntryCard__status-indicator--published___2iM7W",
  "InlineEntryCard__status-indicator--draft": "InlineEntryCard__InlineEntryCard__status-indicator--draft___8AKK1",
  "InlineEntryCard__status-indicator--archived": "InlineEntryCard__InlineEntryCard__status-indicator--archived___3-aWk",
  "InlineEntryCard__status-indicator--changed": "InlineEntryCard__InlineEntryCard__status-indicator--changed___ArwPC",
  "InlineEntryCard__actions": "InlineEntryCard__InlineEntryCard__actions___3DzZi",
  "InlineEntryCard__spinner--enter": "InlineEntryCard__InlineEntryCard__spinner--enter___jY1EO",
  "InlineEntryCard__spinner--enter-active": "InlineEntryCard__InlineEntryCard__spinner--enter-active___AZomL",
  "InlineEntryCard__spinner--exit": "InlineEntryCard__InlineEntryCard__spinner--exit___29TCK",
  "InlineEntryCard__spinner--exit-active": "InlineEntryCard__InlineEntryCard__spinner--exit-active___31qgq"
};
var defaultProps$C = {
  testId: 'cf-ui-inline-entry-card'
};
var InlineEntryCard = /*#__PURE__*/function (_Component) {
  _inherits(InlineEntryCard, _Component);

  var _super = _createSuper$D(InlineEntryCard);

  function InlineEntryCard() {
    _classCallCheck(this, InlineEntryCard);

    return _super.apply(this, arguments);
  }

  _createClass(InlineEntryCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          dropdownListElements = _this$props.dropdownListElements,
          isSelected = _this$props.isSelected,
          children = _this$props.children,
          testId = _this$props.testId,
          isLoading = _this$props.isLoading,
          status = _this$props.status,
          href = _this$props.href,
          otherProps = _objectWithoutProperties(_this$props, ["className", "dropdownListElements", "isSelected", "children", "testId", "isLoading", "status", "href"]);

      var classNames = classnames(styles$v.InlineEntryCard, className);
      var statusIndicatorClassNames = classnames(styles$v['InlineEntryCard__status-indicator'], _defineProperty({}, styles$v["InlineEntryCard__status-indicator--".concat(status)], status && !isLoading));
      return /*#__PURE__*/React.createElement(Card, _extends({
        selected: isSelected,
        className: classNames,
        href: href
      }, otherProps, {
        "data-test-id": testId
      }), /*#__PURE__*/React.createElement(reactTransitionGroup_4, {
        timeout: 100,
        "in": isLoading,
        classNames: {
          enter: styles$v['InlineEntryCard__spinner--enter'],
          enterActive: styles$v['InlineEntryCard__spinner--enter-active'],
          exit: styles$v['InlineEntryCard__spinner--exit'],
          exitActive: styles$v['InlineEntryCard__spinner--exit-active']
        },
        mountOnEnter: true,
        unmountOnExit: true
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$v['InlineEntryCard__skeleton-wrapper']
      }, /*#__PURE__*/React.createElement(EntryCardSkeleton$1, null))), /*#__PURE__*/React.createElement("div", {
        className: statusIndicatorClassNames
      }), /*#__PURE__*/React.createElement("span", {
        className: styles$v['InlineEntryCard__text-wrapper']
      }, isLoading ? 'Loading' : children), dropdownListElements && /*#__PURE__*/React.createElement(CardActions, {
        className: styles$v['InlineEntryCard__actions'],
        iconButtonProps: {
          onClick: function onClick(e) {
            return e.stopPropagation;
          }
        }
      }, dropdownListElements));
    }
  }]);

  return InlineEntryCard;
}(Component$1);
InlineEntryCard.displayName = "InlineEntryCard";

_defineProperty(InlineEntryCard, "propTypes", {
  isSelected: propTypes.bool,
  dropdownListElements: propTypes.element,
  isLoading: propTypes.bool,
  status: propTypes.oneOf(['archived', 'changed', 'draft', 'published']),
  className: propTypes.string,
  testId: propTypes.string,
  href: propTypes.string,
  children: propTypes.node.isRequired
});

_defineProperty(InlineEntryCard, "defaultProps", defaultProps$C);

var illustrationName = {
  Archive: 'Archive',
  Audio: 'Audio',
  Code: 'Code',
  Image: 'Image',
  Markup: 'Markup',
  Pdf: 'Pdf',
  Plaintext: 'Plaintext',
  Presentation: 'Presentation',
  Richtext: 'Richtext',
  Spreadsheet: 'Spreadsheet',
  Video: 'Video'
};

function _createSuper$E(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$E()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$E() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Archive = function Archive(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M20.5 23.5h-17V.5h13l4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M11.5.5v2.001h1v5h-3V2.5M10.5 9.5h1M10.5 11.5h1M10.5 13.5h1M10.5 15.5h1M10.5 17.5h1M10.5 19.5h1M10.5 21.5h1M11.5 10.5h1M11.5 12.5h1M11.5 14.5h1M11.5 16.5h1M11.5 18.5h1M11.5 20.5h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.5H11"
  })));
};

Archive.displayName = "Archive";
Archive.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var Audio = function Audio(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5H7.25a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75H9l3.5 3.5V9L9 12.5zM16 11c.834.688 1.5 1.835 1.5 3 0 1.163-.669 2.312-1.5 3M14 12.25c.562.409 1 1.001 1 1.75 0 .749-.438 1.341-1 1.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 23.5h-19V.5h13l6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5.5v6h6"
  })));
};

Audio.displayName = "Audio";
Audio.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var Code$1 = function Code(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7 23.5h-19V.5h13l6 6v17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7.5v6h6"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: "4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.776 9.095c-3.326 0 .475 4.274-3.326 5.225M10.776 19.544c-3.326 0 .475-4.274-3.326-5.225"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.626 9.095c3.324 0-.475 4.274 3.324 5.225M13.626 19.544c3.324 0-.475-4.274 3.324-5.225"
  })))));
};

Code$1.displayName = "Code";
Code$1.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: "10"
};

var Image = function Image(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 23.5H.5V.5h13l6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5.5v6h6M13 11l-3 5.5-2-2-2.5 5h10z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "9",
    r: "1.5"
  })));
};

Image.displayName = "Image";
Image.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var Markup = function Markup(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.688 23.492h-17v-23h11l6 6v17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.688.492v6h6M14.688 10.492l4 4-4 4M9.688 10.492l-4 4 4 4"
  })));
};

Markup.displayName = "Markup";
Markup.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: "10"
};

var Pdf = function Pdf(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5.5v6h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 23.5h-19V.5h13l6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18.5v-5h1c1.152 0 2 1.068 2 2.5s-.848 2.5-2 2.5h-1zM16.5 18.5v-5H19M16.5 15.5H18M6.5 18.499V13.5h1.25a1.25 1.25 0 1 1 0 2.5H6.5"
  })));
};

Pdf.displayName = "Pdf";
Pdf.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var Plaintext = function Plaintext(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 23.5h-19V.5h13l6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5.5v6h6M7.5 7.5H12M7.5 10.5h9M7.5 13.5h3M7.5 16.5h3M7.5 19.5h3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5v-1h4v1M14.5 13.5v6M13 19.5h3"
  }))));
};

Plaintext.displayName = "Plaintext";
Plaintext.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var Presentation = function Presentation(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h22v3H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M.521 17.5h21.958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.5h18v14h-18zM11.5 17.5v3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11.5",
    cy: "22",
    r: "1.5"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.228l3.272 2.272-3.272 2.272z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11.5",
    cy: "10.5",
    r: "5"
  }))));
};

Presentation.displayName = "Presentation";
Presentation.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var Richtext = function Richtext(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 23.5h-19V.5h13l6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5.5v6h6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M6.5 7.5h5M6.5 10.5h9M6.5 13.5h2M6.5 16.5h2M6.5 19.5h2M11.542 20.5H17.5l-2.479-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    d: "M11.5 13.5h6v7h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15a.5.5 0 1 0 .002 1.002A.5.5 0 0 0 13.5 15z"
  }));
};

Richtext.displayName = "Richtext";
Richtext.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var Spreadsheet = function Spreadsheet(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.5h-17V.5h11l6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5.5v6h6M6.5 8.5h11v12h-11zM6.5 11.5h11M6.5 14.5h11M6.5 17.5h11M10.5 8.5v12"
  })));
};

Spreadsheet.displayName = "Spreadsheet";
Spreadsheet.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var Video = function Video(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.5h-17V.5h11l6 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5.5v6h6M8.5 8.5l8 5-8 5z"
  })));
};

Video.displayName = "Video";
Video.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
var styles$w = {
  "Illustration": "Illustration__Illustration___1R5Px"
};
var ILLUSTRATION_NAMES = Object.keys(illustrationName);
function isIllustrationType(name) {
  return ILLUSTRATION_NAMES.includes(name);
}
var defaultProps$D = {
  testId: 'cf-ui-illustration'
};
var Illustration = /*#__PURE__*/function (_Component) {
  _inherits(Illustration, _Component);

  var _super = _createSuper$E(Illustration);

  function Illustration() {
    _classCallCheck(this, Illustration);

    return _super.apply(this, arguments);
  }

  _createClass(Illustration, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          testId = _this$props.testId,
          illustration = _this$props.illustration,
          otherProps = _objectWithoutProperties(_this$props, ["className", "testId", "illustration"]);

      var illustrationComponents = {
        Archive: Archive,
        Audio: Audio,
        Richtext: Richtext,
        Code: Code$1,
        Image: Image,
        Markup: Markup,
        Pdf: Pdf,
        Plaintext: Plaintext,
        Presentation: Presentation,
        Spreadsheet: Spreadsheet,
        Video: Video
      };
      var classNames = classnames(styles$w['Illustration'], className);
      var Element = illustrationComponents[illustration];
      return /*#__PURE__*/React.createElement(Element, _extends({}, otherProps, {
        "data-test-id": testId,
        className: classNames
      }));
    }
  }]);

  return Illustration;
}(Component$1);
Illustration.displayName = "Illustration";

_defineProperty(Illustration, "propTypes", {
  illustration: propTypes.any.isRequired,
  className: propTypes.string,
  testId: propTypes.string,
  style: propTypes.any
});

_defineProperty(Illustration, "defaultProps", defaultProps$D);

function _createSuper$F(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$F()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$F() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$x = {
  "Table": "Table__Table___3vKIR"
};
var defaultProps$E = {
  testId: 'cf-ui-table'
};
var Table = /*#__PURE__*/function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper$F(Table);

  function Table() {
    _classCallCheck(this, Table);

    return _super.apply(this, arguments);
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      return /*#__PURE__*/React.createElement("table", _extends({
        className: classnames(className, styles$x['Table']),
        cellPadding: "0",
        cellSpacing: "0",
        "data-test-id": testId
      }, otherProps), children);
    }
  }]);

  return Table;
}(Component$1);
Table.displayName = "Table";

_defineProperty(Table, "propTypes", {
  testId: propTypes.string,
  className: propTypes.string,
  style: propTypes.any,
  children: propTypes.node.isRequired
});

_defineProperty(Table, "defaultProps", defaultProps$E);

function _createSuper$G(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$G()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$G() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$F = {
  testId: 'cf-ui-table-body'
};
var TableBody = /*#__PURE__*/function (_Component) {
  _inherits(TableBody, _Component);

  var _super = _createSuper$G(TableBody);

  function TableBody() {
    _classCallCheck(this, TableBody);

    return _super.apply(this, arguments);
  }

  _createClass(TableBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      return /*#__PURE__*/React.createElement("tbody", _extends({
        "data-test-id": testId,
        className: className
      }, otherProps), children);
    }
  }]);

  return TableBody;
}(Component$1);
TableBody.displayName = "TableBody";

_defineProperty(TableBody, "propTypes", {
  className: propTypes.string,
  style: propTypes.any,
  testId: propTypes.string,
  children: propTypes.node.isRequired
});

_defineProperty(TableBody, "defaultProps", defaultProps$F);

var contextOptions = {
  body: {
    name: 'body',
    element: 'td',
    offsetTop: 0
  },
  head: {
    name: 'head',
    element: 'th',
    offsetTop: 0
  }
};
var TableCellContext = React.createContext(contextOptions.body);

function _createSuper$H(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$H()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$H() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$y = {
  "TableCell": "TableCell__TableCell___Wou8a",
  "TableCell--head": "TableCell__TableCell--head___1HhvZ",
  "TableCell--head__sorting": "TableCell__TableCell--head__sorting____Jc1k"
};
var defaultProps$G = {
  align: 'left',
  sorting: false,
  testId: 'cf-ui-table-cell'
};
var TableCell = /*#__PURE__*/function (_Component) {
  _inherits(TableCell, _Component);

  var _super = _createSuper$H(TableCell);

  function TableCell() {
    _classCallCheck(this, TableCell);

    return _super.apply(this, arguments);
  }

  _createClass(TableCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          sorting = _this$props.sorting,
          align = _this$props.align,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "sorting", "align", "testId"]);

      return /*#__PURE__*/React.createElement(TableCellContext.Consumer, null, function (_ref) {
        var _cn;

        var context = _ref.name,
            element = _ref.element,
            offsetTop = _ref.offsetTop;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var Element = element;
        return /*#__PURE__*/React.createElement(Element, _extends({
          className: classnames(styles$y['TableCell'], className, (_cn = {}, _defineProperty(_cn, styles$y['TableCell--head'], context === 'head'), _defineProperty(_cn, styles$y['TableCell--head__sorting'], sorting), _cn)),
          style: {
            top: offsetTop
          },
          align: align,
          "data-test-id": testId
        }, otherProps), children);
      });
    }
  }]);

  return TableCell;
}(Component$1);
TableCell.displayName = "TableCell";

_defineProperty(TableCell, "propTypes", {
  align: propTypes.oneOf(['center', 'left', 'right']),
  sorting: propTypes.oneOfType([propTypes.any, propTypes.bool]),
  style: propTypes.any,
  className: propTypes.string,
  testId: propTypes.string,
  children: propTypes.node
});

_defineProperty(TableCell, "defaultProps", defaultProps$G);

function _createSuper$I(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$I()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$I() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$z = {
  "TableSortingLabel__button": "TableSortingLabel__TableSortingLabel__button___olUoZ",
  "TableSortingLabel__button__text": "TableSortingLabel__TableSortingLabel__button__text___ak824",
  "TableSortingLabel__icon": "TableSortingLabel__TableSortingLabel__icon___1WJBG",
  "TableSortingLabel__icon--asc": "TableSortingLabel__TableSortingLabel__icon--asc___1Tn1Z",
  "TableSortingLabel__icon--desc": "TableSortingLabel__TableSortingLabel__icon--desc___28Knm"
};
var defaultProps$H = {
  testId: 'cf-ui-table-sorting-label'
};
var TableSortingLabel = /*#__PURE__*/function (_Component) {
  _inherits(TableSortingLabel, _Component);

  var _super = _createSuper$I(TableSortingLabel);

  function TableSortingLabel() {
    _classCallCheck(this, TableSortingLabel);

    return _super.apply(this, arguments);
  }

  _createClass(TableSortingLabel, [{
    key: "renderIcon",
    value: function renderIcon() {
      var direction = this.props.direction;
      var classNames = classnames(styles$z['TableSortingLabel__icon'], styles$z["TableSortingLabel__icon--".concat(direction)]);
      return /*#__PURE__*/React.createElement(Icon, {
        className: classNames,
        icon: "ArrowUp",
        color: "muted"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          active = _this$props.active,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "active", "testId"]);

      return /*#__PURE__*/React.createElement("button", _extends({
        type: "button",
        className: classnames(styles$z['TableSortingLabel__button'], className),
        "data-test-id": testId
      }, otherProps), /*#__PURE__*/React.createElement(TabFocusTrap, {
        className: styles$z['TableSortingLabel__button__text']
      }, children, active && this.renderIcon()));
    }
  }]);

  return TableSortingLabel;
}(Component$1);
TableSortingLabel.displayName = "TableSortingLabel";

_defineProperty(TableSortingLabel, "propTypes", {
  children: propTypes.node.isRequired,
  direction: propTypes.any.isRequired,
  active: propTypes.bool.isRequired,
  className: propTypes.string,
  testId: propTypes.string
});

_defineProperty(TableSortingLabel, "defaultProps", defaultProps$H);

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$J(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$J()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$J() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$A = {
  "TableHead--sticky": "TableHead__TableHead--sticky___1YzE0"
};
var defaultProps$I = {
  isSticky: false,
  testId: 'cf-ui-table-head'
};
var TableHead = /*#__PURE__*/function (_Component) {
  _inherits(TableHead, _Component);

  var _super = _createSuper$J(TableHead);

  function TableHead() {
    _classCallCheck(this, TableHead);

    return _super.apply(this, arguments);
  }

  _createClass(TableHead, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          testId = _this$props.testId,
          offsetTop = _this$props.offsetTop,
          isSticky = _this$props.isSticky,
          children = _this$props.children,
          otherProps = _objectWithoutProperties(_this$props, ["className", "testId", "offsetTop", "isSticky", "children"]);

      var classNames = classnames(className, _defineProperty({}, styles$A["TableHead--sticky"], isSticky));
      return /*#__PURE__*/React.createElement(TableCellContext.Provider, {
        value: _objectSpread$7({}, contextOptions.head, {
          offsetTop: offsetTop || 0
        })
      }, /*#__PURE__*/React.createElement("thead", _extends({
        className: classNames,
        "data-test-id": testId
      }, otherProps), children));
    }
  }]);

  return TableHead;
}(Component$1);
TableHead.displayName = "TableHead";

_defineProperty(TableHead, "propTypes", {
  isSticky: propTypes.bool,
  offsetTop: propTypes.oneOfType([propTypes.number, propTypes.string]),
  className: propTypes.string,
  testId: propTypes.string,
  style: propTypes.any,
  children: propTypes.node.isRequired
});

_defineProperty(TableHead, "defaultProps", defaultProps$I);

function _createSuper$K(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$K()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$K() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$B = {
  "TableRow": "TableRow__TableRow___3kcNC"
};
var defaultProps$J = {
  testId: 'cf-ui-table-row'
};
var TableRow = /*#__PURE__*/function (_Component) {
  _inherits(TableRow, _Component);

  var _super = _createSuper$K(TableRow);

  function TableRow() {
    _classCallCheck(this, TableRow);

    return _super.apply(this, arguments);
  }

  _createClass(TableRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      return /*#__PURE__*/React.createElement("tr", _extends({
        className: classnames(styles$B['TableRow'], className),
        "data-test-id": testId
      }, otherProps), children);
    }
  }]);

  return TableRow;
}(Component$1);
TableRow.displayName = "TableRow";

_defineProperty(TableRow, "propTypes", {
  className: propTypes.string,
  style: propTypes.any,
  testId: propTypes.string,
  children: propTypes.node.isRequired
});

_defineProperty(TableRow, "defaultProps", defaultProps$J);

function _createSuper$L(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$L()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$L() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$C = {
  "Toggle": "ToggleButton__Toggle___1gUNN",
  "Toggle--active": "ToggleButton__Toggle--active___cx5OU",
  "Toggle--disabled": "ToggleButton__Toggle--disabled___2uZSk",
  "Toggle__button": "ToggleButton__Toggle__button___g0Ntb a11y__focus-outline--default___2hwb1",
  "Toggle__button__icon": "ToggleButton__Toggle__button__icon___2v22X",
  "Toggle__content-wrapper": "ToggleButton__Toggle__content-wrapper___1VoAt",
  "Toggle__button__inner-wrapper": "ToggleButton__Toggle__button__inner-wrapper___1MGKY",
  "Toggle--square": "ToggleButton__Toggle--square___3nugi"
};
var defaultProps$K = {
  testId: 'cf-ui-toggle-button',
  isActive: false,
  isDisabled: false
};
var ToggleButton = /*#__PURE__*/function (_Component) {
  _inherits(ToggleButton, _Component);

  var _super = _createSuper$L(ToggleButton);

  function ToggleButton() {
    var _this;

    _classCallCheck(this, ToggleButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function () {
      if (!_this.props.isDisabled) {
        if (_this.props.onToggle) {
          _this.props.onToggle();
        }
      }
    });

    return _this;
  }

  _createClass(ToggleButton, [{
    key: "render",
    value: function render() {
      var _cn;

      var _this$props = this.props,
          className = _this$props.className,
          icon = _this$props.icon,
          children = _this$props.children,
          isActive = _this$props.isActive,
          isDisabled = _this$props.isDisabled,
          otherProps = _objectWithoutProperties(_this$props, ["className", "icon", "children", "isActive", "isDisabled"]);

      var classNames = classnames(styles$C.Toggle, className, (_cn = {}, _defineProperty(_cn, styles$C['Toggle--active'], isActive), _defineProperty(_cn, styles$C['Toggle--disabled'], isDisabled), _defineProperty(_cn, styles$C['Toggle--square'], !children), _cn));
      return /*#__PURE__*/React.createElement(Card, _extends({
        className: classNames,
        padding: "none",
        selected: isActive
      }, otherProps), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: styles$C.Toggle__button,
        disabled: isDisabled,
        "data-test-id": "button",
        onClick: this.handleToggle,
        "aria-pressed": isActive
      }, /*#__PURE__*/React.createElement(TabFocusTrap, {
        className: styles$C['Toggle__button__inner-wrapper']
      }, icon && /*#__PURE__*/React.createElement(Icon, {
        icon: icon,
        color: "secondary",
        className: styles$C.Toggle__button__icon
      }), children && /*#__PURE__*/React.createElement("span", {
        className: styles$C['Toggle__content-wrapper']
      }, children))));
    }
  }]);

  return ToggleButton;
}(Component$1);
ToggleButton.displayName = "ToggleButton";

_defineProperty(ToggleButton, "propTypes", {
  children: propTypes.node.isRequired,
  icon: propTypes.any,
  isActive: propTypes.bool,
  onToggle: propTypes.any,
  isDisabled: propTypes.bool,
  testId: propTypes.string,
  className: propTypes.string
});

_defineProperty(ToggleButton, "defaultProps", defaultProps$K);

function _createSuper$M(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$M()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$M() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var DEFAULT_ILLUSTRATION_NAME = 'Archive';
var defaultProps$L = {
  type: 'archive',
  testId: 'cf-ui-asset-icon'
};
/**
 * Renders only the Illustration that would represent this asset's type
 */

var AssetIcon = /*#__PURE__*/function (_Component) {
  _inherits(AssetIcon, _Component);

  var _super = _createSuper$M(AssetIcon);

  function AssetIcon() {
    _classCallCheck(this, AssetIcon);

    return _super.apply(this, arguments);
  }

  _createClass(AssetIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          otherProps = _objectWithoutProperties(_this$props, ["type"]);

      var illustrationName = type.charAt(0).toUpperCase() + type.slice(1);

      if (!isIllustrationType(illustrationName)) {
        illustrationName = DEFAULT_ILLUSTRATION_NAME;
      }

      return /*#__PURE__*/React.createElement(Illustration, _extends({
        illustration: illustrationName
      }, otherProps));
    }
  }]);

  return AssetIcon;
}(Component$1);
AssetIcon.displayName = "AssetIcon";

_defineProperty(AssetIcon, "propTypes", {
  type: propTypes.any
});

_defineProperty(AssetIcon, "defaultProps", defaultProps$L);

function _createSuper$N(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$N()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$N() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$D = {
  "Asset": "Asset__Asset___1zgnB",
  "Asset__image-container": "Asset__Asset__image-container___1oHDv",
  "Asset__image-container__image": "Asset__Asset__image-container__image___3J2Ik",
  "Asset__title-container": "Asset__Asset__title-container___jUj2R",
  "Asset__title-container__title": "Asset__Asset__title-container__title___1AHiK",
  "Asset__asset-container": "Asset__Asset__asset-container___226So",
  "Asset__asset-container__title": "Asset__Asset__asset-container__title___y3fAq",
  "Asset__illustration-container": "Asset__Asset__illustration-container___D0AVE"
};
var defaultProps$M = {
  type: 'image',
  testId: 'cf-ui-asset'
};
var Asset$1 = /*#__PURE__*/function (_Component) {
  _inherits(Asset, _Component);

  var _super = _createSuper$N(Asset);

  function Asset() {
    var _this;

    _classCallCheck(this, Asset);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderImage", function (src, title) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles$D['Asset__image-container']
      }, /*#__PURE__*/React.createElement("img", {
        className: styles$D['Asset__image-container__image'],
        src: src,
        alt: title
      })), /*#__PURE__*/React.createElement("div", {
        className: styles$D['Asset__title-container']
      }, /*#__PURE__*/React.createElement("span", {
        className: styles$D['Asset__title-container__title']
      }, title)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderAsset", function (type, title) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$D['Asset__asset-container']
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$D['Asset__illustration-container']
      }, /*#__PURE__*/React.createElement(AssetIcon, {
        type: type
      })), /*#__PURE__*/React.createElement("span", {
        className: styles$D['Asset__asset-container__title']
      }, title));
    });

    return _this;
  }

  _createClass(Asset, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          src = _this$props.src,
          status = _this$props.status,
          title = _this$props.title,
          type = _this$props.type,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "src", "status", "title", "type", "testId"]);

      var classNames = classnames(styles$D.Asset, className); // Archived images will not have a preview available

      var asImage = type && type === 'image' && (!status || status !== 'archived');
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames,
        "data-test-id": testId
      }, otherProps), asImage ? this.renderImage(src, title) : this.renderAsset(type, title));
    }
  }]);

  return Asset;
}(Component$1);
Asset$1.displayName = "Asset";

_defineProperty(Asset$1, "propTypes", {
  src: propTypes.string.isRequired,
  title: propTypes.string.isRequired,
  type: propTypes.any,
  className: propTypes.string,
  status: propTypes.any,
  testId: propTypes.string
});

_defineProperty(Asset$1, "defaultProps", defaultProps$M);

function _createSuper$O(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$O()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$O() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$N = {
  testId: 'cf-ui-skeleton-image',
  width: 70,
  height: 70,
  radiusX: 0,
  radiusY: 0
};
var SkeletonImage = /*#__PURE__*/function (_Component) {
  _inherits(SkeletonImage, _Component);

  var _super = _createSuper$O(SkeletonImage);

  function SkeletonImage() {
    _classCallCheck(this, SkeletonImage);

    return _super.apply(this, arguments);
  }

  _createClass(SkeletonImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          testId = _this$props.testId,
          offsetLeft = _this$props.offsetLeft,
          offsetTop = _this$props.offsetTop,
          width = _this$props.width,
          height = _this$props.height,
          radiusX = _this$props.radiusX,
          radiusY = _this$props.radiusY,
          otherProps = _objectWithoutProperties(_this$props, ["testId", "offsetLeft", "offsetTop", "width", "height", "radiusX", "radiusY"]);

      return /*#__PURE__*/React.createElement("rect", _extends({
        x: offsetLeft,
        y: offsetTop,
        rx: radiusX,
        ry: radiusY,
        width: width,
        height: height
      }, otherProps));
    }
  }]);

  return SkeletonImage;
}(Component$1);
SkeletonImage.displayName = "SkeletonImage";

_defineProperty(SkeletonImage, "propTypes", {
  width: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  height: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  radiusX: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  radiusY: propTypes.oneOfType([propTypes.string, propTypes.number]).isRequired,
  offsetLeft: propTypes.oneOfType([propTypes.string, propTypes.number]),
  offsetTop: propTypes.oneOfType([propTypes.string, propTypes.number]),
  testId: propTypes.string
});

_defineProperty(SkeletonImage, "defaultProps", defaultProps$N);

var AssetCardSkeleton = function AssetCardSkeleton(props) {
  return /*#__PURE__*/React.createElement(SkeletonContainer, {
    svgWidth: props.size === 'small' ? 150 : 240,
    clipId: "f36-asset-card-skeleton"
  }, /*#__PURE__*/React.createElement(SkeletonImage, {
    offsetLeft: props.size === 'small' ? 40 : 85,
    offsetTop: props.size === 'small' ? 50 : 100
  }), /*#__PURE__*/React.createElement(SkeletonBodyText, {
    offsetLeft: props.size === 'small' ? 25 : 70,
    offsetTop: props.size === 'small' ? 140 : 190,
    numberOfLines: 1,
    width: 100
  }));
};

AssetCardSkeleton.displayName = "AssetCardSkeleton";
AssetCardSkeleton.propTypes = {
  size: propTypes.oneOf(['small', 'default'])
};

function _createSuper$P(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$P()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$P() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$E = {
  "AssetCard": "AssetCard__AssetCard____VWXj",
  "AssetCard--size-small": "AssetCard__AssetCard--size-small___2fyHk",
  "AssetCard__asset": "AssetCard__AssetCard__asset___189id",
  "AssetCard--drag-active": "AssetCard__AssetCard--drag-active___WtiNB",
  "AssetCard__wrapper": "AssetCard__AssetCard__wrapper___24k3w",
  "AssetCard__header": "AssetCard__AssetCard__header___2ahyT",
  "AssetCard__actions": "AssetCard__AssetCard__actions___2Nbjg"
};
var defaultProps$O = {
  isLoading: false,
  testId: 'cf-ui-asset-card',
  size: 'default'
};
var AssetCard = /*#__PURE__*/function (_Component) {
  _inherits(AssetCard, _Component);

  var _super = _createSuper$P(AssetCard);

  function AssetCard() {
    var _this;

    _classCallCheck(this, AssetCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderStatus", function (status) {
      var label;
      var type = null;

      switch (status) {
        case 'archived':
          label = 'archived';
          type = 'negative';
          break;

        case 'changed':
          label = 'changed';
          type = 'primary';
          break;

        case 'published':
          label = 'published';
          type = 'positive';
          break;

        default:
          label = 'draft';
          type = 'warning';
      }

      return /*#__PURE__*/React.createElement(Tag, {
        tagType: type,
        style: {
          marginLeft: 'auto'
        }
      }, label);
    });

    return _this;
  }

  _createClass(AssetCard, [{
    key: "renderCardDragHandle",
    value: function renderCardDragHandle() {
      var _this$props = this.props,
          cardDragHandleComponent = _this$props.cardDragHandleComponent,
          isDragActive = _this$props.isDragActive,
          cardDragHandleProps = _this$props.cardDragHandleProps,
          withDragHandle = _this$props.withDragHandle;

      if (cardDragHandleComponent) {
        return cardDragHandleComponent;
      } else if (withDragHandle) {
        return /*#__PURE__*/React.createElement(CardDragHandle, _extends({
          isDragActive: isDragActive
        }, cardDragHandleProps), "Reorder entry");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cn;

      var _this$props2 = this.props,
          className = _this$props2.className,
          src = _this$props2.src,
          type = _this$props2.type,
          title = _this$props2.title,
          status = _this$props2.status,
          isLoading = _this$props2.isLoading,
          dropdownListElements = _this$props2.dropdownListElements,
          isDragActive = _this$props2.isDragActive,
          testId = _this$props2.testId,
          size = _this$props2.size,
          cardDragHandleProps = _this$props2.cardDragHandleProps,
          cardDragHandleComponent = _this$props2.cardDragHandleComponent,
          withDragHandle = _this$props2.withDragHandle,
          href = _this$props2.href,
          otherProps = _objectWithoutProperties(_this$props2, ["className", "src", "type", "title", "status", "isLoading", "dropdownListElements", "isDragActive", "testId", "size", "cardDragHandleProps", "cardDragHandleComponent", "withDragHandle", "href"]);

      var classNames = classnames(styles$E.AssetCard, (_cn = {}, _defineProperty(_cn, styles$E['AssetCard--drag-active'], isDragActive), _defineProperty(_cn, styles$E["AssetCard--size-".concat(size)], size), _cn), className);
      return /*#__PURE__*/React.createElement(Card, _extends({
        className: classNames,
        padding: "none",
        title: title,
        testId: testId,
        href: href
      }, otherProps), isLoading ? /*#__PURE__*/React.createElement(AssetCardSkeleton, {
        size: size
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, this.renderCardDragHandle(), /*#__PURE__*/React.createElement("div", {
        className: styles$E['AssetCard__wrapper']
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$E['AssetCard__header']
      }, status && this.renderStatus(status), dropdownListElements && /*#__PURE__*/React.createElement(CardActions, {
        className: styles$E['AssetCard__actions'],
        iconButtonProps: {
          onClick: function onClick(e) {
            return e.stopPropagation;
          }
        }
      }, dropdownListElements)), /*#__PURE__*/React.createElement("div", {
        className: styles$E['AssetCard__content']
      }, /*#__PURE__*/React.createElement(Asset$1, {
        className: styles$E['AssetCard__asset'],
        src: src,
        title: title,
        type: type,
        status: status
      })))));
    }
  }]);

  return AssetCard;
}(Component$1);
AssetCard.displayName = "AssetCard";

_defineProperty(AssetCard, "propTypes", {
  src: propTypes.string.isRequired,
  title: propTypes.string.isRequired,
  className: propTypes.string,
  isLoading: propTypes.bool,
  dropdownListElements: propTypes.element,
  status: propTypes.oneOf(['archived', 'changed', 'draft', 'published']),
  testId: propTypes.string,
  type: propTypes.any,
  cardDragHandleComponent: propTypes.node,
  withDragHandle: propTypes.bool,
  cardDragHandleProps: propTypes.any,
  isDragActive: propTypes.bool,
  size: propTypes.oneOf(['small', 'default']),
  href: propTypes.string
});

_defineProperty(AssetCard, "defaultProps", defaultProps$O);

function _createSuper$Q(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$Q()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$Q() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$F = {
  "Typography": "Typography__Typography___1ZUfE"
};
var defaultConfiguration = {
  displayText: {
    spacing: 'l'
  },
  displayTextLarge: {
    spacing: 'xl'
  },
  heading: {
    spacing: 'm'
  },
  paragraph: {
    spacing: 'm'
  },
  sectionHeading: {
    spacing: 'l'
  },
  subheading: {
    spacing: 'm'
  }
};
var defaultProps$P = {
  testId: 'cf-ui-text-container'
};
var TypographyContext = React.createContext({});
var Typography = /*#__PURE__*/function (_Component) {
  _inherits(Typography, _Component);

  var _super = _createSuper$Q(Typography);

  function Typography() {
    _classCallCheck(this, Typography);

    return _super.apply(this, arguments);
  }

  _createClass(Typography, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      var classNames = classnames(styles$F.Typography, className);
      return /*#__PURE__*/React.createElement(TypographyContext.Provider, {
        value: defaultConfiguration
      }, /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
        className: classNames,
        "data-test-id": testId
      }), children));
    }
  }]);

  return Typography;
}(Component$1);
Typography.displayName = "Typography";

_defineProperty(Typography, "propTypes", {
  className: propTypes.string,
  children: propTypes.node,
  style: propTypes.any,
  testId: propTypes.string
});

_defineProperty(Typography, "defaultProps", defaultProps$P);

function _createSuper$R(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$R()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$R() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$G = {
  "Heading": "Heading__Heading___83D3K"
};
var defaultProps$Q = {
  element: 'h1',
  testId: 'cf-ui-heading'
};
var Heading$1 = /*#__PURE__*/function (_Component) {
  _inherits(Heading, _Component);

  var _super = _createSuper$R(Heading);

  function Heading() {
    _classCallCheck(this, Heading);

    return _super.apply(this, arguments);
  }

  _createClass(Heading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          element = _this$props.element,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "element"]);

      var classNames = classnames(styles$G['Heading'], className);
      var Element = element;
      return /*#__PURE__*/React.createElement(TypographyContext.Consumer, null, function (value) {
        return /*#__PURE__*/React.createElement(Element, _extends({
          className: classnames(classNames, [value['heading'] && "f36-margin-bottom--".concat(value['heading']['spacing'])]),
          "data-test-id": testId
        }, otherProps), children);
      });
    }
  }]);

  return Heading;
}(Component$1);
Heading$1.displayName = "Heading";

_defineProperty(Heading$1, "propTypes", {
  element: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']).isRequired,
  style: propTypes.any,
  className: propTypes.string,
  children: propTypes.node,
  testId: propTypes.string
});

_defineProperty(Heading$1, "defaultProps", defaultProps$Q);

var tabbable_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];
});

unwrapExports(tabbable_1);

var focusManager = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;



var _tabbable2 = _interopRequireDefault(tabbable_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}
});

unwrapExports(focusManager);
var focusManager_1 = focusManager.handleBlur;
var focusManager_2 = focusManager.handleFocus;
var focusManager_3 = focusManager.markForFocusLater;
var focusManager_4 = focusManager.returnFocus;
var focusManager_5 = focusManager.popWithoutFocus;
var focusManager_6 = focusManager.setupScopedFocus;
var focusManager_7 = focusManager.teardownScopedFocus;

var scopeTab_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;



var _tabbable2 = _interopRequireDefault(tabbable_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];
});

unwrapExports(scopeTab_1);

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

var warning_1 = warning;

var exenv = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if ( module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());
});

var safeHTMLElement = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;



var _exenv2 = _interopRequireDefault(exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;
});

unwrapExports(safeHTMLElement);
var safeHTMLElement_1 = safeHTMLElement.canUseDOM;

var ariaAppHider = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;



var _warning2 = _interopRequireDefault(warning_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}
});

unwrapExports(ariaAppHider);
var ariaAppHider_1 = ariaAppHider.assertNodeList;
var ariaAppHider_2 = ariaAppHider.setElement;
var ariaAppHider_3 = ariaAppHider.validateElement;
var ariaAppHider_4 = ariaAppHider.hide;
var ariaAppHider_5 = ariaAppHider.show;
var ariaAppHider_6 = ariaAppHider.documentNotReadyOrSSRTesting;
var ariaAppHider_7 = ariaAppHider.resetForTesting;

var classList = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (process.env.NODE_ENV !== "production") {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
});

unwrapExports(classList);
var classList_1 = classList.dumpClassLists;
var classList_2 = classList.add;
var classList_3 = classList.remove;

var ModalPortal_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(propTypes);



var focusManager$1 = _interopRequireWildcard(focusManager);



var _scopeTab2 = _interopRequireDefault(scopeTab_1);



var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);



var classList$1 = _interopRequireWildcard(classList);



var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      classList$1.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider$1.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager$1.returnFocus();
          focusManager$1.teardownScopedFocus();
        } else {
          focusManager$1.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager$1.setupScopedFocus(_this.node);
          focusManager$1.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (process.env.NODE_ENV !== "production") {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      classList$1.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider$1.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(React.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];
});

unwrapExports(ModalPortal_1);

var Modal_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _reactDom2 = _interopRequireDefault(ReactDOM);



var _propTypes2 = _interopRequireDefault(propTypes);



var _ModalPortal2 = _interopRequireDefault(ModalPortal_1);



var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);



var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider$1.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(React.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, reactLifecyclesCompat_es.polyfill)(Modal);

exports.default = Modal;
});

unwrapExports(Modal_1);
var Modal_2 = Modal_1.bodyOpenClassName;
var Modal_3 = Modal_1.portalClassName;

var lib$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _Modal2 = _interopRequireDefault(Modal_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];
});

var ReactModal = unwrapExports(lib$1);

function _createSuper$S(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$S()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$S() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$H = {
  "ModalHeader": "ModalHeader__ModalHeader___1yD1S",
  "ModalHeader__title": "ModalHeader__ModalHeader__title___3IuOy",
  "ModalHeader__title--is-not-wrapped": "ModalHeader__ModalHeader__title--is-not-wrapped___39i2J"
};
var defaultProps$R = {
  testId: 'cf-ui-modal-header'
};
var ModalHeader = /*#__PURE__*/function (_Component) {
  _inherits(ModalHeader, _Component);

  var _super = _createSuper$S(ModalHeader);

  function ModalHeader() {
    _classCallCheck(this, ModalHeader);

    return _super.apply(this, arguments);
  }

  _createClass(ModalHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClose = _this$props.onClose,
          title = _this$props.title,
          testId = _this$props.testId,
          isNotWrapped = _this$props.isNotWrapped,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["onClose", "title", "testId", "isNotWrapped", "className"]);

      var titleClassNames = classnames(styles$H.ModalHeader__title, _defineProperty({}, styles$H['ModalHeader__title--is-not-wrapped'], isNotWrapped));
      return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
        className: classnames(styles$H.ModalHeader, className),
        "data-test-id": testId
      }), /*#__PURE__*/React.createElement("h1", {
        className: titleClassNames
      }, title), onClose && /*#__PURE__*/React.createElement(IconButton, {
        iconProps: {
          icon: 'Close'
        },
        buttonType: "muted",
        label: "Close",
        onClick: function onClick() {
          return onClose();
        }
      }));
    }
  }]);

  return ModalHeader;
}(Component$1);
ModalHeader.displayName = "ModalHeader";

_defineProperty(ModalHeader, "propTypes", {
  title: propTypes.string.isRequired,
  onClose: propTypes.any,
  testId: propTypes.string,
  className: propTypes.string,
  isNotWrapped: propTypes.bool,
  style: propTypes.any
});

_defineProperty(ModalHeader, "defaultProps", defaultProps$R);

function _createSuper$T(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$T()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$T() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$I = {
  "ModalContent": "ModalContent__ModalContent___2mf3h"
};
var defaultProps$S = {
  testId: 'cf-ui-modal-content'
};
var ModalContent = /*#__PURE__*/function (_Component) {
  _inherits(ModalContent, _Component);

  var _super = _createSuper$T(ModalContent);

  function ModalContent() {
    _classCallCheck(this, ModalContent);

    return _super.apply(this, arguments);
  }

  _createClass(ModalContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          testId = _this$props.testId,
          className = _this$props.className,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["testId", "className", "children"]);

      return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
        className: classnames(styles$I.ModalContent, className),
        "data-test-id": testId
      }), children);
    }
  }]);

  return ModalContent;
}(Component$1);
ModalContent.displayName = "ModalContent";

_defineProperty(ModalContent, "propTypes", {
  testId: propTypes.string,
  className: propTypes.string,
  children: propTypes.node.isRequired,
  style: propTypes.any
});

_defineProperty(ModalContent, "defaultProps", defaultProps$S);

function _createSuper$U(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$U()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$U() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$J = {
  "ModalControls": "ModalControls__ModalControls___2bTQx"
};
var defaultProps$T = {
  testId: 'cf-ui-modal-controls'
};
var ModalControls = /*#__PURE__*/function (_Component) {
  _inherits(ModalControls, _Component);

  var _super = _createSuper$U(ModalControls);

  function ModalControls() {
    _classCallCheck(this, ModalControls);

    return _super.apply(this, arguments);
  }

  _createClass(ModalControls, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          testId = _this$props.testId,
          className = _this$props.className,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["testId", "className", "children"]);

      return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
        className: classnames(styles$J.ModalControls, className),
        "data-test-id": testId
      }), children);
    }
  }]);

  return ModalControls;
}(Component$1);
ModalControls.displayName = "ModalControls";

_defineProperty(ModalControls, "propTypes", {
  testId: propTypes.string,
  className: propTypes.string,
  children: propTypes.node.isRequired,
  style: propTypes.any
});

_defineProperty(ModalControls, "defaultProps", defaultProps$T);

function _createSuper$V(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$V()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$V() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$K = {
  "Modal__portal": "Modal__Modal__portal___1AjJC",
  "Modal__overlay": "Modal__Modal__overlay___3gPyC",
  "Modal__overlay--after-open": "Modal__Modal__overlay--after-open___sRqhJ",
  "Modal__overlay--before-close": "Modal__Modal__overlay--before-close___3hzWL",
  "Modal__overlay--centered": "Modal__Modal__overlay--centered___2kDOU",
  "Modal__wrap": "Modal__Modal__wrap___BjfRz",
  "Modal__wrap--zen": "Modal__Modal__wrap--zen___32JOV",
  "Modal__wrap--after-open": "Modal__Modal__wrap--after-open___1XDbx",
  "Modal": "Modal__Modal___2S_pS",
  "Modal__wrap--before-close": "Modal__Modal__wrap--before-close___1jI3B",
  "Modal--overflow": "Modal__Modal--overflow___2FUtB",
  "Modal--zen": "Modal__Modal--zen___2t2w9"
};
var ModalSizesMapper = {
  medium: '520px',
  small: '400px',
  large: '700px',
  fullWidth: '100vw',
  zen: '100vw'
};
var defaultProps$U = {
  shouldCloseOnEscapePress: true,
  shouldCloseOnOverlayClick: true,
  position: 'center',
  testId: 'cf-ui-modal',
  topOffset: '50px',
  size: 'medium',
  allowHeightOverflow: false
};
var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper$V(Modal);

  function Modal() {
    _classCallCheck(this, Modal);

    return _super.apply(this, arguments);
  }

  _createClass(Modal, [{
    key: "renderDefault",
    value: function renderDefault() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.title && /*#__PURE__*/React.createElement(ModalHeader, _extends({
        title: this.props.title,
        onClose: this.props.onClose
      }, this.props.modalHeaderProps)), /*#__PURE__*/React.createElement(ModalContent, this.props.modalContentProps, this.props.children));
    }
  }, {
    key: "render",
    value: function render() {
      var _cn2, _cn3;

      return /*#__PURE__*/React.createElement(ReactModal, {
        ariaHideApp: false,
        onRequestClose: this.props.onClose,
        isOpen: this.props.isShown,
        onAfterOpen: this.props.onAfterOpen,
        shouldCloseOnEsc: this.props.shouldCloseOnEscapePress,
        shouldCloseOnOverlayClick: this.props.shouldCloseOnOverlayClick,
        portalClassName: styles$K.Modal__portal,
        className: {
          base: classnames(styles$K.Modal__wrap, _defineProperty({}, styles$K['Modal__wrap--zen'], this.props.size === 'zen')),
          afterOpen: styles$K['Modal__wrap--after-open'],
          beforeClose: styles$K['Modal__wrap--before-close']
        },
        style: {
          content: {
            top: this.props.position === 'center' ? 0 : this.props.topOffset
          }
        },
        overlayClassName: {
          base: classnames((_cn2 = {}, _defineProperty(_cn2, styles$K.Modal__overlay, true), _defineProperty(_cn2, styles$K['Modal__overlay--centered'], this.props.position === 'center'), _cn2)),
          afterOpen: styles$K['Modal__overlay--after-open'],
          beforeClose: styles$K['Modal__overlay--before-close']
        },
        htmlOpenClassName: "Modal__html--open",
        bodyOpenClassName: "Modal__body--open",
        closeTimeoutMS: 300
      }, /*#__PURE__*/React.createElement("div", {
        "data-test-id": this.props.testId,
        style: {
          width: ModalSizesMapper[this.props.size] || this.props.size
        },
        className: classnames(styles$K.Modal, this.props.className, (_cn3 = {}, _defineProperty(_cn3, styles$K['Modal--overflow'], this.props.allowHeightOverflow), _defineProperty(_cn3, styles$K['Modal--zen'], this.props.size === 'zen'), _cn3))
      }, typeof this.props.children === 'function' ? this.props.children(this.props) : this.renderDefault()));
    }
  }]);

  return Modal;
}(Component$1);
Modal.displayName = "Modal";

_defineProperty(Modal, "propTypes", {
  isShown: propTypes.bool.isRequired,
  onClose: propTypes.any.isRequired,
  onAfterOpen: propTypes.any,
  shouldCloseOnOverlayClick: propTypes.bool,
  shouldCloseOnEscapePress: propTypes.bool,
  position: propTypes.oneOf(['center', 'top']),
  topOffset: propTypes.oneOfType([propTypes.number, propTypes.string]),
  title: propTypes.string,
  size: propTypes.oneOfType([propTypes.oneOf(['small']), propTypes.oneOf(['medium']), propTypes.oneOf(['large']), propTypes.oneOf(['fullWidth']), propTypes.oneOf(['zen']), propTypes.string, propTypes.number]),
  allowHeightOverflow: propTypes.bool,
  modalHeaderProps: propTypes.any,
  modalContentProps: propTypes.any,
  className: propTypes.string,
  testId: propTypes.string,
  children: propTypes.any.isRequired
});

_defineProperty(Modal, "Header", ModalHeader);

_defineProperty(Modal, "Content", ModalContent);

_defineProperty(Modal, "Controls", ModalControls);

_defineProperty(Modal, "defaultProps", defaultProps$U);

function _createSuper$W(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$W()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$W() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$V = {
  testId: 'cf-ui-modal-confirm',
  confirmTestId: 'cf-ui-modal-confirm-confirm-button',
  secondaryTestId: 'cf-ui-modal-confirm-secondary-button',
  cancelTestId: 'cf-ui-modal-confirm-cancel-button',
  title: 'Are you sure?',
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
  intent: 'positive',
  shouldCloseOnOverlayClick: true,
  shouldCloseOnEscapePress: true,
  isConfirmDisabled: false,
  isConfirmLoading: false,
  size: 'medium',
  allowHeightOverflow: false
};
var ModalConfirm = /*#__PURE__*/function (_Component) {
  _inherits(ModalConfirm, _Component);

  var _super = _createSuper$W(ModalConfirm);

  function ModalConfirm() {
    _classCallCheck(this, ModalConfirm);

    return _super.apply(this, arguments);
  }

  _createClass(ModalConfirm, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          testId = _this$props.testId,
          isShown = _this$props.isShown,
          title = _this$props.title,
          onConfirm = _this$props.onConfirm,
          onSecondary = _this$props.onSecondary,
          onCancel = _this$props.onCancel,
          size = _this$props.size,
          confirmLabel = _this$props.confirmLabel,
          secondaryLabel = _this$props.secondaryLabel,
          cancelLabel = _this$props.cancelLabel,
          intent = _this$props.intent,
          secondaryIntent = _this$props.secondaryIntent,
          shouldCloseOnOverlayClick = _this$props.shouldCloseOnOverlayClick,
          shouldCloseOnEscapePress = _this$props.shouldCloseOnEscapePress,
          allowHeightOverflow = _this$props.allowHeightOverflow,
          isConfirmDisabled = _this$props.isConfirmDisabled,
          isSecondaryDisabled = _this$props.isSecondaryDisabled,
          isConfirmLoading = _this$props.isConfirmLoading,
          isSecondaryLoading = _this$props.isSecondaryLoading,
          confirmTestId = _this$props.confirmTestId,
          secondaryTestId = _this$props.secondaryTestId,
          cancelTestId = _this$props.cancelTestId;
      return /*#__PURE__*/React.createElement(Modal, {
        testId: testId,
        isShown: isShown,
        onClose: onCancel,
        size: size,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        allowHeightOverflow: allowHeightOverflow
      }, function () {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal.Header, _extends({
          title: title
        }, _this.props.modalHeaderProps)), /*#__PURE__*/React.createElement(Modal.Content, _this.props.modalContentProps, children), /*#__PURE__*/React.createElement(Modal.Controls, _this.props.modalControlsProps, confirmLabel && /*#__PURE__*/React.createElement(Button, {
          testId: confirmTestId,
          disabled: isConfirmDisabled,
          loading: isConfirmLoading,
          buttonType: intent,
          onClick: function onClick() {
            return onConfirm();
          }
        }, confirmLabel), secondaryLabel && /*#__PURE__*/React.createElement(Button, {
          testId: secondaryTestId,
          disabled: isSecondaryDisabled,
          loading: isSecondaryLoading,
          buttonType: secondaryIntent,
          onClick: function onClick() {
            return onSecondary && onSecondary();
          }
        }, secondaryLabel), cancelLabel && /*#__PURE__*/React.createElement(Button, {
          testId: cancelTestId,
          buttonType: "muted",
          onClick: function onClick() {
            return onCancel();
          }
        }, cancelLabel)));
      });
    }
  }]);

  return ModalConfirm;
}(Component$1);
ModalConfirm.displayName = "ModalConfirm";

_defineProperty(ModalConfirm, "propTypes", {
  isShown: propTypes.bool.isRequired,
  onConfirm: propTypes.any.isRequired,
  onSecondary: propTypes.any,
  onCancel: propTypes.any.isRequired,
  title: propTypes.string,
  confirmLabel: propTypes.oneOfType([propTypes.string, propTypes.oneOf([false])]),
  secondaryLabel: propTypes.oneOfType([propTypes.string, propTypes.oneOf([false])]),
  cancelLabel: propTypes.oneOfType([propTypes.string, propTypes.oneOf([false])]),
  intent: propTypes.oneOf(['primary', 'positive', 'negative']),
  secondaryIntent: propTypes.oneOf(['primary', 'positive', 'negative', 'muted']),
  size: propTypes.any,
  shouldCloseOnOverlayClick: propTypes.bool,
  shouldCloseOnEscapePress: propTypes.bool,
  isConfirmDisabled: propTypes.bool,
  isSecondaryDisabled: propTypes.bool,
  isConfirmLoading: propTypes.bool,
  isSecondaryLoading: propTypes.bool,
  allowHeightOverflow: propTypes.bool,
  modalHeaderProps: propTypes.any,
  modalContentProps: propTypes.any,
  modalControlsProps: propTypes.any,
  testId: propTypes.string,
  confirmTestId: propTypes.string,
  secondaryTestId: propTypes.string,
  cancelTestId: propTypes.string
});

_defineProperty(ModalConfirm, "defaultProps", defaultProps$V);

function _createSuper$X(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$X()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$X() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$L = {
  "FieldGroup": "FieldGroup__FieldGroup___2mLmO",
  "FieldGroup__item": "FieldGroup__FieldGroup__item___2qkC3",
  "FieldGroup--row": "FieldGroup__FieldGroup--row___17yyV"
};
var defaultProps$W = {
  row: false,
  testId: 'cf-ui-field-group'
};
var FieldGroup = /*#__PURE__*/function (_Component) {
  _inherits(FieldGroup, _Component);

  var _super = _createSuper$X(FieldGroup);

  function FieldGroup() {
    _classCallCheck(this, FieldGroup);

    return _super.apply(this, arguments);
  }

  _createClass(FieldGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          row = _this$props.row,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "row", "testId"]);

      var classNames = classnames(styles$L.FieldGroup, styles$L.className, _defineProperty({}, styles$L['FieldGroup--row'], row));
      return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
        "data-test-id": testId,
        className: classNames
      }), React.Children.map(children, function (child) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles$L.FieldGroup__item
        }, child);
      }));
    }
  }]);

  return FieldGroup;
}(Component$1);
FieldGroup.displayName = "FieldGroup";

_defineProperty(FieldGroup, "propTypes", {
  className: propTypes.string,
  children: propTypes.node.isRequired,
  style: propTypes.any,
  testId: propTypes.string,
  row: propTypes.bool
});

_defineProperty(FieldGroup, "defaultProps", defaultProps$W);

function _createSuper$Y(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$Y()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$Y() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$M = {
  "Form": "Form__Form___2zwZf",
  "Form__item": "Form__Form__item___2qOZE",
  "Form__item--default": "Form__Form__item--default___1CHMK",
  "Form__item--condensed": "Form__Form__item--condensed___2iooB"
};
var defaultProps$X = {
  spacing: 'default',
  testId: 'cf-ui-form'
};
var Form = /*#__PURE__*/function (_Component) {
  _inherits(Form, _Component);

  var _super = _createSuper$Y(Form);

  function Form() {
    var _this;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      event.preventDefault();

      if (_this.props.onSubmit) {
        _this.props.onSubmit(event);
      }
    });

    return _this;
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          onSubmit = _this$props.onSubmit,
          spacing = _this$props.spacing,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "onSubmit", "spacing"]);

      var classNames = classnames(styles$M.Form, className);
      var formItemClassNames = classnames(styles$M.Form__item, styles$M["Form__item--".concat(spacing)]);
      return /*#__PURE__*/React.createElement("form", _extends({
        className: classNames,
        "data-test-id": testId,
        onSubmit: this.handleSubmit
      }, otherProps), React.Children.map(children, function (child) {
        if (child) {
          return /*#__PURE__*/React.createElement("div", {
            className: formItemClassNames
          }, child);
        }

        return null;
      }));
    }
  }]);

  return Form;
}(Component$1);
Form.displayName = "Form";

_defineProperty(Form, "propTypes", {
  onSubmit: propTypes.func,
  spacing: propTypes.oneOf(['condensed', 'default']),
  testId: propTypes.string,
  style: propTypes.any,
  className: propTypes.string,
  children: propTypes.oneOfType([propTypes.any, propTypes.any]).isRequired
});

_defineProperty(Form, "defaultProps", defaultProps$X);

var iconName = {
  ArrowDown: 'ArrowDown',
  ArrowDownTrimmed: 'ArrowDownTrimmed',
  ArrowUp: 'ArrowUp',
  ArrowUpTrimmed: 'ArrowUpTrimmed',
  Asset: 'Asset',
  AssetTrimmed: 'AssetTrimmed',
  ChatBubble: 'ChatBubble',
  ChatBubbleTrimmed: 'ChatBubbleTrimmed',
  CheckCircle: 'CheckCircle',
  CheckCircleTrimmed: 'CheckCircleTrimmed',
  ChevronDown: 'ChevronDown',
  ChevronDownTrimmed: 'ChevronDownTrimmed',
  ChevronLeft: 'ChevronLeft',
  ChevronLeftTrimmed: 'ChevronLeftTrimmed',
  ChevronRight: 'ChevronRight',
  ChevronRightTrimmed: 'ChevronRightTrimmed',
  ChevronUp: 'ChevronUp',
  ChevronUpTrimmed: 'ChevronUpTrimmed',
  Clock: 'Clock',
  ClockTrimmed: 'ClockTrimmed',
  Close: 'Close',
  CloseTrimmed: 'CloseTrimmed',
  Code: 'Code',
  CodeTrimmed: 'CodeTrimmed',
  Copy: 'Copy',
  CopyTrimmed: 'CopyTrimmed',
  Cycle: 'Cycle',
  CycleTrimmed: 'CycleTrimmed',
  Delete: 'Delete',
  DeleteTrimmed: 'DeleteTrimmed',
  Download: 'Download',
  DownloadTrimmed: 'DownloadTrimmed',
  Drag: 'Drag',
  DragTrimmed: 'DragTrimmed',
  Edit: 'Edit',
  EditTrimmed: 'EditTrimmed',
  EmbeddedEntryBlock: 'EmbeddedEntryBlock',
  EmbeddedEntryBlockTrimmed: 'EmbeddedEntryBlockTrimmed',
  EmbeddedEntryInline: 'EmbeddedEntryInline',
  EmbeddedEntryInlineTrimmed: 'EmbeddedEntryInlineTrimmed',
  Entry: 'Entry',
  EntryTrimmed: 'EntryTrimmed',
  ErrorCircle: 'ErrorCircle',
  ErrorCircleTrimmed: 'ErrorCircleTrimmed',
  ExternalLink: 'ExternalLink',
  ExternalLinkTrimmed: 'ExternalLinkTrimmed',
  FaceHappy: 'FaceHappy',
  FaceHappyTrimmed: 'FaceHappyTrimmed',
  Filter: 'Filter',
  FilterTrimmed: 'FilterTrimmed',
  Folder: 'Folder',
  FolderCreate: 'FolderCreate',
  FolderCreateTrimmed: 'FolderCreateTrimmed',
  FolderOpen: 'FolderOpen',
  FolderOpenTrimmed: 'FolderOpenTrimmed',
  FolderTrimmed: 'FolderTrimmed',
  FormatBold: 'FormatBold',
  FormatBoldTrimmed: 'FormatBoldTrimmed',
  FormatItalic: 'FormatItalic',
  FormatItalicTrimmed: 'FormatItalicTrimmed',
  FormatUnderlined: 'FormatUnderlined',
  FormatUnderlinedTrimmed: 'FormatUnderlinedTrimmed',
  Heading: 'Heading',
  HeadingOne: 'HeadingOne',
  HeadingOneTrimmed: 'HeadingOneTrimmed',
  HeadingTrimmed: 'HeadingTrimmed',
  HeadingTwo: 'HeadingTwo',
  HeadingTwoTrimmed: 'HeadingTwoTrimmed',
  HelpCircle: 'HelpCircle',
  HelpCircleTrimmed: 'HelpCircleTrimmed',
  HorizontalRule: 'HorizontalRule',
  HorizontalRuleTrimmed: 'HorizontalRuleTrimmed',
  InfoCircle: 'InfoCircle',
  InfoCircleTrimmed: 'InfoCircleTrimmed',
  Link: 'Link',
  LinkTrimmed: 'LinkTrimmed',
  ListBulleted: 'ListBulleted',
  ListBulletedTrimmed: 'ListBulletedTrimmed',
  ListNumbered: 'ListNumbered',
  ListNumberedTrimmed: 'ListNumberedTrimmed',
  Lock: 'Lock',
  LockTrimmed: 'LockTrimmed',
  LooksOne: 'LooksOne',
  LooksOneTrimmed: 'LooksOneTrimmed',
  LooksTwo: 'LooksTwo',
  LooksTwoTrimmed: 'LooksTwoTrimmed',
  Menu: 'Menu',
  MenuTrimmed: 'MenuTrimmed',
  MoreHorizontal: 'MoreHorizontal',
  MoreHorizontalTrimmed: 'MoreHorizontalTrimmed',
  MoreVertical: 'MoreVertical',
  MoreVerticalTrimmed: 'MoreVerticalTrimmed',
  Plus: 'Plus',
  PlusCircle: 'PlusCircle',
  PlusCircleTrimmed: 'PlusCircleTrimmed',
  PlusTrimmed: 'PlusTrimmed',
  Quote: 'Quote',
  QuoteTrimmed: 'QuoteTrimmed',
  References: 'References',
  Release: 'Release',
  ReleaseTrimmed: 'ReleaseTrimmed',
  Receipt: 'Receipt',
  ReceiptTrimmed: 'ReceiptTrimmed',
  Search: 'Search',
  SearchTrimmed: 'SearchTrimmed',
  Settings: 'Settings',
  SettingsTrimmed: 'SettingsTrimmed',
  ShoppingCart: 'ShoppingCart',
  ShoppingCartTrimmed: 'ShoppingCartTrimmed',
  Star: 'Star',
  StarTrimmed: 'StarTrimmed',
  Tags: 'Tags',
  Text: 'Text',
  TextTrimmed: 'TextTrimmed',
  ThumbDown: 'ThumbDown',
  ThumbDownTrimmed: 'ThumbDownTrimmed',
  ThumbUp: 'ThumbUp',
  ThumbUpTrimmed: 'ThumbUpTrimmed',
  Users: 'Users',
  UsersTrimmed: 'UsersTrimmed',
  Warning: 'Warning',
  WarningTrimmed: 'WarningTrimmed'
};

function _createSuper$Z(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$Z()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$Z() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$N = {
  "Note": "Note__Note___2eSKN",
  "Note--primary": "Note__Note--primary___-8-7D",
  "Note--negative": "Note__Note--negative___3fkwL",
  "Note--positive": "Note__Note--positive___3Omoh",
  "Note--warning": "Note__Note--warning___3X53I",
  "Note__title": "Note__Note__title___2nwpx",
  "Note__icon": "Note__Note__icon___20RqC"
};
var Icons = {
  primary: iconName.InfoCircle,
  positive: iconName.CheckCircle,
  negative: iconName.Warning,
  warning: iconName.Warning
};
var defaultProps$Y = {
  noteType: 'primary',
  testId: 'cf-ui-note'
};
var Note = /*#__PURE__*/function (_Component) {
  _inherits(Note, _Component);

  var _super = _createSuper$Z(Note);

  function Note() {
    _classCallCheck(this, Note);

    return _super.apply(this, arguments);
  }

  _createClass(Note, [{
    key: "render",
    value: function render() {
      var _classNames;

      var icon = Icons[this.props.noteType];

      if (!icon) {
        throw new Error("Intent ".concat(this.props.noteType, " is not supported in Note component."));
      }

      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style,
        className: classnames(styles$N.Note, this.props.className, (_classNames = {}, _defineProperty(_classNames, styles$N['Note--primary'], this.props.noteType === 'primary'), _defineProperty(_classNames, styles$N['Note--positive'], this.props.noteType === 'positive'), _defineProperty(_classNames, styles$N['Note--negative'], this.props.noteType === 'negative'), _defineProperty(_classNames, styles$N['Note--warning'], this.props.noteType === 'warning'), _classNames)),
        "data-test-id": this.props.testId
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$N.Note__icon
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: icon,
        color: this.props.noteType
      })), /*#__PURE__*/React.createElement("div", {
        className: styles$N.Note__info
      }, this.props.title && /*#__PURE__*/React.createElement("div", {
        className: styles$N.Note__title
      }, this.props.title), /*#__PURE__*/React.createElement("div", null, this.props.children)));
    }
  }]);

  return Note;
}(Component$1);
Note.displayName = "Note";

_defineProperty(Note, "propTypes", {
  noteType: propTypes.oneOf(['primary', 'positive', 'negative', 'warning']).isRequired,
  className: propTypes.string,
  title: propTypes.string,
  style: propTypes.any,
  testId: propTypes.string,
  children: propTypes.node.isRequired
});

_defineProperty(Note, "defaultProps", defaultProps$Y);

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var AnimateHeight_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(propTypes);



var _classnames2 = _interopRequireDefault(classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_STATE_CLASSES = {
  animating: 'rah-animating',
  animatingUp: 'rah-animating--up',
  animatingDown: 'rah-animating--down',
  animatingToHeightZero: 'rah-animating--to-height-zero',
  animatingToHeightAuto: 'rah-animating--to-height-auto',
  animatingToHeightSpecific: 'rah-animating--to-height-specific',
  static: 'rah-static',
  staticHeightZero: 'rah-static--height-zero',
  staticHeightAuto: 'rah-static--height-auto',
  staticHeightSpecific: 'rah-static--height-specific'
};

var PROPS_TO_OMIT = ['animateOpacity', 'animationStateClasses', 'applyInlineTransitions', 'children', 'contentClassName', 'delay', 'duration', 'easing', 'height', 'onAnimationEnd', 'onAnimationStart'];

function omit(obj) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  if (!keys.length) {
    return obj;
  }

  var res = {};
  var objectKeys = Object.keys(obj);

  for (var i = 0; i < objectKeys.length; i++) {
    var key = objectKeys[i];

    if (keys.indexOf(key) === -1) {
      res[key] = obj[key];
    }
  }

  return res;
}

// Start animation helper using nested requestAnimationFrames
function startAnimationHelper(callback) {
  var requestAnimationFrameIDs = [];

  requestAnimationFrameIDs[0] = requestAnimationFrame(function () {
    requestAnimationFrameIDs[1] = requestAnimationFrame(function () {
      callback();
    });
  });

  return requestAnimationFrameIDs;
}

function cancelAnimationFrames(requestAnimationFrameIDs) {
  requestAnimationFrameIDs.forEach(function (id) {
    return cancelAnimationFrame(id);
  });
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function isPercentage(height) {
  // Percentage height
  return typeof height === 'string' && height.search('%') === height.length - 1 && isNumber(height.substr(0, height.length - 1));
}

function runCallback(callback, params) {
  if (callback && typeof callback === 'function') {
    callback(params);
  }
}

var AnimateHeight = function (_React$Component) {
  _inherits(AnimateHeight, _React$Component);

  function AnimateHeight(props) {
    _classCallCheck(this, AnimateHeight);

    var _this = _possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));

    _this.animationFrameIDs = [];

    var height = 'auto';
    var overflow = 'visible';

    if (isNumber(props.height)) {
      // If value is string "0" make sure we convert it to number 0
      height = props.height < 0 || props.height === '0' ? 0 : props.height;
      overflow = 'hidden';
    } else if (isPercentage(props.height)) {
      // If value is string "0%" make sure we convert it to number 0
      height = props.height === '0%' ? 0 : props.height;
      overflow = 'hidden';
    }

    _this.animationStateClasses = _extends({}, ANIMATION_STATE_CLASSES, props.animationStateClasses);

    var animationStateClasses = _this.getStaticStateClasses(height);

    _this.state = {
      animationStateClasses: animationStateClasses,
      height: height,
      overflow: overflow,
      shouldUseTransitions: false
    };
    return _this;
  }

  _createClass(AnimateHeight, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var height = this.state.height;

      // Hide content if height is 0 (to prevent tabbing into it)
      // Check for contentElement is added cause this would fail in tests (react-test-renderer)
      // Read more here: https://github.com/Stanko/react-animate-height/issues/17

      if (this.contentElement && this.contentElement.style) {
        this.hideContent(height);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props = this.props,
          delay = _props.delay,
          duration = _props.duration,
          height = _props.height,
          onAnimationEnd = _props.onAnimationEnd,
          onAnimationStart = _props.onAnimationStart;

      // Check if 'height' prop has changed

      if (this.contentElement && height !== prevProps.height) {
        var _cx;

        // Remove display: none from the content div
        // if it was hidden to prevent tabbing into it
        this.showContent(prevState.height);

        // Cache content height
        this.contentElement.style.overflow = 'hidden';
        var contentHeight = this.contentElement.offsetHeight;
        this.contentElement.style.overflow = '';

        // set total animation time
        var totalDuration = duration + delay;

        var newHeight = null;
        var timeoutState = {
          height: null, // it will be always set to either 'auto' or specific number
          overflow: 'hidden'
        };
        var isCurrentHeightAuto = prevState.height === 'auto';

        if (isNumber(height)) {
          // If value is string "0" make sure we convert it to number 0
          newHeight = height < 0 || height === '0' ? 0 : height;
          timeoutState.height = newHeight;
        } else if (isPercentage(height)) {
          // If value is string "0%" make sure we convert it to number 0
          newHeight = height === '0%' ? 0 : height;
          timeoutState.height = newHeight;
        } else {
          // If not, animate to content height
          // and then reset to auto
          newHeight = contentHeight; // TODO solve contentHeight = 0
          timeoutState.height = 'auto';
          timeoutState.overflow = null;
        }

        if (isCurrentHeightAuto) {
          // This is the height to be animated to
          timeoutState.height = newHeight;

          // If previous height was 'auto'
          // set starting height explicitly to be able to use transition
          newHeight = contentHeight;
        }

        // Animation classes
        var animationStateClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, this.animationStateClasses.animating, true), _defineProperty(_cx, this.animationStateClasses.animatingUp, prevProps.height === 'auto' || height < prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingDown, height === 'auto' || height > prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), _defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), _defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx));

        // Animation classes to be put after animation is complete
        var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);

        // Set starting height and animating classes
        // We are safe to call set state as it will not trigger infinite loop
        // because of the "height !== prevProps.height" check
        this.setState({ // eslint-disable-line react/no-did-update-set-state
          animationStateClasses: animationStateClasses,
          height: newHeight,
          overflow: 'hidden',
          // When animating from 'auto' we first need to set fixed height
          // that change should be animated
          shouldUseTransitions: !isCurrentHeightAuto
        });

        // Clear timeouts
        clearTimeout(this.timeoutID);
        clearTimeout(this.animationClassesTimeoutID);

        if (isCurrentHeightAuto) {
          // When animating from 'auto' we use a short timeout to start animation
          // after setting fixed height above
          timeoutState.shouldUseTransitions = true;

          cancelAnimationFrames(this.animationFrameIDs);
          this.animationFrameIDs = startAnimationHelper(function () {
            _this2.setState(timeoutState);

            // ANIMATION STARTS, run a callback if it exists
            runCallback(onAnimationStart, { newHeight: timeoutState.height });
          });

          // Set static classes and remove transitions when animation ends
          this.animationClassesTimeoutID = setTimeout(function () {
            _this2.setState({
              animationStateClasses: timeoutAnimationStateClasses,
              shouldUseTransitions: false
            });

            // ANIMATION ENDS
            // Hide content if height is 0 (to prevent tabbing into it)
            _this2.hideContent(timeoutState.height);
            // Run a callback if it exists
            runCallback(onAnimationEnd, { newHeight: timeoutState.height });
          }, totalDuration);
        } else {
          // ANIMATION STARTS, run a callback if it exists
          runCallback(onAnimationStart, { newHeight: newHeight });

          // Set end height, classes and remove transitions when animation is complete
          this.timeoutID = setTimeout(function () {
            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
            timeoutState.shouldUseTransitions = false;

            _this2.setState(timeoutState);

            // ANIMATION ENDS
            // If height is auto, don't hide the content
            // (case when element is empty, therefore height is 0)
            if (height !== 'auto') {
              // Hide content if height is 0 (to prevent tabbing into it)
              _this2.hideContent(newHeight); // TODO solve newHeight = 0
            }
            // Run a callback if it exists
            runCallback(onAnimationEnd, { newHeight: newHeight });
          }, totalDuration);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      cancelAnimationFrames(this.animationFrameIDs);

      clearTimeout(this.timeoutID);
      clearTimeout(this.animationClassesTimeoutID);

      this.timeoutID = null;
      this.animationClassesTimeoutID = null;
      this.animationStateClasses = null;
    }
  }, {
    key: 'showContent',
    value: function showContent(height) {
      if (height === 0) {
        this.contentElement.style.display = '';
      }
    }
  }, {
    key: 'hideContent',
    value: function hideContent(newHeight) {
      if (newHeight === 0) {
        this.contentElement.style.display = 'none';
      }
    }
  }, {
    key: 'getStaticStateClasses',
    value: function getStaticStateClasses(height) {
      var _cx2;

      return (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, this.animationStateClasses.static, true), _defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx3,
          _this3 = this;

      var _props2 = this.props,
          animateOpacity = _props2.animateOpacity,
          applyInlineTransitions = _props2.applyInlineTransitions,
          children = _props2.children,
          className = _props2.className,
          contentClassName = _props2.contentClassName,
          duration = _props2.duration,
          easing = _props2.easing,
          delay = _props2.delay,
          style = _props2.style;
      var _state = this.state,
          height = _state.height,
          overflow = _state.overflow,
          animationStateClasses = _state.animationStateClasses,
          shouldUseTransitions = _state.shouldUseTransitions;


      var componentStyle = _extends({}, style, {
        height: height,
        overflow: overflow || style.overflow
      });

      if (shouldUseTransitions && applyInlineTransitions) {
        componentStyle.transition = 'height ' + duration + 'ms ' + easing + ' ' + delay + 'ms';

        // Include transition passed through styles
        if (style.transition) {
          componentStyle.transition = style.transition + ', ' + componentStyle.transition;
        }

        // Add webkit vendor prefix still used by opera, blackberry...
        componentStyle.WebkitTransition = componentStyle.transition;
      }

      var contentStyle = {};

      if (animateOpacity) {
        contentStyle.transition = 'opacity ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
        // Add webkit vendor prefix still used by opera, blackberry...
        contentStyle.WebkitTransition = contentStyle.transition;

        if (height === 0) {
          contentStyle.opacity = 0;
        }
      }

      var componentClasses = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, animationStateClasses, true), _defineProperty(_cx3, className, className), _cx3));

      return _react2.default.createElement(
        'div',
        _extends({}, omit.apply(undefined, [this.props].concat(PROPS_TO_OMIT)), {
          'aria-hidden': height === 0,
          className: componentClasses,
          style: componentStyle
        }),
        _react2.default.createElement(
          'div',
          {
            className: contentClassName,
            style: contentStyle,
            ref: function ref(el) {
              return _this3.contentElement = el;
            }
          },
          children
        )
      );
    }
  }]);

  return AnimateHeight;
}(_react2.default.Component);

var heightPropType = function heightPropType(props, propName, componentName) {
  var value = props[propName];

  if (typeof value === 'number' && value >= 0 || isPercentage(value) || value === 'auto') {
    return null;
  }

  return new TypeError('value "' + value + '" of type "' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)) + '" is invalid type for ' + propName + ' in ' + componentName + '. ' + 'It needs to be a positive number, string "auto" or percentage string (e.g. "15%").');
};

AnimateHeight.propTypes = {
  animateOpacity: _propTypes2.default.bool,
  animationStateClasses: _propTypes2.default.object,
  applyInlineTransitions: _propTypes2.default.bool,
  children: _propTypes2.default.any.isRequired,
  className: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  duration: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  easing: _propTypes2.default.string,
  height: heightPropType,
  onAnimationEnd: _propTypes2.default.func,
  onAnimationStart: _propTypes2.default.func,
  style: _propTypes2.default.object
};

AnimateHeight.defaultProps = {
  animateOpacity: false,
  animationStateClasses: ANIMATION_STATE_CLASSES,
  applyInlineTransitions: true,
  duration: 250,
  delay: 0,
  easing: 'ease',
  style: {}
};

exports.default = AnimateHeight;
});

var AnimateHeight = unwrapExports(AnimateHeight_1);

function _createSuper$_(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$_()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$_() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$O = {
  "NotificationItem": "NotificationItem__NotificationItem___22iZo",
  "NotificationItem__intent": "NotificationItem__NotificationItem__intent___cC494 helpers__sr-only___3Kv3z",
  "NotificationItem__icon": "NotificationItem__NotificationItem__icon___3gdKj",
  "NotificationItem__icon--success": "NotificationItem__NotificationItem__icon--success___jzA45",
  "NotificationItem__icon--error": "NotificationItem__NotificationItem__icon--error___nAbZQ",
  "NotificationItem__icon--warning": "NotificationItem__NotificationItem__icon--warning___2aEPB",
  "NotificationItem__content": "NotificationItem__NotificationItem__content___2z-pT",
  "NotificationItem__text": "NotificationItem__NotificationItem__text___1-1Up",
  "NotificationItem__title": "NotificationItem__NotificationItem__title___126c1",
  "NotificationItem__body": "NotificationItem__NotificationItem__body___11cuA",
  "NotificationItem__dismiss": "NotificationItem__NotificationItem__dismiss___1Z6Df"
};
var defaultProps$Z = {
  testId: 'cf-ui-notification',
  intent: 'success',
  hasCloseButton: true
};
var NotificationItem = /*#__PURE__*/function (_Component) {
  _inherits(NotificationItem, _Component);

  var _super = _createSuper$_(NotificationItem);

  function NotificationItem() {
    _classCallCheck(this, NotificationItem);

    return _super.apply(this, arguments);
  }

  _createClass(NotificationItem, [{
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$O.NotificationItem__title
      }, title ? title : children);
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          children = _this$props2.children;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$O.NotificationItem__body
      }, title && children);
    }
  }, {
    key: "renderCta",
    value: function renderCta() {
      var cta = this.props.cta;
      if (cta && cta.label) return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextLink, cta.textLinkProps, cta.label));
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var intent = this.props.intent;
      var iconClasses = classnames(styles$O.NotificationItem__icon, _defineProperty({}, styles$O["NotificationItem__icon--".concat(intent)], true));
      var icon;

      switch (intent) {
        case 'success':
          icon = 'CheckCircle';
          break;

        case 'warning':
          icon = 'Warning';
          break;

        case 'error':
          icon = 'ErrorCircle';
          break;

        default:
          icon = 'ErrorCircle';
      }

      return /*#__PURE__*/React.createElement("div", {
        className: iconClasses,
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: icon,
        color: "white"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          testId = _this$props3.testId,
          intent = _this$props3.intent,
          onClose = _this$props3.onClose,
          hasCloseButton = _this$props3.hasCloseButton;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$O.NotificationItem,
        "data-test-id": testId,
        "data-intent": intent,
        role: "alert",
        "aria-live": intent === 'success' ? 'polite' : 'assertive'
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$O.NotificationItem__intent
      }, intent), this.renderIcon(), /*#__PURE__*/React.createElement("div", {
        className: styles$O.NotificationItem__content
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$O.NotificationItem__text
      }, this.renderTitle(), this.renderBody(), this.renderCta()), hasCloseButton && /*#__PURE__*/React.createElement(IconButton, {
        buttonType: "secondary",
        iconProps: {
          icon: 'Close'
        },
        onClick: function onClick() {
          if (onClose) {
            onClose();
          }
        },
        testId: "cf-ui-notification-close",
        label: "Dismiss",
        className: styles$O.NotificationItem__dismiss
      })));
    }
  }]);

  return NotificationItem;
}(Component$1);
NotificationItem.displayName = "NotificationItem";

_defineProperty(NotificationItem, "propTypes", {
  intent: propTypes.oneOf(['success', 'error', 'warning']).isRequired,
  hasCloseButton: propTypes.bool,
  onClose: propTypes.any,
  testId: propTypes.string,
  children: propTypes.node.isRequired,
  title: propTypes.string,
  cta: propTypes.any
});

_defineProperty(NotificationItem, "defaultProps", defaultProps$Z);

function _createSuper$$(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$$()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$$() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$_ = {
  isShown: false
};
var NotificationItemContainer = /*#__PURE__*/function (_Component) {
  _inherits(NotificationItemContainer, _Component);

  var _super = _createSuper$$(NotificationItemContainer);

  function NotificationItemContainer() {
    var _this;

    _classCallCheck(this, NotificationItemContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "timer", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isShown: false
    });

    _defineProperty(_assertThisInitialized(_this), "startTimer", function () {
      if (_this.props.duration) {
        if (_this.props.duration === 0) return;
        _this.timer = setTimeout(function () {
          _this.close();
        }, _this.props.duration);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "stopTimer", function () {
      if (_this.props.duration === 0) return;

      if (_this.timer) {
        clearTimeout(_this.timer);
        _this.timer = null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.stopTimer();

      _this.setState({
        isShown: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      _this.stopTimer();
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.startTimer();
    });

    return _this;
  }

  _createClass(NotificationItemContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startTimer(); // eslint-disable-next-line

      this.setState({
        isShown: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isShown !== this.props.isShown) {
        // eslint-disable-next-line
        this.setState({
          isShown: this.props.isShown
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          duration = _this$props.duration,
          rest = _objectWithoutProperties(_this$props, ["duration"]);

      return /*#__PURE__*/React.createElement(AnimateHeight, {
        duration: 200,
        height: this.state.isShown ? 'auto' : 0,
        easing: "ease-in-out",
        animateOpacity: true,
        onAnimationEnd: function onAnimationEnd() {
          if (_this2.state.isShown === false) {
            if (_this2.props.onClose) {
              _this2.props.onClose();
            }
          }
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          pointerEvents: 'all'
        },
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, /*#__PURE__*/React.createElement(NotificationItem, _extends({}, rest, {
        onClose: this.close
      }))));
    }
  }]);

  return NotificationItemContainer;
}(Component$1);
NotificationItemContainer.displayName = "NotificationItemContainer";

_defineProperty(NotificationItemContainer, "propTypes", {
  duration: propTypes.number,
  isShown: propTypes.bool
});

_defineProperty(NotificationItemContainer, "defaultProps", defaultProps$_);

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$10(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$10()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$10() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$P = {
  "NotificationsManager": "NotificationsManager__NotificationsManager___1uvY2",
  "NotificationsManager__container": "NotificationsManager__NotificationsManager__container___3U0e9",
  "NotificationsManager--top": "NotificationsManager__NotificationsManager--top___aRv7j"
};
var uniqueId = 0;

var getUniqueId = function getUniqueId() {
  uniqueId += 1;
  return uniqueId;
};

var NotificationsManager = /*#__PURE__*/function (_PureComponent) {
  _inherits(NotificationsManager, _PureComponent);

  var _super = _createSuper$10(NotificationsManager);

  function NotificationsManager(props) {
    var _this;

    _classCallCheck(this, NotificationsManager);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setPosition", function (position, params) {
      if (position === 'bottom' || position === 'top') {
        var positionOffset = params && params.offset ? params.offset : 20;

        _this.setState({
          position: position,
          positionOffset: positionOffset
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setDuration", function (duration) {
      _this.setState({
        duration: duration
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function (id) {
      _this.setState(function (state) {
        return {
          items: state.items.map(function (item) {
            if (item.id !== id) {
              return item;
            }

            return _objectSpread$8({}, item, {
              isShown: false
            });
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeAndDelete", function (id) {
      _this.setState(function (state) {
        return {
          items: state.items.filter(function (item) {
            return item.id !== id;
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeAll", function () {
      _this.setState(function (state) {
        return {
          items: state.items.map(function (item) {
            return _objectSpread$8({}, item, {
              isShown: false
            });
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "show", function (text, settings) {
      var duration = settings && typeof settings.duration !== 'undefined' // Needed as 0 is falsy but 0 is valid to disable auto-closing a notification
      ? settings.duration : _this.state.duration;
      var intent = settings && settings.intent ? settings.intent : 'success';
      var canClose = settings && typeof settings.canClose !== 'undefined' ? settings.canClose : true;
      var notificationId = settings && settings.id ? settings.id : getUniqueId();
      var notification = {
        id: notificationId,
        text: text,
        close: function close() {
          return _this.closeAndDelete(notificationId);
        },
        duration: duration,
        canClose: canClose,
        isShown: true,
        intent: intent,
        title: settings && settings.title,
        cta: settings && settings.cta
      };

      var alreadyThere = _this.state.items.find(function (item) {
        return item.id === notification.id;
      });

      if (alreadyThere) {
        return alreadyThere;
      }

      _this.setState(function (state) {
        if (state.position === 'top') {
          return _objectSpread$8({}, state, {
            items: [notification].concat(_toConsumableArray(state.items))
          });
        }

        return _objectSpread$8({}, state, {
          items: [].concat(_toConsumableArray(state.items), [notification])
        });
      });

      return notification;
    });

    _this.state = {
      items: [],
      position: 'bottom',
      positionOffset: 20,
      duration: 6000
    };

    _this.props.register('close', _this.close);

    _this.props.register('show', _this.show);

    _this.props.register('closeAll', _this.closeAll);

    _this.props.register('setPosition', _this.setPosition);

    _this.props.register('setDuration', _this.setDuration);

    return _this;
  }

  _createClass(NotificationsManager, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-test-id": "cf-notification-container",
        className: classnames(styles$P.NotificationsManager, _defineProperty({}, styles$P["NotificationsManager--top"], this.state.position === 'top')),
        style: _defineProperty({}, this.state.position, this.state.positionOffset)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$P.NotificationsManager__container
      }, this.state.items.map(function (item) {
        return /*#__PURE__*/React.createElement(NotificationItemContainer, {
          intent: item.intent,
          duration: item.duration,
          key: item.id,
          hasCloseButton: item.canClose,
          onClose: item.close,
          isShown: item.isShown,
          title: item.title,
          cta: item.cta
        }, item.text);
      })));
    }
  }]);

  return NotificationsManager;
}(PureComponent);
NotificationsManager.displayName = "NotificationsManager";

_defineProperty(NotificationsManager, "propTypes", {
  register: propTypes.func.isRequired
});

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var initiated = false;
var internalAPI = {};

function registerAPI(fnName, fn) {
  internalAPI[fnName] = fn;
}

function createRoot(callback) {
  var container = document.createElement('div');
  document.body.appendChild(container);
  render( /*#__PURE__*/React.createElement(NotificationsManager, {
    register: registerAPI
  }), container, callback);
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


var afterInit = function afterInit(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!initiated) {
      initiated = true;
      return new Promise(function (resolve) {
        createRoot(function () {
          resolve(fn.apply(void 0, args));
        });
      });
    } else {
      return Promise.resolve(fn.apply(void 0, args));
    }
  };
};

var show = function show(intent) {
  return function (text, settings) {
    if (internalAPI.show) {
      return internalAPI.show(text, _objectSpread$9({}, settings || {}, {
        intent: intent
      }));
    }
  };
};

var Notification = {
  success: afterInit(show('success')),
  error: afterInit(show('error')),
  warning: afterInit(show('warning')),
  close: afterInit(function (id) {
    if (internalAPI.close) {
      return internalAPI.close(id);
    }
  }),
  closeAll: afterInit(function () {
    if (internalAPI.closeAll) {
      return internalAPI.closeAll();
    }
  }),
  setPosition: afterInit(function (position, params) {
    if (internalAPI.setPosition) {
      return internalAPI.setPosition(position, params);
    }
  }),
  setDuration: afterInit(function (duration) {
    if (internalAPI.setDuration) {
      return internalAPI.setDuration(duration);
    }
  })
};

function _createSuper$11(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$11()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$11() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$$ = {
  required: false,
  disabled: false,
  type: 'radio',
  testId: 'cf-ui-radio-button',
  willBlurOnEsc: true
};
var RadioButton = /*#__PURE__*/function (_Component) {
  _inherits(RadioButton, _Component);

  var _super = _createSuper$11(RadioButton);

  function RadioButton() {
    _classCallCheck(this, RadioButton);

    return _super.apply(this, arguments);
  }

  _createClass(RadioButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ControlledInput, this.props);
    }
  }]);

  return RadioButton;
}(Component$1);
RadioButton.displayName = "RadioButton";

_defineProperty(RadioButton, "defaultProps", defaultProps$$);

RadioButton.defaultProps = defaultProps$$;

function _createSuper$12(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$12()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$12() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$10 = {
  labelIsLight: false,
  checked: false,
  inputType: 'checkbox',
  testId: 'cf-ui-radio-button-field'
};
var RadioButtonField = /*#__PURE__*/function (_Component) {
  _inherits(RadioButtonField, _Component);

  var _super = _createSuper$12(RadioButtonField);

  function RadioButtonField() {
    _classCallCheck(this, RadioButtonField);

    return _super.apply(this, arguments);
  }

  _createClass(RadioButtonField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["testId"]);

      return /*#__PURE__*/React.createElement(ControlledInputField, _extends({
        testId: testId
      }, otherProps, {
        inputType: "radio"
      }));
    }
  }]);

  return RadioButtonField;
}(Component$1);
RadioButtonField.displayName = "RadioButtonField";

_defineProperty(RadioButtonField, "defaultProps", defaultProps$10);

function _createSuper$13(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$13()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$13() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$Q = {
  "Subheading": "Subheading__Subheading___2mA9j"
};
var defaultProps$11 = {
  element: 'h2',
  testId: 'cf-ui-subheading'
};
var Subheading = /*#__PURE__*/function (_Component) {
  _inherits(Subheading, _Component);

  var _super = _createSuper$13(Subheading);

  function Subheading() {
    _classCallCheck(this, Subheading);

    return _super.apply(this, arguments);
  }

  _createClass(Subheading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          element = _this$props.element,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "element"]);

      var classNames = classnames(styles$Q['Subheading'], className);
      var Element = element;
      return /*#__PURE__*/React.createElement(TypographyContext.Consumer, null, function (value) {
        return /*#__PURE__*/React.createElement(Element, _extends({
          className: classnames(classNames, [value['subheading'] && "f36-margin-bottom--".concat(value['subheading']['spacing'])]),
          "data-test-id": testId
        }, otherProps), children);
      });
    }
  }]);

  return Subheading;
}(Component$1);
Subheading.displayName = "Subheading";

_defineProperty(Subheading, "propTypes", {
  element: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']).isRequired,
  className: propTypes.string,
  children: propTypes.node,
  testId: propTypes.string,
  style: propTypes.any
});

_defineProperty(Subheading, "defaultProps", defaultProps$11);

function _createSuper$14(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$14()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$14() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$R = {
  "SectionHeading": "SectionHeading__SectionHeading___39J6j"
};
var defaultProps$12 = {
  element: 'h3',
  testId: 'cf-ui-section-heading'
};
var SectionHeading = /*#__PURE__*/function (_Component) {
  _inherits(SectionHeading, _Component);

  var _super = _createSuper$14(SectionHeading);

  function SectionHeading() {
    _classCallCheck(this, SectionHeading);

    return _super.apply(this, arguments);
  }

  _createClass(SectionHeading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          element = _this$props.element,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "element"]);

      var classNames = classnames(styles$R['SectionHeading'], className);
      var Element = element;
      return /*#__PURE__*/React.createElement(TypographyContext.Consumer, null, function (value) {
        return /*#__PURE__*/React.createElement(Element, _extends({
          className: classnames(classNames, [value['sectionHeading'] && "f36-margin-bottom--".concat(value['sectionHeading']['spacing'])]),
          "data-test-id": testId
        }, otherProps), children);
      });
    }
  }]);

  return SectionHeading;
}(Component$1);
SectionHeading.displayName = "SectionHeading";

_defineProperty(SectionHeading, "propTypes", {
  element: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']).isRequired,
  className: propTypes.string,
  children: propTypes.oneOfType([propTypes.node, propTypes.string]),
  testId: propTypes.string,
  style: propTypes.any
});

_defineProperty(SectionHeading, "defaultProps", defaultProps$12);

function _createSuper$15(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$15()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$15() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$S = {
  "Paragraph": "Paragraph__Paragraph___2aO-9"
};
var defaultProps$13 = {
  element: 'p',
  testId: 'cf-ui-paragraph'
};
var Paragraph = /*#__PURE__*/function (_Component) {
  _inherits(Paragraph, _Component);

  var _super = _createSuper$15(Paragraph);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _super.apply(this, arguments);
  }

  _createClass(Paragraph, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          element = _this$props.element,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "element"]);

      var classNames = classnames(styles$S['Paragraph'], className);
      var Element = element;
      return /*#__PURE__*/React.createElement(TypographyContext.Consumer, null, function (value) {
        return /*#__PURE__*/React.createElement(Element, _extends({
          className: classnames(classNames, [value['paragraph'] && "f36-margin-bottom--".concat(value['paragraph']['spacing'])]),
          "data-test-id": testId
        }, otherProps), children);
      });
    }
  }]);

  return Paragraph;
}(Component$1);
Paragraph.displayName = "Paragraph";

_defineProperty(Paragraph, "propTypes", {
  element: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']).isRequired,
  className: propTypes.string,
  children: propTypes.node,
  testId: propTypes.string,
  style: propTypes.any
});

_defineProperty(Paragraph, "defaultProps", defaultProps$13);

function _createSuper$16(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$16()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$16() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$T = {
  "DisplayText": "DisplayText__DisplayText___172Lq",
  "DisplayText--default": "DisplayText__DisplayText--default___25iJC",
  "DisplayText--large": "DisplayText__DisplayText--large___2QHQE"
};
var defaultProps$14 = {
  element: 'h1',
  testId: 'cf-ui-display-text',
  size: 'default'
};
var DisplayText = /*#__PURE__*/function (_Component) {
  _inherits(DisplayText, _Component);

  var _super = _createSuper$16(DisplayText);

  function DisplayText() {
    _classCallCheck(this, DisplayText);

    return _super.apply(this, arguments);
  }

  _createClass(DisplayText, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          element = _this$props.element,
          size = _this$props.size,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "element", "size"]);

      var classNames = classnames(styles$T['DisplayText'], className, _defineProperty({}, styles$T["DisplayText--".concat(size)], size));
      var Element = element;
      return /*#__PURE__*/React.createElement(TypographyContext.Consumer, null, function (value) {
        var contextSize = size === 'large' ? value['displayTextLarge'] : value['displayText'];
        return /*#__PURE__*/React.createElement(Element, _extends({
          className: classnames(classNames, [contextSize && "f36-margin-bottom--".concat(contextSize.spacing)]),
          "data-test-id": testId
        }, otherProps), children);
      });
    }
  }]);

  return DisplayText;
}(Component$1);
DisplayText.displayName = "DisplayText";

_defineProperty(DisplayText, "propTypes", {
  element: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']).isRequired,
  size: propTypes.oneOf(['default', 'large']).isRequired,
  className: propTypes.string,
  children: propTypes.node,
  style: propTypes.any,
  testId: propTypes.string
});

_defineProperty(DisplayText, "defaultProps", defaultProps$14);

function _createSuper$17(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$17()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$17() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$U = {
  "List": "List__List___1YcFy"
};
var defaultProps$15 = {
  testId: 'cf-ui-list'
};
var List = /*#__PURE__*/function (_Component) {
  _inherits(List, _Component);

  var _super = _createSuper$17(List);

  function List() {
    _classCallCheck(this, List);

    return _super.apply(this, arguments);
  }

  _createClass(List, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      var classNames = classnames(styles$U['List'], className);
      return /*#__PURE__*/React.createElement("ul", _extends({}, otherProps, {
        className: classNames,
        "data-test-id": testId
      }), children);
    }
  }]);

  return List;
}(Component$1);
List.displayName = "List";

_defineProperty(List, "propTypes", {
  className: propTypes.string,
  children: propTypes.node.isRequired,
  style: propTypes.any,
  testId: propTypes.string
});

_defineProperty(List, "defaultProps", defaultProps$15);

function _createSuper$18(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$18()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$18() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$V = {
  "ListItem": "ListItem__ListItem___3S9Oc",
  "ListItem--nested-list": "ListItem__ListItem--nested-list___dzAem"
};
var defaultProps$16 = {
  testId: 'cf-ui-list-item'
};
var ListItem = /*#__PURE__*/function (_Component) {
  _inherits(ListItem, _Component);

  var _super = _createSuper$18(ListItem);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _super.apply(this, arguments);
  }

  _createClass(ListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      var classNames = classnames(styles$V['ListItem'], className, _defineProperty({}, styles$V['ListItem--nested-list'], // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.props.children.type === List));
      return /*#__PURE__*/React.createElement("li", _extends({
        className: classNames,
        "data-test-id": testId
      }, otherProps), children);
    }
  }]);

  return ListItem;
}(Component$1);
ListItem.displayName = "ListItem";

_defineProperty(ListItem, "propTypes", {
  className: propTypes.string,
  children: propTypes.node.isRequired,
  testId: propTypes.string
});

_defineProperty(ListItem, "defaultProps", defaultProps$16);

var SkeletonTableCell = function SkeletonTableCell() {
  return /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(SkeletonContainer, {
    svgHeight: 16 // This is equal to the default height of a SkeletonText line, if no value is passed the svg will be bigger than the line

  }, /*#__PURE__*/React.createElement(SkeletonBodyText, {
    numberOfLines: 1
  })));
};
SkeletonTableCell.displayName = "SkeletonTableCell";

var defaultProps$17 = {
  rowCount: 1,
  columnCount: 5
};
var SkeletonRow = function SkeletonRow(_ref) {
  var rowCount = _ref.rowCount,
      columnCount = _ref.columnCount;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array.from(Array(rowCount)).map(function (_, rowIndex) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: rowIndex
    }, Array.from(Array(columnCount)).map(function (_, cellIndex) {
      return /*#__PURE__*/React.createElement(SkeletonTableCell, {
        key: cellIndex
      });
    }));
  }));
};
SkeletonRow.displayName = "SkeletonRow";
SkeletonRow.propTypes = {
  rowCount: propTypes.number,
  columnCount: propTypes.number
};
SkeletonRow.defaultProps = defaultProps$17;

function _createSuper$19(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$19()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$19() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$W = {
  "Tabs": "Tabs__Tabs___3Cp8m",
  "Tab": "Tabs__Tab___1SiYI",
  "Tabs__with-divider": "Tabs__Tabs__with-divider___2Mx3Z",
  "Tab__selected": "Tabs__Tab__selected___3erbm",
  "Tab__disabled": "Tabs__Tab__disabled___3H8Zw"
};
var defaultProps$18 = {
  testId: 'cf-ui-tabs',
  role: 'tablist',
  withDivider: false
};
var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);

  var _super = _createSuper$19(Tabs);

  function Tabs() {
    _classCallCheck(this, Tabs);

    return _super.apply(this, arguments);
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          role = _this$props.role,
          withDivider = _this$props.withDivider,
          style = _this$props.style;
      var classNames = classnames(styles$W.Tabs, _defineProperty({}, styles$W['Tabs__with-divider'], withDivider), className);
      var elementProps = {
        'data-test-id': testId,
        className: classNames,
        style: style
      };

      if (role === 'navigation') {
        return /*#__PURE__*/React.createElement("nav", _extends({}, elementProps, {
          role: "navigation"
        }), children);
      }

      return /*#__PURE__*/React.createElement("div", _extends({}, elementProps, {
        role: "tablist"
      }), children);
    }
  }]);

  return Tabs;
}(Component$1);
Tabs.displayName = "Tabs";

_defineProperty(Tabs, "propTypes", {
  role: propTypes.oneOf(['navigation', 'tablist']),
  style: propTypes.any,
  className: propTypes.string,
  withDivider: propTypes.bool,
  children: propTypes.node,
  testId: propTypes.string
});

_defineProperty(Tabs, "defaultProps", defaultProps$18);

function _createSuper$1a(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$1a()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$X = {
  "Tabs": "Tabs__Tabs___3Cp8m",
  "Tab": "Tabs__Tab___1SiYI",
  "Tabs__with-divider": "Tabs__Tabs__with-divider___2Mx3Z",
  "Tab__selected": "Tabs__Tab__selected___3erbm",
  "Tab__disabled": "Tabs__Tab__disabled___3H8Zw"
};
var defaultProps$19 = {
  selected: false,
  disabled: false,
  testId: 'cf-ui-tab',
  tabIndex: 0
};
var Tab = /*#__PURE__*/function (_Component) {
  _inherits(Tab, _Component);

  var _super = _createSuper$1a(Tab);

  function Tab() {
    var _this;

    _classCallCheck(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      if (_this.props.onSelect && !_this.props.disabled) {
        _this.props.onSelect(_this.props.id, e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyPress", function (e) {
      if (_this.props.onSelect && e.key === 'Enter') {
        _this.props.onSelect(_this.props.id, e);

        e.preventDefault();
      }
    });

    return _this;
  }

  _createClass(Tab, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          id = _this$props.id,
          disabled = _this$props.disabled,
          className = _this$props.className,
          href = _this$props.href,
          style = _this$props.style,
          testId = _this$props.testId,
          selected = _this$props.selected,
          children = _this$props.children,
          tabIndex = _this$props.tabIndex;
      var elementProps = {
        className: classnames(styles$X.Tab, (_classNames = {}, _defineProperty(_classNames, styles$X['Tab__selected'], selected), _defineProperty(_classNames, styles$X['Tab__disabled'], disabled), _classNames), className),
        onClick: this.onClick,
        onKeyPress: this.onKeyPress,
        style: style,
        'data-test-id': testId,
        tabIndex: tabIndex
      };

      if (disabled) {
        elementProps['aria-disabled'] = true;
      }

      if (href) {
        elementProps['href'] = href;

        if (selected) {
          elementProps['aria-current'] = 'page';
        }

        return /*#__PURE__*/React.createElement("a", elementProps, children);
      } else {
        elementProps['aria-selected'] = selected;
        elementProps['role'] = 'tab';
        elementProps['aria-controls'] = id;
        return /*#__PURE__*/React.createElement("div", elementProps, children);
      }
    }
  }]);

  return Tab;
}(Component$1);
Tab.displayName = "Tab";

_defineProperty(Tab, "propTypes", {
  id: propTypes.string.isRequired,
  onSelect: propTypes.func,
  selected: propTypes.bool,
  href: propTypes.string,
  target: propTypes.string,
  disabled: propTypes.bool,
  tabIndex: propTypes.number,
  style: propTypes.any,
  className: propTypes.string,
  testId: propTypes.string,
  children: propTypes.node.isRequired
});

_defineProperty(Tab, "defaultProps", defaultProps$19);

function _createSuper$1b(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$1b()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var defaultProps$1a = {
  testId: 'cf-ui-tab-panel'
};
var TabPanel = /*#__PURE__*/function (_Component) {
  _inherits(TabPanel, _Component);

  var _super = _createSuper$1b(TabPanel);

  function TabPanel() {
    _classCallCheck(this, TabPanel);

    return _super.apply(this, arguments);
  }

  _createClass(TabPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          testId = _this$props.testId,
          className = _this$props.className,
          children = _this$props.children,
          id = _this$props.id,
          rest = _objectWithoutProperties(_this$props, ["testId", "className", "children", "id"]);

      return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
        id: id,
        role: "tabpanel",
        "data-test-id": testId,
        className: className
      }), children);
    }
  }]);

  return TabPanel;
}(Component$1);
TabPanel.displayName = "TabPanel";

_defineProperty(TabPanel, "propTypes", {
  id: propTypes.string.isRequired,
  className: propTypes.string,
  testId: propTypes.string,
  style: propTypes.any,
  children: propTypes.node.isRequired
});

_defineProperty(TabPanel, "defaultProps", defaultProps$1a);

function _createSuper$1c(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$1c()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$Y = {
  "EntityList": "EntityList__EntityList___foLpo"
};
var defaultProps$1b = {
  testId: 'cf-ui-entity-list'
};
var EntityList = /*#__PURE__*/function (_Component) {
  _inherits(EntityList, _Component);

  var _super = _createSuper$1c(EntityList);

  function EntityList() {
    _classCallCheck(this, EntityList);

    return _super.apply(this, arguments);
  }

  _createClass(EntityList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      var classNames = classnames(styles$Y.EntityList, className);
      return /*#__PURE__*/React.createElement("ul", _extends({}, otherProps, {
        className: classNames,
        "data-test-id": testId
      }), children);
    }
  }]);

  return EntityList;
}(Component$1);
EntityList.displayName = "EntityList";

_defineProperty(EntityList, "propTypes", {
  className: propTypes.string,
  children: propTypes.node,
  testId: propTypes.string
});

_defineProperty(EntityList, "defaultProps", defaultProps$1b);

function _createSuper$1d(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$1d()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$Z = {
  "EntityListItem": "EntityListItem__EntityListItem___29x4C",
  "EntityListItem--drag-active": "EntityListItem__EntityListItem--drag-active___1qF1k",
  "EntityListItem__focus-trap": "EntityListItem__EntityListItem__focus-trap___Hm8Et",
  "EntityListItem__inner": "EntityListItem__EntityListItem__inner___3sE6J a11y__focus-outline--default___2hwb1",
  "EntityListItem__media": "EntityListItem__EntityListItem__media___33gWs",
  "EntityListItem__thumbnail": "EntityListItem__EntityListItem__thumbnail___1fjhs",
  "EntityListItem__content": "EntityListItem__EntityListItem__content___y2dN5 helpers__truncate___3ZEQa",
  "EntityListItem__heading": "EntityListItem__EntityListItem__heading___133Tm",
  "EntityListItem__title": "EntityListItem__EntityListItem__title___5sclg helpers__truncate___3ZEQa",
  "EntityListItem__content-type": "EntityListItem__EntityListItem__content-type___CoCul helpers__truncate___3ZEQa",
  "EntityListItem__description": "EntityListItem__EntityListItem__description___-sYiZ helpers__truncate___3ZEQa",
  "EntityListItem__meta": "EntityListItem__EntityListItem__meta___3xi8M",
  "EntityListItem__status": "EntityListItem__EntityListItem__status___8aOEj",
  "EntityListItem__actions": "EntityListItem__EntityListItem__actions___1BF6s"
};
var defaultProps$1c = {
  testId: 'cf-ui-entity-list-item',
  entityType: 'entry',
  isActionsDisabled: false
};
var EntityListItem = /*#__PURE__*/function (_Component) {
  _inherits(EntityListItem, _Component);

  var _super = _createSuper$1d(EntityListItem);

  function EntityListItem() {
    var _this;

    _classCallCheck(this, EntityListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderStatus", function (status) {
      var label;
      var type;

      switch (status) {
        case 'archived':
          label = 'archived';
          type = 'negative';
          break;

        case 'changed':
          label = 'changed';
          type = 'primary';
          break;

        case 'published':
          label = 'published';
          type = 'positive';
          break;

        default:
          label = 'draft';
          type = 'warning';
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles$Z['EntityListItem__status']
      }, /*#__PURE__*/React.createElement(Tag, {
        tagType: type
      }, label));
    });

    return _this;
  }

  _createClass(EntityListItem, [{
    key: "renderIcon",
    value: function renderIcon() {
      var entityType = this.props.entityType;
      var isAsset = entityType && entityType.toLowerCase() === 'asset';
      var icon = isAsset ? 'Asset' : 'Entry';
      return /*#__PURE__*/React.createElement(Icon, {
        icon: icon,
        color: "muted"
      });
    }
  }, {
    key: "renderThumbnail",
    value: function renderThumbnail() {
      return /*#__PURE__*/React.createElement("img", {
        src: this.props.thumbnailUrl,
        className: styles$Z['EntityListItem__thumbnail'],
        alt: this.props.thumbnailAltText
      });
    }
  }, {
    key: "renderLoadingCard",
    value: function renderLoadingCard() {
      return /*#__PURE__*/React.createElement("article", {
        className: styles$Z['EntityListItem__inner']
      }, /*#__PURE__*/React.createElement(SkeletonContainer, {
        clipId: "f36-entity-list-item-skeleton"
      }, /*#__PURE__*/React.createElement(SkeletonImage, {
        height: 46,
        width: 46
      }), /*#__PURE__*/React.createElement(SkeletonBodyText, {
        numberOfLines: 2,
        lineHeight: 18,
        offsetLeft: 54
      })));
    }
  }, {
    key: "renderCardDragHandle",
    value: function renderCardDragHandle() {
      var _this$props = this.props,
          cardDragHandleComponent = _this$props.cardDragHandleComponent,
          isDragActive = _this$props.isDragActive,
          cardDragHandleProps = _this$props.cardDragHandleProps,
          withDragHandle = _this$props.withDragHandle;

      if (cardDragHandleComponent) {
        return cardDragHandleComponent;
      } else if (withDragHandle) {
        return /*#__PURE__*/React.createElement(CardDragHandle, _extends({
          isDragActive: isDragActive
        }, cardDragHandleProps), "Reorder entry");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cn;

      var _this$props2 = this.props,
          className = _this$props2.className,
          testId = _this$props2.testId,
          title = _this$props2.title,
          description = _this$props2.description,
          contentType = _this$props2.contentType,
          entityType = _this$props2.entityType,
          thumbnailUrl = _this$props2.thumbnailUrl,
          thumbnailAltText = _this$props2.thumbnailAltText,
          status = _this$props2.status,
          dropdownListElements = _this$props2.dropdownListElements,
          withDragHandle = _this$props2.withDragHandle,
          isDragActive = _this$props2.isDragActive,
          isLoading = _this$props2.isLoading,
          onClick = _this$props2.onClick,
          href = _this$props2.href,
          cardDragHandleProps = _this$props2.cardDragHandleProps,
          cardDragHandleComponent = _this$props2.cardDragHandleComponent,
          isActionsDisabled = _this$props2.isActionsDisabled,
          otherProps = _objectWithoutProperties(_this$props2, ["className", "testId", "title", "description", "contentType", "entityType", "thumbnailUrl", "thumbnailAltText", "status", "dropdownListElements", "withDragHandle", "isDragActive", "isLoading", "onClick", "href", "cardDragHandleProps", "cardDragHandleComponent", "isActionsDisabled"]);

      var classNames = classnames(styles$Z.EntityListItem, className, (_cn = {}, _defineProperty(_cn, styles$Z['EntityListItem--drag-active'], isDragActive), _defineProperty(_cn, styles$Z['EntityListItem--is-interactive'], onClick || href), _cn));
      var Element = onClick ? 'a' : 'article'; // archived assets will not be available on the CDN, resulting in a broken image src

      var isArchived = status === 'archived';
      var asIcon = isArchived || !thumbnailUrl;
      return /*#__PURE__*/React.createElement("li", _extends({}, otherProps, {
        className: classNames,
        "data-test-id": testId
      }), this.renderCardDragHandle(), isLoading ? this.renderLoadingCard() : /*#__PURE__*/React.createElement(Element, {
        className: styles$Z['EntityListItem__inner'],
        onClick: onClick,
        href: href,
        tabIndex: onClick && 0,
        target: onClick && href ? '_blank' : undefined
      }, /*#__PURE__*/React.createElement(TabFocusTrap, {
        className: styles$Z['EntityListItem__focus-trap']
      }, /*#__PURE__*/React.createElement("figure", {
        className: styles$Z['EntityListItem__media']
      }, asIcon ? this.renderIcon() : this.renderThumbnail()), /*#__PURE__*/React.createElement("div", {
        className: styles$Z['EntityListItem__content']
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$Z['EntityListItem__heading']
      }, /*#__PURE__*/React.createElement("h1", {
        className: styles$Z['EntityListItem__title']
      }, title), contentType && /*#__PURE__*/React.createElement("div", {
        className: styles$Z['EntityListItem__content-type']
      }, "(", contentType, ")")), description && /*#__PURE__*/React.createElement("p", {
        className: styles$Z['EntityListItem__description']
      }, description)), /*#__PURE__*/React.createElement("div", {
        className: styles$Z['EntityListItem__meta']
      }, status && this.renderStatus(status), dropdownListElements && /*#__PURE__*/React.createElement(CardActions, {
        className: styles$Z['EntityListItem__actions'],
        isDisabled: isActionsDisabled,
        iconButtonProps: {
          onClick: function onClick(e) {
            return e.stopPropagation;
          }
        }
      }, dropdownListElements)))));
    }
  }]);

  return EntityListItem;
}(Component$1);
EntityListItem.displayName = "EntityListItem";

_defineProperty(EntityListItem, "propTypes", {
  title: propTypes.string.isRequired,
  description: propTypes.string,
  contentType: propTypes.string,
  status: propTypes.oneOf(['archived', 'changed', 'draft', 'published']),
  thumbnailUrl: propTypes.string,
  thumbnailAltText: propTypes.string,
  dropdownListElements: propTypes.element,
  withDragHandle: propTypes.bool,
  isDragActive: propTypes.bool,
  cardDragHandleComponent: propTypes.node,
  cardDragHandleProps: propTypes.any,
  entityType: propTypes.oneOf(['Entry', 'Asset', 'entry', 'asset']),
  isLoading: propTypes.bool,
  onClick: propTypes.func,
  href: propTypes.string,
  className: propTypes.string,
  testId: propTypes.string,
  isActionsDisabled: propTypes.bool
});

_defineProperty(EntityListItem, "defaultProps", defaultProps$1c);

function _createSuper$1e(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$1e()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$_ = {
  "EmptyState": "EmptyState__EmptyState___35Xbk",
  "EmptyState_container": "EmptyState__EmptyState_container___34eoG",
  "EmptyState_illustration": "EmptyState__EmptyState_illustration___3KEC9",
  "EmptyState_element": "EmptyState__EmptyState_element___1cYfd",
  "EmptyState_paragraph": "EmptyState__EmptyState_paragraph___KTUQq"
};
var defaultProps$1d = {
  testId: 'cf-ui-empty-state'
};
var EmptyState = /*#__PURE__*/function (_Component) {
  _inherits(EmptyState, _Component);

  var _super = _createSuper$1e(EmptyState);

  function EmptyState() {
    _classCallCheck(this, EmptyState);

    return _super.apply(this, arguments);
  }

  _createClass(EmptyState, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          customImageElement = _this$props.customImageElement,
          imageProps = _this$props.imageProps,
          headingProps = _this$props.headingProps,
          descriptionProps = _this$props.descriptionProps,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId", "customImageElement", "imageProps", "headingProps", "descriptionProps"]);

      var classNames = classnames(styles$_.EmptyState, className);
      return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
        className: classNames,
        "data-test-id": testId
      }), /*#__PURE__*/React.createElement("div", {
        className: styles$_['EmptyState_container']
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$_['EmptyState_element']
      }, customImageElement ? customImageElement : imageProps && /*#__PURE__*/React.createElement("img", {
        src: imageProps.url,
        alt: imageProps.description,
        className: classnames(imageProps.className, styles$_['EmptyState_illustration']),
        style: {
          height: imageProps.height,
          width: imageProps.width
        }
      })), /*#__PURE__*/React.createElement(Heading$1, {
        element: headingProps.elementType ? headingProps.elementType : 'h1',
        className: styles$_['EmptyState_element']
      }, headingProps.text), /*#__PURE__*/React.createElement(Paragraph, {
        element: descriptionProps.elementType ? descriptionProps.elementType : 'p',
        className: classnames(styles$_['EmptyState_paragraph'], styles$_['EmptyState_element'])
      }, descriptionProps.text), children));
    }
  }]);

  return EmptyState;
}(Component$1);
EmptyState.displayName = "EmptyState";

_defineProperty(EmptyState, "propTypes", {
  className: propTypes.string,
  children: propTypes.node,
  testId: propTypes.string,
  imageProps: propTypes.shape({
    url: propTypes.string.isRequired,
    width: propTypes.string.isRequired,
    height: propTypes.string.isRequired,
    description: propTypes.string.isRequired,
    className: propTypes.string
  }),
  customImageElement: propTypes.element,
  headingProps: propTypes.shape({
    text: propTypes.node.isRequired,
    elementType: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'])
  }).isRequired,
  descriptionProps: propTypes.shape({
    text: propTypes.node.isRequired,
    elementType: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'])
  }).isRequired
});

_defineProperty(EmptyState, "defaultProps", defaultProps$1d);

var styles$$ = {
  "Switch__wrapper": "Switch__Switch__wrapper___1kkJg",
  "Switch": "Switch__Switch___bJH7R",
  "Switch--checked": "Switch__Switch--checked___3CVQe",
  "Switch--disabled": "Switch__Switch--disabled___4AE9X",
  "Switch__label": "Switch__Switch__label___2S5bb",
  "Switch__label--disabled": "Switch__Switch__label--disabled___2C2Sn"
};
var Switch = function Switch(props) {
  var _classNames;

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$$['Switch__wrapper'], props.className)
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onClick: onToggle,
    onKeyUp: onKeyUp,
    defaultChecked: props.isChecked,
    disabled: props.isDisabled,
    className: classnames(styles$$['Switch'], (_classNames = {}, _defineProperty(_classNames, styles$$['Switch--checked'], props.isChecked), _defineProperty(_classNames, styles$$['Switch--disabled'], props.isDisabled), _classNames)),
    id: props.id
  }), /*#__PURE__*/React.createElement(FormLabel, {
    className: classnames(styles$$['Switch__label'], _defineProperty({}, styles$$['Switch__label--disabled'], props.isDisabled)),
    htmlFor: props.id
  }, props.labelText));

  function onToggle() {
    if (props.onToggle) {
      props.onToggle(!props.isChecked);
    }
  }

  function onKeyUp(e) {
    if (props.onToggle && e.key === 'Enter') {
      props.onToggle(!props.isChecked);
    }
  }
};
Switch.propTypes = {
  onToggle: propTypes.func,
  isChecked: propTypes.bool,
  isDisabled: propTypes.bool,
  labelText: propTypes.string.isRequired,
  className: propTypes.string,
  id: propTypes.string.isRequired
};

function _createSuper$1f(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct$1f()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var styles$10 = {
  "Workbench": "Workbench__Workbench___THi9K",
  "Workbench__header": "Workbench__Workbench__header___2wo2E",
  "Workbench__header-back": "Workbench__Workbench__header-back___3qZkM",
  "Workbench__header-back-button": "Workbench__Workbench__header-back-button___1G3-G",
  "Workbench__header-icon": "Workbench__Workbench__header-icon___1kJlL",
  "Workbench__header-title": "Workbench__Workbench__header-title___3xp7b",
  "Workbench__header-title__heading": "Workbench__Workbench__header-title__heading___1Pe5h",
  "Workbench__header-description": "Workbench__Workbench__header-description___1LHbc",
  "Workbench__header-description__text": "Workbench__Workbench__header-description__text___2xjBG",
  "Workbench__header-actions": "Workbench__Workbench__header-actions___mJoSR",
  "Workbench__content-wrapper": "Workbench__Workbench__content-wrapper___3yWKi",
  "Workbench__content": "Workbench__Workbench__content___1U8bV",
  "Workbench__content-inner": "Workbench__Workbench__content-inner___36_Hx",
  "Workbench__content-inner--default": "Workbench__Workbench__content-inner--default___2wRXn",
  "Workbench__content-inner--text": "Workbench__Workbench__content-inner--text___7nfTX",
  "Workbench__content-inner--full": "Workbench__Workbench__content-inner--full___3eP1v",
  "Workbench__sidebar": "Workbench__Workbench__sidebar___3i7n0",
  "Workbench__sidebar--left": "Workbench__Workbench__sidebar--left___67OKM",
  "Workbench__sidebar--right": "Workbench__Workbench__sidebar--right___3f4XO"
};
function WorkbenchHeader(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$10['Workbench__header'], props.className),
    "data-test-id": props.testId
  }, props.onBack ? /*#__PURE__*/React.createElement("div", {
    className: styles$10['Workbench__header-back']
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick() {
      if (typeof props.onBack === 'function') {
        props.onBack();
      }
    },
    testId: "workbench-back-btn",
    className: styles$10['Workbench__header-back-button'],
    label: "Back",
    buttonType: "muted",
    iconProps: {
      size: 'large',
      icon: 'ChevronLeft'
    }
  })) : null, props.icon ? /*#__PURE__*/React.createElement("div", {
    className: styles$10['Workbench__header-icon']
  }, props.icon) : null, props.title && /*#__PURE__*/React.createElement("div", {
    "data-test-id": "workbench-title",
    className: styles$10['Workbench__header-title']
  }, typeof props.title === 'string' ? /*#__PURE__*/React.createElement(Heading$1, {
    className: styles$10['Workbench__header-title__heading']
  }, props.title) : props.title), props.description && /*#__PURE__*/React.createElement("div", {
    "data-test-id": "workbench-description",
    className: styles$10['Workbench__header-description']
  }, typeof props.description === 'string' ? /*#__PURE__*/React.createElement("span", {
    className: styles$10['Workbench__header-description__text']
  }, props.description) : props.description), props.actions ? /*#__PURE__*/React.createElement("div", {
    className: styles$10['Workbench__header-actions']
  }, props.actions) : null);
}
WorkbenchHeader.displayName = "WorkbenchHeader";
WorkbenchHeader.propTypes = {
  title: propTypes.oneOfType([propTypes.element, propTypes.string]),
  description: propTypes.oneOfType([propTypes.element, propTypes.string]),
  icon: propTypes.element,
  actions: propTypes.element,
  onBack: propTypes.any,
  className: propTypes.string,
  testId: propTypes.string
};
WorkbenchHeader.defaultProps = {
  testId: 'cf-ui-workbench-header'
};
WorkbenchHeader.displayName = 'WorkbenchHeader';
function WorkbenchSidebar(props) {
  var _cn;

  return /*#__PURE__*/React.createElement("div", {
    "data-test-id": "".concat(props.testId).concat(props.position ? "-".concat(props.position) : ''),
    className: classnames(styles$10['Workbench__sidebar'], (_cn = {}, _defineProperty(_cn, styles$10['Workbench__sidebar--right'], props.position === 'right'), _defineProperty(_cn, styles$10['Workbench__sidebar--left'], props.position === 'left'), _cn), props.className)
  }, props.children);
}
WorkbenchSidebar.displayName = "WorkbenchSidebar";
WorkbenchSidebar.propTypes = {
  children: propTypes.node.isRequired,
  className: propTypes.string,
  position: propTypes.oneOf(['left', 'right']),
  testId: propTypes.string
};
WorkbenchSidebar.defaultProps = {
  testId: 'cf-ui-workbench-sidebar'
};
function WorkbenchContent(props) {
  var _cn2;

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$10['Workbench__content'], props.className),
    "data-test-id": props.testId
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles$10['Workbench__content-inner'], (_cn2 = {}, _defineProperty(_cn2, styles$10['Workbench__content-inner--default'], props.type === 'default'), _defineProperty(_cn2, styles$10['Workbench__content-inner--text'], props.type === 'text'), _defineProperty(_cn2, styles$10['Workbench__content-inner--full'], props.type === 'full'), _cn2))
  }, props.children));
}
WorkbenchContent.displayName = "WorkbenchContent";
WorkbenchContent.propTypes = {
  children: propTypes.node.isRequired,
  type: propTypes.oneOf(['default', 'text', 'full']),
  className: propTypes.string,
  testId: propTypes.string
};
WorkbenchContent.defaultProps = {
  type: 'default',
  testId: 'cf-ui-workbench-content'
};
var defaultProps$1e = {
  testId: 'cf-ui-workbench'
};
var Workbench = /*#__PURE__*/function (_Component) {
  _inherits(Workbench, _Component);

  var _super = _createSuper$1f(Workbench);

  function Workbench() {
    _classCallCheck(this, Workbench);

    return _super.apply(this, arguments);
  }

  _createClass(Workbench, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          testId = _this$props.testId,
          otherProps = _objectWithoutProperties(_this$props, ["className", "children", "testId"]);

      var childrenArray = React.Children.toArray(children);
      var header = [];
      var other = [];
      childrenArray.forEach( // eslint-disable-next-line
      function (item) {
        if (item && item.type && item.type.displayName === 'WorkbenchHeader') {
          header.push(item);
        } else {
          other.push(item);
        }
      });
      var classNames = classnames(styles$10.Workbench, className);
      return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
        className: classNames,
        "data-test-id": testId
      }), header, /*#__PURE__*/React.createElement("div", {
        className: styles$10['Workbench__content-wrapper']
      }, other));
    }
  }]);

  return Workbench;
}(Component$1);
Workbench.displayName = "Workbench";

_defineProperty(Workbench, "propTypes", {
  className: propTypes.string,
  children: propTypes.node,
  testId: propTypes.string
});

_defineProperty(Workbench, "defaultProps", defaultProps$1e);

_defineProperty(Workbench, "Header", WorkbenchHeader);

_defineProperty(Workbench, "Content", WorkbenchContent);

_defineProperty(Workbench, "Sidebar", WorkbenchSidebar);

export { Asset$1 as Asset, AssetCard, Button, Card, CardActions, CardDragHandle, Checkbox, CheckboxField, ControlledInput, ControlledInputField, CopyButton, DisplayText, Dropdown, DropdownList, DropdownListItem, EditorToolbar, EditorToolbarButton, EditorToolbarDivider, EmptyState, EntityList, EntityListItem, EntryCard, FieldGroup, Form, FormLabel, Heading$1 as Heading, HelpText, Icon, IconButton, Illustration, InViewport, InlineEntryCard, List, ListItem, Modal, ModalConfirm, Note, Notification, Option, Paragraph, Pill, RadioButton, RadioButtonField, SectionHeading, Select, SelectField, SkeletonBodyText, SkeletonContainer, SkeletonDisplayText, SkeletonImage, SkeletonRow, SkeletonTableCell, SkeletonText, Spinner, Subheading, Switch, Tab, TabFocusTrap, TabPanel, Table, TableBody, TableCell, TableHead, TableRow, Tabs, Tag, TextField, TextInput, TextLink, Textarea, ToggleButton, Tooltip, Typography, ValidationMessage, Workbench };
